<template>
  <div>
    <div class="fixed-top-bar d-flex align-center">
      <v-row>
        <v-col cols="10">
          <!-- <span>
            <v-btn icon dark disabled>
              <v-icon size="28px">mdi-arrow-left-bold-box-outline</v-icon>
                 <span class="lable_class"></span>
            </v-btn>
          </span>-->
          <span class="ml-7">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  small
                  dark
                  v-bind="attrs"
                  v-on="on"
                  @click="import_dailog = true"
                  class="header_btn"
                  :disabled="selectedRows.length > 0 || pagination.filters.generate_invoice"
                >
                  <v-icon size="28px">mdi-import</v-icon>
                  <span class="lable_class">Import</span>
                </v-btn>
              </template>
              <span>Import Transactions</span>
            </v-tooltip>
            <!-- {{hasInvoices.length}} -->
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  @click="opendEditPopup()"
                  icon
                  dark
                  v-bind="attrs"
                  v-on="on"
                  :disabled="hasInvoices.length > 0 || pagination.filters.generate_invoice || selectedRows.length == 0 || pagination.filters.filter_by == '12' || open_doc_model_falg || open_log_model_falg"
                  class="ml-4 header_btn"
                >
                  <v-icon size="28px">mdi-pencil-box-multiple-outline</v-icon>
                  <span class="lable_class">Edit</span>
                </v-btn>
              </template>
              <span>Edit Selected Type, Project, Vendor and Item</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon dark v-bind="attrs" v-on="on" disabled class="ml-4 header_btn">
                  <v-icon size="28px">mdi-eye-outline</v-icon>
                  <span class="lable_class">View</span>
                </v-btn>
              </template>
              <span>View</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  icon
                  small
                  dark
                  @click="delete_dialog = true"
                  class="ml-5 header_btn"
                  :disabled="
                    pagination.filters.generate_invoice || 
                    selectedRows.length == 0 ||
                    hasInvoices.length > 0 ||
                    hasParentAssign.length > 0 ||
                    hasChilds.length > 0 || 
                    pagination.filters.filter_by == '12' || 
                    open_doc_model_falg || 
                    open_log_model_falg
                  "
                >
                  <v-icon size="28px">mdi-delete-outline</v-icon>
                  <span class="lable_class">Delete</span>
                </v-btn>
              </template>
              <span>Delete Transaction</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  icon
                  small
                  dark
                  @click="misc_delete_dialog = true"
                  class="ml-5 header_btn"
                  :disabled="
                    pagination.filters.generate_invoice || 
                    selectedRows.length == 0  
                    || pagination.filters.f_project ==''  || selectProjectIsMisc != 'retail_sales' ||
                    open_doc_model_falg || 
                    open_log_model_falg
                  "
                >
                  <v-icon size="28px">mdi-delete-outline</v-icon>
                  <span class="lable_class">Delete</span>
                </v-btn>
              </template>
              <span>Delete Assign</span>
            </v-tooltip>
          </span>
          <span class="ml-7">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  icon
                  small
                  dark
                  class="ml-7 header_btn"
                  @click="addAsMainTransaction()"
                  :disabled="(pagination.filters.filter_by != '9' && pagination.filters.filter_by != '10' && pagination.filters.filter_by != '11' && pagination.filters.filter_by != '12') || selectedRows.length == 0 || pagination.filters.generate_invoice || open_doc_model_falg || open_log_model_falg"
                >
                  <v-icon size="28px">mdi-plus-circle-outline</v-icon>
                  <span class="lable_class">Add</span>
                </v-btn>
              </template>
              <span>Add In Main Transaction</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  icon
                  small
                  class="ml-4 header_btn"
                  dark
                  @click="splitTransaction()"
                  :disabled="hasInvoices.length > 0 || pagination.filters.generate_invoice || selectedRows.length != 1 || pagination.filters.filter_by == '9' || pagination.filters.filter_by == '10' || pagination.filters.filter_by == '11' || pagination.filters.filter_by == '12' || open_doc_model_falg || open_log_model_falg"
                >
                  <v-icon size="28px">mdi-arrow-split-vertical</v-icon>
                  <span class="lable_class">Split</span>
                </v-btn>
              </template>
              <span>Split Transaction</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  icon
                  small
                  dark
                  class="ml-7 header_btn"
                  @click="addProjectVendor()"
                  :disabled="pagination.filters.generate_invoice || open_doc_model_falg || open_log_model_falg"
                >
                  <v-icon size="28px">mdi-update</v-icon>
                  <span class="lable_class">Update</span>
                </v-btn>
              </template>
              <span>Auto fill project and vendor as per keywords</span>
            </v-tooltip>

            <!-- <v-menu bottom offset-y :close-on-content-click="false" v-model="search_menu">
              <template v-slot:activator="{ on, attrs }">
                <v-btn :disabled="pagination.filters.generate_invoice || open_doc_model_falg || open_log_model_falg" icon small dark v-bind="attrs" v-on="on" class="ml-1">
                  <v-badge overlap dot :value="search" color="error">
                    <v-icon size="28px">mdi-magnify</v-icon>
                  </v-badge>
                </v-btn>
              </template>
              <v-card tile width="400">
                <v-row no-gutters>
                  <v-col cols="12">
                    <v-text-field
                      v-model="search"
                      append-icon="mdi-magnify"
                      label="Search"
                      single-line
                      hide-details
                      dense
                      solo
                      clearable
                      aria-autocomplete="false"
                      autocomplete="off"
                      autofocus
                      v-on:keyup.enter="search_menu = false"
                      v-debounce:500="getTransaction"
                      @click:clear="search = null; getTransaction()"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-card>
            </v-menu>-->

            <v-menu
              bottom
              v-model="filter_menu"
              :close-on-content-click="false"
              content-class="elevation-0"
              v-if="pagination.filters.generate_invoice"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn dark icon v-bind="attrs" v-on="on" class="ml-7 header_btn">
                  <v-icon size="22px">mdi-filter-outline</v-icon>
                  <span class="lable_class">Filter</span>
                </v-btn>
              </template>

              <v-card tile max-width="400" class="mb-5 mr-5">
                <v-list class="filter-section-border">
                  <v-list-item>
                    <v-autocomplete
                      dense
                      flat
                      :items="project_work"
                      outlined
                      label="Project Type"
                      hide-details
                      small
                      class="body-2"
                      placeholder="All"
                      clearable
                      :disabled="pagination.filters.generated_inv_id!=''"
                      @click:clear="pagination.itemsPerPage =25;"
                      @change="pagination.itemsPerPage =25;pagination.filters.generate_invoice_project = ''"
                      v-model="pagination.filters.generate_invoice_project_work"
                    ></v-autocomplete>
                  </v-list-item>
                  <v-list-item>
                    <v-col cols="6" class="pl-0">
                      <v-autocomplete
                        dense
                        flat
                        :items="status"
                        outlined
                        label="Status"
                        hide-details
                        x-small
                        class="body-2"
                        placeholder=" "
                        v-model="pagination.filters.f_project_status"
                        @change="pagination.itemsPerPage=25;"
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="6" class="pa-0">
                      <v-autocomplete
                        dense
                        flat
                        :items="project_list_filter"
                        outlined
                        label="Project"
                        hide-details
                        small
                        class="body-2"
                        placeholder="All"
                        clearable
                        :disabled="pagination.filters.generated_inv_id!=''"
                        v-model="pagination.filters.generate_invoice_project"
                        @click:clear="pagination.itemsPerPage =25;last_select_transaction = '';"
                        @change="pagination.itemsPerPage =25;getinvoices();"
                      ></v-autocomplete>
                    </v-col>
                  </v-list-item>
                  <v-list-item>
                    <v-autocomplete
                      dense
                      flat
                      :items="expence_list_filter"
                      outlined
                      label="Vendor"
                      hide-details
                      small
                      class="body-2 focus-on-vendor-expence"
                      placeholder="All"
                      clearable
                      @click:clear="pagination.itemsPerPage =25;vendor_date = null;"
                      @change="pagination.itemsPerPage =25;"
                      v-model="pagination.filters.generate_invoice_vendor"
                      v-if="expence_filter_flag"
                    >
                      <template v-slot:prepend-item>
                        <a
                          class="pl-4"
                          @click="expence_filter_flag = false; setFocus('focus-on-vendor-expence');"
                        >Select Vendor</a>
                        <v-divider></v-divider>
                      </template>
                    </v-autocomplete>

                    <v-autocomplete
                      dense
                      flat
                      :items="vendor_list_filter"
                      outlined
                      label="Vendor"
                      hide-details
                      small
                      class="body-2 focus-on-vendor-expence"
                      placeholder="All"
                      clearable
                      @click:clear="pagination.itemsPerPage =25;vendor_date = null;"
                      @change="pagination.itemsPerPage =25;"
                      v-model="pagination.filters.generate_invoice_vendor"
                      v-else
                    >
                      <template v-slot:prepend-item>
                        <a
                          class="pl-4"
                          @click="expence_filter_flag = true; setFocus('focus-on-vendor-expence');"
                        >Select Chart of Account</a>
                        <v-divider></v-divider>
                      </template>
                    </v-autocomplete>
                  </v-list-item>
                  <v-list-item>
                    <v-autocomplete
                      dense
                      flat
                      :items="group_list_filter"
                      outlined
                      label="Group"
                      hide-details
                      small
                      class="body-2"
                      placeholder="All"
                      clearable
                      v-model="pagination.filters.generate_invoice_group"
                      @click:clear="pagination.itemsPerPage =25;last_select_transaction = '';pagination.filters.generate_invoice_group = '';"
                      @change="pagination.itemsPerPage =25;getinvoices()"
                    ></v-autocomplete>
                  </v-list-item>
                  <v-list-item>
                    <v-autocomplete
                      dense
                      flat
                      :items="date_filter"
                      outlined
                      label="Date Filter"
                      hide-details
                      class="body-2 date-filter-height"
                      placeholder="All"
                      v-model="pagination.filters.date_filter"
                      clearable
                      :menu-props="{
                            maxHeight : 340
                          }"
                      @change="pagination.itemsPerPage=25;"
                      @click:clear="pagination.itemsPerPage=25;"
                    ></v-autocomplete>
                  </v-list-item>
                  <v-list-item v-if="pagination.filters.date_filter == '8'">
                    <v-menu
                      v-model="tran_start_date"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="pagination.filters.tran_start_date"
                          label="Start Date"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          dense
                          placeholder=" "
                          hide-details
                          outlined
                          clearable
                          @click:clear="disable_dates = null"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="dateFormatted"
                        @input="tran_start_date = false; parseDate('tran_start_date')"
                        no-title
                        scrollable
                      ></v-date-picker>
                    </v-menu>

                    <v-menu
                      v-model="tran_end_date"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="pagination.filters.tran_end_date"
                          label="End Date"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          dense
                          placeholder=" "
                          hide-details
                          outlined
                          clearable
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="dateFormatted"
                        @input="tran_end_date = false; parseDate('tran_end_date')"
                        no-title
                        scrollable
                        :min="disable_dates"
                      ></v-date-picker>
                    </v-menu>
                  </v-list-item>
                </v-list>
                <v-card-title class="pa-0">
                  <v-btn
                    fab
                    color="error"
                    x-small
                    absolute
                    @click="filter_menu = false"
                    class="custom-close-btn"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-card-title>
              </v-card>
            </v-menu>

            <v-menu
              bottom
              v-model="filter_menu"
              :close-on-content-click="false"
              :close-on-click="loading? false : true"
              persistent
              content-class="elevation-0"
              v-else
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :disabled="pagination.filters.generate_invoice || open_doc_model_falg || open_log_model_falg"
                  dark
                  icon
                  v-bind="attrs"
                  v-on="on"
                  class="ml-7 header_btn"
                >
                  <v-badge
                    :content="filtersCount"
                    :value="filtersCount"
                    color="error"
                    overlap
                    size="15"
                  >
                    <v-icon size="22px">mdi-filter-menu-outline</v-icon>
                  </v-badge>
                  <span class="lable_class">Filter</span>
                </v-btn>
              </template>
              <v-card tile max-width="600" class="mb-5 mr-5">
                <v-list class="filter-section-border">
                  <v-subheader v-if="pagination.filters.filter_by != 6">
                    <v-row dense>
                      <v-col cols="3" style="max-width: 22%;">
                        <v-autocomplete
                          dense
                          flat
                          :items="status"
                          outlined
                          label="Status"
                          hide-details
                          x-small
                          class="body-2"
                          placeholder=" "
                          v-model="pagination.filters.bank_status"
                          @change="pagination.itemsPerPage=25;"
                        ></v-autocomplete>
                      </v-col>
                      <v-col>
                        <v-autocomplete
                          dense
                          flat
                          :items="bank_filter"
                          outlined
                          label="All Bank"
                          @click:clear="bank_date = null;pagination.filters.bank='';pagination.itemsPerPage=25;"
                          hide-details
                          x-small
                          @change="pagination.itemsPerPage=25;getLockDate('bank');pagination.filters.date_filter='5';pagination.filters.bank_status='1';pagination.filters.f_project_status='';pagination.filters.f_vendor_status='';pagination.filters.f_group_status='1';"
                          class="body-2"
                          placeholder="All"
                          clearable
                          v-model="pagination.filters.bank"
                        ></v-autocomplete>
                      </v-col>
                      <v-col cols="1" class="d-flex align-center" style="max-width: 6%;">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              v-bind="attrs"
                              :disabled="!pagination.filters.bank"
                              @click="bank_lock_enable = !bank_lock_enable"
                              :color="(bank_lock_enable)?'primary':''"
                              v-on="on"
                              size="28"
                            >mdi-lock-outline</v-icon>
                          </template>
                          <span>Lock transaction by bank & date</span>
                        </v-tooltip>
                      </v-col>
                      <v-col cols="4" style="max-width: 26%;">
                        <v-menu
                          v-model="bank_lock_date"
                          :close-on-content-click="false"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="bank_date"
                              label="Bank"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                              :disabled="!bank_lock_enable || !pagination.filters.bank"
                              dense
                              placeholder=" "
                              @click:clear="dateFormatted = null; changeLockDate('bank',pagination.filters.bank)"
                              hide-details
                              outlined
                              clearable
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="dateFormatted"
                            @input="bank_lock_date = false; changeLockDate('bank',pagination.filters.bank)"
                            no-title
                            scrollable
                          ></v-date-picker>
                        </v-menu>
                      </v-col>
                    </v-row>
                  </v-subheader>
                  <v-subheader :class="(pagination.filters.filter_by == 6)?'mt-2':''">
                    <v-row dense>
                      <v-col>
                        <v-autocomplete
                          dense
                          flat
                          :items="date_filter"
                          outlined
                          label="Date Filter"
                          hide-details
                          class="body-2 date-filter-height"
                          placeholder="All"
                          v-model="pagination.filters.date_filter"
                          clearable
                          :menu-props="{
                            maxHeight : 340
                          }"
                          @change="pagination.itemsPerPage=25;"
                          @click:clear="pagination.itemsPerPage=25;"
                        ></v-autocomplete>
                      </v-col>
                      <v-col cols="1" class="d-flex align-center" style="max-width: 6%;">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              v-bind="attrs"
                              @click="general_lock_enable = !general_lock_enable"
                              :color="(general_lock_enable)?'primary':''"
                              v-on="on"
                              size="28"
                            >mdi-lock-outline</v-icon>
                          </template>
                          <span>Lock transaction by date</span>
                        </v-tooltip>
                      </v-col>
                      <v-col cols="4" style="max-width: 26%;">
                        <v-menu
                          v-model="general_lock_date"
                          :close-on-content-click="false"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="general_date"
                              label="Date"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                              dense
                              placeholder=" "
                              hide-details
                              :disabled="!general_lock_enable"
                              outlined
                              @click:clear="dateFormatted = null; changeLockDate('general','')"
                              clearable
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="dateFormatted"
                            @input="general_lock_date = false; changeLockDate('general','')"
                            no-title
                            scrollable
                          ></v-date-picker>
                        </v-menu>
                      </v-col>
                    </v-row>
                  </v-subheader>
                  <v-list-item v-if="pagination.filters.date_filter == '8'">
                    <v-menu
                      v-model="tran_start_date"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="pagination.filters.tran_start_date"
                          label="Start Date"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          dense
                          placeholder=" "
                          hide-details
                          outlined
                          clearable
                          @click:clear="disable_dates = null"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="dateFormatted"
                        @input="tran_start_date = false; parseDate('tran_start_date')"
                        no-title
                        scrollable
                      ></v-date-picker>
                    </v-menu>

                    <v-menu
                      v-model="tran_end_date"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="pagination.filters.tran_end_date"
                          label="End Date"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          dense
                          placeholder=" "
                          hide-details
                          outlined
                          clearable
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="dateFormatted"
                        @input="tran_end_date = false; parseDate('tran_end_date')"
                        no-title
                        scrollable
                        :min="disable_dates"
                      ></v-date-picker>
                    </v-menu>
                  </v-list-item>

                  <v-subheader v-if="pagination.filters.filter_by != 6">
                    <v-row dense>
                      <v-col cols="9" style="max-width: 68%">
                        <v-autocomplete
                          dense
                          flat
                          :items="filter_by"
                          outlined
                          label="Filter By"
                          hide-details
                          class="body-2"
                          placeholder=" "
                          v-model="pagination.filters.filter_by"
                          @change="set_date_default= true;pagination.itemsPerPage=25;pagination.filters.filter_by=='1' ? pagination.filters.f_project_status='':pagination.filters.f_project_status='1'; "
                        ></v-autocomplete>
                      </v-col>
                    </v-row>
                  </v-subheader>

                  <v-subheader>
                    <v-row dense>
                      <v-col
                        v-if="pagination.filters.filter_by!=6"
                        cols="3"
                        style="max-width: 22%;"
                      >
                        <v-autocomplete
                          dense
                          flat
                          :items="status"
                          outlined
                          label="Status"
                          hide-details
                          x-small
                          class="body-2"
                          placeholder=" "
                          v-model="pagination.filters.f_project_status"
                          @change="pagination.itemsPerPage=25;"
                        ></v-autocomplete>
                      </v-col>
                      <v-col v-if="pagination.filters.filter_by!=6">
                        <v-autocomplete
                          dense
                          flat
                          :items="project_list_filter"
                          outlined
                          label="Projects"
                          hide-details
                          small
                          class="body-2"
                          placeholder="All"
                          clearable
                          @click:clear="pagination.filters.f_project='';pagination.itemsPerPage=25;project_date = null;selectProjectIsMisc='';"
                          v-model="pagination.filters.f_project"
                          @change="pagination.itemsPerPage=25;getProjectType();getLockDate('project')"
                        ></v-autocomplete>
                      </v-col>
                      <v-col v-if="pagination.filters.filter_by==6">
                        <v-autocomplete
                          dense
                          flat
                          :items="project_list_filter"
                          outlined
                          label="Projects"
                          hide-details
                          small
                          class="body-2"
                          placeholder="All"
                          clearable
                          @click:clear="pagination.filters.f_project='';pagination.itemsPerPage=25;project_date = null;"
                          v-model="pagination.filters.f_project"
                          @change="pagination.itemsPerPage=25;getLockDate('project')"
                        ></v-autocomplete>
                      </v-col>
                      <v-col cols="1" class="d-flex align-center" style="max-width: 6%;">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              v-bind="attrs"
                              :disabled="!pagination.filters.f_project"
                              @click="project_lock_enable = !project_lock_enable"
                              :color="(project_lock_enable)?'primary':''"
                              v-on="on"
                              size="28"
                            >mdi-lock-outline</v-icon>
                          </template>
                          <span>Lock transaction by bank & date</span>
                        </v-tooltip>
                      </v-col>
                      <v-col cols="4" style="max-width: 26%;">
                        <v-menu
                          v-model="project_lock_date"
                          :close-on-content-click="false"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="project_date"
                              label="Project"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                              :disabled="!project_lock_enable || !pagination.filters.f_project"
                              dense
                              placeholder=" "
                              @click:clear="pagination.itemsPerPage=25;dateFormatted = null; changeLockDate('project',pagination.filters.f_project)"
                              hide-details
                              outlined
                              clearable
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="dateFormatted"
                            @input="pagination.itemsPerPage=25;project_lock_date = false; changeLockDate('project',pagination.filters.f_project)"
                            no-title
                            scrollable
                          ></v-date-picker>
                        </v-menu>
                      </v-col>
                    </v-row>
                  </v-subheader>

                  <v-subheader v-if="pagination.filters.filter_by != 6">
                    <v-row dense>
                      <v-col cols="3" style="max-width: 22%;">
                        <v-autocomplete
                          dense
                          flat
                          :items="status"
                          outlined
                          label="Status"
                          hide-details
                          x-small
                          class="body-2"
                          placeholder=" "
                          v-model="pagination.filters.f_vendor_status"
                          @change="pagination.itemsPerPage=25;"
                        ></v-autocomplete>
                      </v-col>
                      <v-col>
                        <v-autocomplete
                          dense
                          flat
                          :items="expence_list_filter"
                          outlined
                          label="Vendor"
                          hide-details
                          small
                          class="body-2 focus-on-vendor-expence"
                          placeholder="All"
                          clearable
                          @click:clear="pagination.filters.f_vendor='';vendor_date = null;pagination.itemsPerPage=25"
                          v-model="pagination.filters.f_vendor"
                          v-if="expence_filter_flag"
                          @change="pagination.itemsPerPage=25;getLockDate('chart_of_account')"
                        >
                          <template v-slot:prepend-item>
                            <a
                              class="pl-4"
                              @click="expence_filter_flag = false; setFocus('focus-on-vendor-expence');"
                            >Select Vendor</a>
                            <v-divider></v-divider>
                          </template>
                        </v-autocomplete>

                        <v-autocomplete
                          dense
                          flat
                          :items="vendor_list_filter"
                          outlined
                          label="Vendor"
                          hide-details
                          small
                          class="body-2 focus-on-vendor-expence"
                          placeholder="All"
                          clearable
                          @click:clear="pagination.filters.f_vendor='';vendor_date = null;pagination.itemsPerPage=25"
                          v-model="pagination.filters.f_vendor"
                          @change="pagination.itemsPerPage=25;getLockDate('vendor')"
                          v-else
                        >
                          <template v-slot:prepend-item>
                            <a
                              class="pl-4"
                              @click="expence_filter_flag = true; setFocus('focus-on-vendor-expence');"
                            >Select Chart of Account</a>
                            <v-divider></v-divider>
                          </template>
                        </v-autocomplete>
                      </v-col>
                      <v-col cols="1" class="d-flex align-center" style="max-width: 6%;">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              v-bind="attrs"
                              :disabled="!pagination.filters.f_vendor"
                              @click="vendor_lock_enable = !vendor_lock_enable"
                              :color="(vendor_lock_enable)?'primary':''"
                              v-on="on"
                              size="28"
                            >mdi-lock-outline</v-icon>
                          </template>
                          <span>Lock transaction by bank & date</span>
                        </v-tooltip>
                      </v-col>
                      <v-col cols="4" style="max-width: 26%;">
                        <v-menu
                          v-model="vendor_lock_date"
                          :close-on-content-click="false"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="vendor_date"
                              label="Vendor"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                              :disabled="!vendor_lock_enable || !pagination.filters.f_vendor"
                              dense
                              placeholder=" "
                              @click:clear="pagination.itemsPerPage=25;dateFormatted = null; changeLockDate(vendor_account_flag,pagination.filters.f_vendor)"
                              @change="pagination.itemsPerPage=25;"
                              hide-details
                              outlined
                              clearable
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="dateFormatted"
                            @input="vendor_lock_date = false; changeLockDate(vendor_account_flag,pagination.filters.f_vendor)"
                            no-title
                            scrollable
                          ></v-date-picker>
                        </v-menu>
                      </v-col>
                    </v-row>
                  </v-subheader>

                  <v-subheader v-if="pagination.filters.filter_by != 6">
                    <v-row dense>
                      <v-col cols="3" style="max-width: 21.5%;">
                        <v-autocomplete
                          dense
                          flat
                          :items="filter_by_group"
                          outlined
                          label="Group Filter By"
                          hide-details
                          class="body-2"
                          placeholder="All"
                          v-model="pagination.filters.f_group_status"
                          @change="pagination.itemsPerPage=25;"
                        ></v-autocomplete>
                      </v-col>
                      <v-col cols="6" style="max-width: 46.4%;">
                        <v-autocomplete
                          :items="group_list_filter"
                          v-model="group_change_order"
                          label="Group"
                          hide-details
                          dense
                          outlined
                          clearable
                          placeholder=" "
                          v-debounce:500="customChange"
                          @click:clear="pagination.itemsPerPage=25;"
                          @change="pagination.itemsPerPage=25;pagination.filters.f_group='';pagination.filters.f_co='';AssignGroupChangeOrder();getTransaction()"
                        ></v-autocomplete>
                      </v-col>
                    </v-row>
                  </v-subheader>
                  <v-subheader v-if="pagination.filters.filter_by != 6">
                    <v-row dense>
                      <v-col cols="9" style="max-width: 68%">
                        <v-text-field
                          v-model="search"
                          append-icon="mdi-magnify"
                          label="Search"
                          hide-details
                          dense
                          outlined
                          placeholder=" "
                          clearable
                          autofocus
                          v-on:keyup.enter="search_menu = false"
                          v-debounce:500="getTransaction"
                          @click:clear="search = null;pagination.itemsPerPage =25; getTransaction()"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-subheader>
                  <v-subheader v-if="pagination.filters.filter_by != 6">
                    <v-row dense>
                      <v-col cols="3" style="max-width: 21.5%;">
                        <v-autocomplete
                          dense
                          flat
                          :items="filter_by_amount"
                          outlined
                          label="Amt Filter By"
                          hide-details
                          class="body-2"
                          placeholder="All"
                          v-model="pagination.filters.amt_filter_by"
                          @change="pagination.itemsPerPage=25;"
                        ></v-autocomplete>
                      </v-col>
                      <v-col cols="6" style="max-width: 46.4%;">
                        <v-text-field
                          v-model="exact_amount"
                          label="Exact Amt"
                          type="number"
                          hide-details
                          dense
                          outlined
                          clearable
                          placeholder=" "
                          v-debounce:500="customChange"
                          @click:clear="exact_amount = '';pagination.itemsPerPage=25;"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-subheader>
                  <v-subheader>
                    <v-row dense style="max-width: 82.7%;">
                      <v-col cols="5">
                        <v-text-field
                          v-model="amount_from"
                          label="Amt From"
                          hide-details
                          dense
                          outlined
                          clearable
                          placeholder=" "
                          v-debounce:500="customChange"
                          @click:clear="amount_from = '';pagination.itemsPerPage=25; getTransaction()"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="5">
                        <v-text-field
                          v-model="amount_to"
                          label="Amt To"
                          hide-details
                          dense
                          outlined
                          clearable
                          placeholder=" "
                          v-debounce:500="customChange"
                          @click:clear="amount_to = '';pagination.itemsPerPage=25; getTransaction()"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-subheader>

                  <v-list-item v-if="pagination.filters.filter_by == 6">
                    <v-switch
                      class="pt-0 ma-0"
                      v-model="pagination.filters.outstanding"
                      label="Outstading"
                      color="success"
                      dense
                      hide-details
                    ></v-switch>
                  </v-list-item>
                </v-list>
                <v-card-title class="pa-0">
                  <v-btn
                    fab
                    color="error"
                    x-small
                    absolute
                    @click="filter_menu = false"
                    class="custom-close-btn"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                  <v-btn
                    fab
                    absolute
                    class="error"
                    @click="resetFilter()"
                    style="right:-12px;top:-16px;"
                    x-small
                  >
                    <v-icon>mdi-filter-remove-outline</v-icon>
                  </v-btn>
                </v-card-title>
              </v-card>
            </v-menu>
          </span>
          <span class="ml-7">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  dark
                  v-bind="attrs"
                  v-on="on"
                  class="ml-7 header_btn"
                  @click="openDocList(selectedRows[0])"
                  :disabled="pagination.filters.generate_invoice || selectedRows.length != 1 || pagination.filters.filter_by == '12' || pagination.filters.filter_by == '6'"
                >
                  <v-badge
                    color="error"
                    :content="(selectedRows[0] && selectedRows.length == 1 && pagination.filters.filter_by != '6')?selectedRows[0].related_doc_count:''"
                    :value="(selectedRows[0] && selectedRows.length == 1 && pagination.filters.filter_by != '6')?selectedRows[0].related_doc_count:''"
                    overlap
                  >
                    <v-icon size="28px">mdi-dresser-outline</v-icon>
                  </v-badge>
                  <span class="lable_class">DOX</span>
                </v-btn>
              </template>
              <span>Documents</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  dark
                  v-bind="attrs"
                  v-on="on"
                  @click="openLogList(selectedRows[0])"
                  :disabled="pagination.filters.generate_invoice || selectedRows.length != 1 || pagination.filters.filter_by == '12' || pagination.filters.filter_by == '6'"
                  class="ml-7 header_btn"
                >
                  <v-badge
                    color="error"
                    :content="(selectedRows[0] && selectedRows.length == 1 && pagination.filters.filter_by != '6')?selectedRows[0].logs_count:''"
                    :value="(selectedRows[0] && selectedRows.length == 1 && pagination.filters.filter_by != '6')?selectedRows[0].logs_count:''"
                    overlap
                  >
                    <v-icon size="22px">mdi-file-document-multiple-outline</v-icon>
                  </v-badge>
                  <span class="lable_class">Logs</span>
                </v-btn>
              </template>
              <span>Logs</span>
            </v-tooltip>
          </span>
          <span class="ml-7">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :disabled="pagination.filters.generate_invoice || selectedRows.length != 1 || pagination.filters.filter_by == '12' || open_doc_model_falg || open_log_model_falg || pagination.filters.filter_by == '6'"
                  icon
                  dark
                  v-bind="attrs"
                  v-on="on"
                  class="ml-7 header_btn"
                  @click="openKeywordList(selectedRows[0],true)"
                >
                  <v-icon size="28px">mdi-key-plus</v-icon>
                  <span class="lable_class">Keywords</span>
                </v-btn>
              </template>
              <span>Key word</span>
            </v-tooltip>
          </span>
          <span class="ml-7">
            <!-- <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  icon
                  small
                  dark
                  :disabled="
                    !pagination.filters.f_project || 
                    selectedRows.length == 0 ||
                    hasInvoices.length > 0 ||
                    !tranIsTagged || pagination.filters.transaction_type_filter == '2' || pagination.filters.transaction_type_filter == '3' || pagination.filters.transaction_type_filter == '4' || pagination.filters.transaction_type_filter == '5'
                  "
                  @click="generateInvoices"
                  class="ml-2"
                >
                  <v-icon size="28px">mdi-newspaper-plus</v-icon>
                </v-btn>
              </template>
              <span>Generate Invoice</span>
            </v-tooltip>-->
            <v-tooltip bottom v-if="!pagination.filters.generate_invoice">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  icon
                  small
                  dark
                  class="ml-7 header_btn"
                  :disabled="open_doc_model_falg || open_log_model_falg"
                  @click="loading = true;items.data=[];is_project_unchecked = false; pagination.sortBy = ['generate_invoice']; last_select_transaction = ''; pagination.filters.generate_invoice_project = '';  pagination.filters.generate_invoice_project_work = '';pagination.filters.generate_invoice_vendor = '';pagination.filters.generate_invoice_group = '';pagination.filters.date_filter = '';pagination.filters.tran_start_date = '';pagination.filters.tran_end_date = '';report_details=[];pagination.itemsPerPage=25; pagination.filters.generate_invoice = true;pagination.filters.f_project_status='1'"
                >
                  <v-icon size="28px">mdi-playlist-plus</v-icon>
                  <span class="lable_class">Invoice</span>
                </v-btn>
              </template>
              <span>Create Invoice</span>
            </v-tooltip>
            <v-tooltip bottom v-if="pagination.filters.generate_invoice">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  icon
                  small
                  dark
                  class="ml-7 header_btn"
                  @click="loading = true;items.data=[]; is_project_unchecked = false; pagination.sortBy = ['trans_code'];  active_report = 6; last_select_transaction = ''; pagination.filters.generated_inv_id = ''; report_details=[];pagination.filters.generate_invoice_project = '';pagination.filters.generate_invoice_group = '';pagination.filters.date_filter = '';pagination.filters.tran_start_date = '';pagination.filters.tran_end_date = '';pagination.itemsPerPage=25;pagination.filters.generate_invoice = false;pagination.filters.f_project_status='1'"
                >
                  <v-icon size="28px">mdi-playlist-remove</v-icon>
                  <span class="lable_class">Invoice</span>
                </v-btn>
              </template>

              <span>Close invoice</span>
            </v-tooltip>
            <!-- <v-tooltip bottom v-if="pagination.filters.generate_invoice">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  icon
                  small
                  dark
                  class="ml-2"
                  :disabled="selectedRows.length == 0 || open_doc_model_falg || open_log_model_falg"
                  @click="generateInvoices"
                >
                  <v-icon size="28px">mdi-newspaper-plus</v-icon>
                </v-btn>
              </template>
              <span>Generate Invoice</span>
            </v-tooltip>-->
            <!-- <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  icon
                  small
                  dark
                  @click="delete_invoice_dialog = true"
                  class="ml-2"
                  disabled=""
                >
                  <v-icon size="28px">mdi-file-restore-outline</v-icon>
                </v-btn>
              </template>
              <span>Delete Invoice</span>
            </v-tooltip>-->
            <!-- <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" icon small dark class="ml-7" disabled>
                  <v-icon size="28px">mdi-note-text</v-icon>
                    <span class="lable_class">Summary</span>
                </v-btn>
              </template>
              <span>Invoice Summary</span>
            </v-tooltip>-->
          </span>
          <span class="ml-7">
            <v-menu offset-y v-model="report_menu" :close-on-content-click="closeOnContentClick">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  class="ml-7 header_btn"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  :disabled="selectedRows.length != 1 || pagination.filters.filter_by != '6'"
                >
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon size="28px" v-bind="attrs" v-on="on">mdi-printer</v-icon>
                    </template>
                    <span>Select report to generate</span>
                  </v-tooltip>
                  <span class="lable_class">Report</span>
                </v-btn>
              </template>

              <v-list dense style="font-size: 16px !important;">
                <!-- <v-list-item
                  v-if="selectedRows.length == 1 && selectedRows[0].project &&  (selectedRows[0].project.project_work == 'remodeling' || selectedRows[0].project.project_work == 'new_construction' || selectedRows[0].project.project_work == 'project_management')"
                  @click="report_header_name='Order - G702';report_menu = false; g702_change_report=true;generateG702Report();"
                >
                  <v-list-item-title>Order - G702</v-list-item-title>
                </v-list-item>
                <v-list-item
                  v-if="selectedRows.length == 1 && selectedRows[0].project &&   (selectedRows[0].project.project_work == 'remodeling' || selectedRows[0].project.project_work == 'new_construction' || selectedRows[0].project.project_work == 'project_management')"
                  @click="report_header_name='Schedule of Value - G703';report_menu = false; g703_change_report=true; generateG703Report();"
                >
                  <v-list-item-title>Schedule of Value - G703</v-list-item-title>
                </v-list-item>-->
                <v-list-item
                  v-if="selectedRows.length == 1 && selectedRows[0].project &&   selectedRows[0].project.p_type=='fixed' && (selectedRows[0].project.project_work == 'remodeling' || selectedRows[0].project.project_work == 'new_construction' || selectedRows[0].project.project_work == 'project_management')"
                  @click="report_header_name='Pay App - G702';report_menu = false;g702_change_report=false; generateG702Report();"
                >
                  <v-list-item-title>Pay App - G702</v-list-item-title>
                </v-list-item>
                <v-list-item
                  v-if="selectedRows.length == 1 && selectedRows[0].project &&   selectedRows[0].project.p_type=='fixed' && (selectedRows[0].project.project_work == 'remodeling' || selectedRows[0].project.project_work == 'new_construction' || selectedRows[0].project.project_work == 'project_management')"
                  @click="report_header_name='Pay App - G703';report_menu = false; g703_change_report=false; generateG703Report();"
                >
                  <v-list-item-title>Pay App - G703</v-list-item-title>
                </v-list-item>
                <v-list-item
                  v-if="selectedRows.length == 1 && selectedRows[0].project &&  selectedRows[0].project.p_type=='cost_plus' && (selectedRows[0].project.project_work == 'remodeling' || selectedRows[0].project.project_work == 'new_construction' || selectedRows[0].project.project_work == 'project_management')"
                  @click="report_header_name='Invoice';report_menu = false; g703_change_report=false; generateG703Report('cost_plus');"
                >
                  <v-list-item-title>Invoice (Cost Plus)</v-list-item-title>
                </v-list-item>

                <!-- <v-list-item
                  v-if="selectedRows.length == 1 && selectedRows[0].project && selectedRows[0].project.project_work &&  (selectedRows[0].project.project_work == 'remodeling' || selectedRows[0].project.project_work == 'new_construction' || selectedRows[0].project.project_work == 'project_management')"
                  @click="report_menu = false; generateContractReport();"
                >
                  <v-list-item-title>Contract</v-list-item-title>
                </v-list-item>-->
                <!-- <v-list-item v-if="selectedRows.length == 1 && selectedRows[0].project && selectedRows[0].project.project_work &&  selectedRows[0].project.project_work != 'retail_sales'">
                  <v-list-item-title>Change Order</v-list-item-title>
                </v-list-item>-->
                <v-list-item
                  v-if="selectedRows.length == 1 && selectedRows[0].project && selectedRows[0].project.project_work &&  (selectedRows[0].project.project_work == 'remodeling' || selectedRows[0].project.project_work == 'new_construction' || selectedRows[0].project.project_work == 'project_management')"
                  @click="report_menu = false; generatePartialLienReleaseReport()"
                >
                  <v-list-item-title>Partial Lien Release</v-list-item-title>
                </v-list-item>
                <v-list-item
                  v-if="selectedRows.length == 1 && selectedRows[0].project && selectedRows[0].project.project_work &&  (selectedRows[0].project.project_work == 'remodeling' || selectedRows[0].project.project_work == 'new_construction' || selectedRows[0].project.project_work == 'project_management')"
                  @click="report_menu = false; generateFinalLienReleaseReport()"
                >
                  <v-list-item-title>Final Lien Release</v-list-item-title>
                </v-list-item>
                <v-list-item
                  v-if="selectedRows.length == 1 && selectedRows[0].project && selectedRows[0].project.project_work &&  (selectedRows[0].project.project_work == 'counter_tops' || selectedRows[0].project.project_work == 'retail_sales')"
                  @click="generateSalesInvoiceReport(); report_menu = false;"
                >
                  <v-list-item-title>Sales Order</v-list-item-title>
                </v-list-item>
                <v-list-item
                  v-if="selectedRows.length == 1 && selectedRows[0].project && selectedRows[0].project.project_work &&  selectedRows[0].project.project_work == 'counter_tops'"
                  @click="generateCounterTopOrderReport(); report_menu = false;"
                >
                  <v-list-item-title>Cut List</v-list-item-title>
                </v-list-item>
                <v-list-item
                  v-if="selectedRows.length == 1 && selectedRows[0].project && selectedRows[0].project.project_work &&  selectedRows[0].project.project_work == 'counter_tops'"
                  @click="generateAcceptanceReport(); report_menu = false;"
                >
                  <v-list-item-title>Material</v-list-item-title>
                </v-list-item>
                <!-- <v-list-item v-if="selectedRows.length == 1 && selectedRows[0].project && selectedRows[0].project.project_work &&  selectedRows[0].project.project_work != 'retail_sales'" @click="signOffReport(); report_menu = false;">
                  <v-list-item-title>Sign Off</v-list-item-title>
                </v-list-item>-->
              </v-list>
            </v-menu>
          </span>
        </v-col>
        <v-col cols="2" class="d-flex align-center justify-end">
          <span class="white--text font-weight-bold">
            Bank Transactions
            <v-icon
              class="error--text ml-2"
              size="30"
              style="color:#ffffff  !important"
              @click="logout()"
            >mdi-logout</v-icon>
          </span>
        </v-col>
      </v-row>
    </div>
    <div class="fixed-top-bar2 d-flex align-center">
      <v-row>
        <v-col>
          <span v-if="pagination.filters.generate_invoice">
            <span class="ml-10">
              INV No:
              <b>{{report_details.application_number}}</b>
            </span>
            <span
              :class="report_details.invoice_amt < 0 ?  'ml-10 error--text': 'ml-10 primary--text'"
            >
              INV Amt:
              <b>{{getAmountFormat(report_details.invoice_amt)}}</b>
            </span>
            <span class="ml-10">
              Date:
              <b>{{report_details.application_date}}</b>
            </span>
            <!-- <span class="ml-10">Amt: <b>${{ selected_transaction_invoice_total }}</b></span> -->
          </span>
        </v-col>
        <v-col cols="3">
          <span v-if="pagination.filters.generate_invoice">
            <span :class="selected_transaction_invoice_total < 0 ? 'error--text': 'primary--text'">
              Amt:
              <b>${{ getAmountFormat(selected_transaction_invoice_total) }}</b>
            </span>
          </span>
        </v-col>

        <!-- <v-col  cols="5">
            <span v-if="pagination.filters.generate_invoice">
              <span class="ml-10">Mult: <b>{{ report_details.multiplier }}</b></span>
            <span class="ml-10">O & P: <b>{{ report_details.p_price ? report_details.p_price+'%' : '' }}</b></span>
            </span>
        </v-col>-->
        <!-- <v-col cols="1" style="max-width: 7%;">
          <span v-if="pagination.filters.generate_invoice">
            ${{ selected_transaction_invoice_total }}
          </span>
        </v-col>-->
        <!-- <v-col cols="1" class="text-right mr-5">
          <span
            v-if="getAmountFormat(total_invoice_amt) > 0 && active_report == 6 && pagination.filters.generate_invoice"
          >${{ getAmountFormat(total_invoice_amt) }}</span>
        </v-col>-->
        <v-col cols="2" class="text-right">{{getSelectedTransactionType}}</v-col>
      </v-row>
    </div>
    <v-overlay absolute :value="loading" style="z-index: 10">
      <v-icon style="font-size: 80px;">mdi-progress-clock mdi-spin</v-icon>
    </v-overlay>
    <v-card tile style="background: none" flat :loading="loading">
      <v-row
        class="white ml-0 mr-0"
        v-if="pagination.filters.generate_invoice"
        dense
        style="position: fixed; z-index: 1; width: 1350px;"
      >
        <v-col cols="8">
          <v-tabs>
            <v-tab class="text-capitalize" @click="active_report = 6">Invoice Data</v-tab>
            <!-- <v-tab
              v-if="pagination.filters.generate_invoice_project && invoice_project_data.project_work.length > 0 && (invoice_project_data.project_work[0].project_work == 'remodeling' || invoice_project_data.project_work[0].project_work == 'new_construction' || invoice_project_data.project_work[0].project_work == 'project_management')"
              :disabled="selectedRows.length == 0"
              class="text-capitalize"
              @click="active_report = 1"
            >G-702</v-tab>
            <v-tab
              v-if="pagination.filters.generate_invoice_project && invoice_project_data.project_work.length > 0 && (invoice_project_data.project_work[0].project_work == 'remodeling' || invoice_project_data.project_work[0].project_work == 'new_construction' || invoice_project_data.project_work[0].project_work == 'project_management')"
              :disabled="selectedRows.length == 0"
              class="text-capitalize"
              @click="active_report = 2"
            >G-703</v-tab>
            <v-tab
              v-if="pagination.filters.generate_invoice_project && invoice_project_data.project_work.length > 0 && (invoice_project_data.project_work[0].project_work == 'remodeling' || invoice_project_data.project_work[0].project_work == 'new_construction' || invoice_project_data.project_work[0].project_work == 'project_management')"
              :disabled="selectedRows.length == 0"
              class="text-capitalize"
              @click="active_report = 3"
            >Contract</v-tab>
            <v-tab
              v-if="pagination.filters.generate_invoice_project && invoice_project_data.project_work.length > 0 && (invoice_project_data.project_work[0].project_work == 'remodeling' || invoice_project_data.project_work[0].project_work == 'new_construction' || invoice_project_data.project_work[0].project_work == 'project_management')"
              :disabled="selectedRows.length == 0"
              class="text-capitalize"
              @click="active_report = 4"
            >Partial Lien Release</v-tab>
            <v-tab
              v-if="pagination.filters.generate_invoice_project && invoice_project_data.project_work.length > 0 && (invoice_project_data.project_work[0].project_work == 'remodeling' || invoice_project_data.project_work[0].project_work == 'new_construction' || invoice_project_data.project_work[0].project_work == 'project_management')"
              :disabled="selectedRows.length == 0"
              class="text-capitalize"
              @click="active_report = 5"
            >Final Lien Release</v-tab>-->
          </v-tabs>
        </v-col>
        <v-col cols="4" class="d-flex align-center justify-end">
          <v-btn
            v-if="pagination.filters.generated_inv_id && active_report != 6"
            color="primary"
            class="text-capitalize"
            @click="getTotalPage(); is_send_report = false; preview_pdf_dialog = true;"
          >
            <v-icon left>mdi-content-save-outline</v-icon>Save
          </v-btn>
          <v-btn
            v-if="pagination.filters.generated_inv_id && active_report != 6"
            color="primary"
            class="ml-2 text-capitalize"
            @click="preview_pdf_dialog = true; is_send_report = true; getTotalPage();"
          >
            <v-icon left>mdi-send</v-icon>Send
          </v-btn>
          <v-btn
            v-if="pagination.filters.generated_inv_id && last_invoice == 'yes'"
            color="primary"
            class="text-capitalize ml-2"
            @click="delete_invoice_dialog = true"
            :disabled="open_doc_model_falg"
          >Delete Invoice</v-btn>
          <v-btn
            v-if="pagination.filters.generated_inv_id && last_invoice == 'yes'"
            color="primary"
            class="text-capitalize ml-2"
            @click="pagination.filters.is_last_invoice='yes'"
            :disabled="selectedRows.length == 0 || open_doc_model_falg || open_log_model_falg"
          >Edit Invoice</v-btn>
          <v-btn
            v-if="pagination.filters.generated_inv_id && last_invoice == 'yes' && selectedRows.length == 0"
            color="primary"
            class="text-capitalize ml-2"
            @click="updateInvoiceFromReport"
            :disabled="open_doc_model_falg || open_log_model_falg"
          >Generate Invoice W/O transaction</v-btn>
          <v-btn
            v-if="pagination.filters.generated_inv_id && last_invoice == 'yes' && selectedRows[0] && selectedRows[0].project.p_type=='fixed'"
            color="primary"
            class="text-capitalize ml-2"
            @click="updateInvoiceFromReport"
            :disabled="selectedRows.length == 0 || open_doc_model_falg || open_log_model_falg"
          >Generate Invoice</v-btn>
          <v-btn
            v-if="pagination.filters.generated_inv_id && last_invoice == 'yes' && selectedRows[0] && selectedRows[0].project.p_type=='cost_plus'"
            color="primary"
            class="text-capitalize ml-2"
            @click="updateInvoiceFromReportForCostPlus"
            :disabled="selectedRows.length == 0 || open_doc_model_falg || open_log_model_falg"
          >Generate Invoice</v-btn>
          <v-btn
            v-if="pagination.filters.generated_inv_id"
            color="error"
            class="text-capitalize ml-2"
            @click="loading = true;items.data=[]; is_project_unchecked = false; pagination.sortBy = ['trans_code'];  active_report = 6; last_select_transaction = ''; pagination.filters.generated_inv_id = ''; report_details=[];pagination.filters.generate_invoice_project = '';pagination.filters.generate_invoice_group = '';pagination.itemsPerPage=25;pagination.filters.generate_invoice = false;"
            :disabled="open_doc_model_falg"
          >Cancel</v-btn>
          <v-btn
            v-if="!pagination.filters.generated_inv_id && selectedRows.length == 0"
            color="primary"
            class="text-capitalize ml-2"
            @click="generate_invoice_project_list_popup=true;getProjectListWithWorkType();"
            :disabled="open_doc_model_falg || open_log_model_falg"
          >Generate Invoice W/O Transaction</v-btn>
          <v-btn
            v-if="!pagination.filters.generated_inv_id && selectedRows[0] && selectedRows[0].project.p_type=='fixed'"
            color="primary"
            class="text-capitalize ml-2"
            @click="view703Report()"
            :disabled="selectedRows.length == 0 || open_doc_model_falg || open_log_model_falg"
          >Generate Invoice</v-btn>
          <v-btn
            v-if="!pagination.filters.generated_inv_id && selectedRows[0] && selectedRows[0].project.p_type=='cost_plus'"
            color="primary"
            class="text-capitalize ml-2"
            @click="view703ReportForCostPlus()"
            :disabled="selectedRows.length == 0 || open_doc_model_falg || open_log_model_falg"
          >Generate Invoice</v-btn>
        </v-col>
      </v-row>
      <!-- <div style="padding-top: 48px !important;" v-if="pagination.filters.generate_invoice">
        <v-card-text
          style="width: 1200px;"
          class="pa-0 mx-auto"
          v-show="active_report == 1" 
        >
          <G702Report :project_details="invoice_project_data" :is_preview_only="true" :generate_invoice_project="pagination.filters.generate_invoice_project" :g702_change_report="g702_change_report"/>
        </v-card-text>
        <v-card-text
          style="width: 1200px;"
          class="pa-0 mx-auto"
          v-show="active_report == 2"
        >
          <G703Report :project_details="invoice_project_data" :is_preview_only="true" :generate_invoice_project="pagination.filters.generate_invoice_project" :selectedRows="selectedRows" :g703_change_report="g703_change_report" />
         
        </v-card-text>
        <v-card-text
          style="width: 1200px;"
          class="pa-0 mx-auto"
          v-show="active_report == 3"
        >
          <ContractReport :project_details="invoice_project_data" :is_preview_only="true" :generate_invoice_project="pagination.filters.generate_invoice_project" />
        
        </v-card-text>
        <v-card-text
          style="width: 1030px; font-family: 'Roboto', sans-serif;"
          class="pa-0 mx-auto"
          id="partial_lien_release"
          v-if="active_report == 4"
        >
          <v-row dense class="ml-2 mt-3 report-header2 custom-font-for-print">
            <v-col cols="12" style="font-size: 18px;" class="text-center mt-2">
              <b>UNCONDITIONL WAIVER AND RELEASE UPON PROGRESS PAYMENT</b>
              <v-divider class="mt-3 mb-5"></v-divider>
            </v-col>

            <v-col cols="12" class="ml-1 d-flex">
              <span v-html="getReportText(2,1)"></span>
              <span v-if="!printing_report" class="align-self-end">
                <v-icon
                  class="cursor-pointer"
                  @click="openReportTextDialog(2,1)"
                  :disabled="!pagination.filters.invoice_project || pagination.filters.generated_inv_id > 0"
                >mdi-border-color</v-icon>
              </span>
            </v-col>
            
            <v-col cols="1" style="max-width: 4.2%; margin-top: 28px;">Dated:</v-col>
            <v-col cols="1">
              <v-divider style="margin-top: 45px;"></v-divider>
            </v-col>
            <v-col cols="8"></v-col>
            <v-col>
              <v-divider style="margin-top: 45px;"></v-divider>By:
              <br />{{company_details.name}},
              <br />{{company_details.shipping_address_line_1}}
              <br />{{company_details.shipping_city_details.city_name}}, {{company_details.shipping_state_details.short_name}} {{company_details.shipping_zip}}
            </v-col>

            <v-col cols="12" class="ml-1 d-flex" style="margin-top: 20px;">
              <span v-html="getReportText(2,2)"></span>
              <span v-if="!printing_report" class="align-self-end">
                <v-icon
                  class="cursor-pointer"
                  @click="openReportTextDialog(2,2)"
                  :disabled="!pagination.filters.invoice_project || pagination.filters.generated_inv_id > 0"
                >mdi-border-color</v-icon>
              </span>
            </v-col>

            <v-col cols="12" class="ml-1 d-flex" style="margin-top: 20px;">
              <span v-html="getReportText(2,3)"></span>
              <span v-if="!printing_report" class="align-self-end">
                <v-icon
                  class="cursor-pointer"
                  @click="openReportTextDialog(2,3)"
                  :disabled="!pagination.filters.invoice_project || pagination.filters.generated_inv_id > 0"
                >mdi-border-color</v-icon>
              </span>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-text
          style="width: 1030px; font-family: 'Roboto', sans-serif;"
          class="pa-0 mx-auto"
          id="final_lien_release"
          v-if="active_report == 5"
        >
          <v-row dense class="ml-2 mt-3 report-header2 custom-font-for-print">
            <v-col cols="12" style="font-size: 18px;" class="text-center mt-2">
              <b>WAIVER AND RELEASE OF LIEN FINAL PAYMENT</b>
              <v-divider class="mt-3 mb-5"></v-divider>
            </v-col>

            <v-col cols="12" class="d-flex">
              <span v-html="getReportText(3,1)"></span>
              <span v-if="!printing_report" class="align-self-end">
                <v-icon
                  class="cursor-pointer"
                  @click="openReportTextDialog(3,1)"
                  :disabled="!pagination.filters.invoice_project || pagination.filters.generated_inv_id > 0"
                >mdi-border-color</v-icon>
              </span>
            </v-col>
            <v-col cols="12" style="margin-top: 16px;">Lienor's Name: {{company_details.name}}</v-col>
            <v-col cols="12" style="margin-top: 16px;">Address: {{company_details.shipping_address_line_1}}, {{company_details.shipping_city_details.city_name}}, {{company_details.shipping_state_details.short_name}} {{company_details.shipping_zip}}</v-col>

            <v-col cols="2" style="margin-top: 20px;"></v-col>
            <v-col cols="2">
              <v-divider style="margin-top: 45px;"></v-divider>
            </v-col>
            <v-col cols="8" style="margin-top: 20px;"></v-col>

            <v-col cols="2">By:</v-col>
            <v-col cols="10"><b>President</b></v-col>
            <v-col cols="2">Printed Name:</v-col>
            <v-col cols="10"><b>{{company_details.contact_person}}</b></v-col>

            <v-col cols="12" class="d-flex" style="margin-top: 20px;">
              <span v-html="getReportText(3,2)"></span>
              <span v-if="!printing_report" class="align-self-end">
                <v-icon
                  class="cursor-pointer"
                  @click="openReportTextDialog(3,2)"
                  :disabled="!pagination.filters.invoice_project || pagination.filters.generated_inv_id > 0"
                >mdi-border-color</v-icon>
              </span>
            </v-col>

            <v-col cols="12" class="d-flex" style="margin-top: 20px;">
              <span v-html="getReportText(3,3)"></span>
              <span v-if="!printing_report" class="align-self-end">
                <v-icon
                  class="cursor-pointer"
                  @click="openReportTextDialog(3,3)"
                  :disabled="!pagination.filters.invoice_project || pagination.filters.generated_inv_id > 0"
                >mdi-border-color</v-icon>
              </span>
            </v-col>
          </v-row>
        </v-card-text>
      </div>-->
      <v-card-text
        class="pa-0 mx-auto"
        v-show="(active_report == 6 || !pagination.filters.generate_invoice) && (pagination.filters.filter_by != 6 || pagination.filters.generate_invoice)"
      >
        <v-data-table
          :headers="headers"
          class="elevation-1 rounded-0 my-transaction-table fix-table-layout fix-table-header"
          :class="(pagination.filters.generate_invoice)?'fix-table-transaction-header':''"
          :search="search"
          :items="sortData"
          :items-per-page="pagination.itemsPerPage"
          hide-default-footer
          :page.sync="pagination.page"
          mobile-breakpoint="50"
          dense
          item-key="trans_id"
          :options.sync="pagination"
        >
          <template v-slot:group.header="{ group, headers, toggle, isOpen }">
            <td :colspan="headers.length" class="pl-1">
              <div class="d-flex justify-space-between">
                <div>
                  <v-btn @click="toggle" small icon :ref="group">
                    <v-icon v-if="isOpen">mdi-chevron-up</v-icon>
                    <v-icon v-else>mdi-chevron-down</v-icon>
                  </v-btn>
                  <span class="font-weight-bold">
                    {{
                    getSelectedTitle(group)
                    }}
                  </span>
                </div>
                <div>
                  <v-btn small icon @click="grouped.status = false">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </div>
              </div>
            </td>
          </template>
          <template v-slot:item="{ item}">
            <tr :class="row_backgroup_color(item)">
              <td class="text-start" width="2%">
                <v-simple-checkbox
                  v-model="item.selected"
                  :ripple="false"
                  class="custom-simple-box"
                  v-show="!is_project_unchecked"
                  :disabled="(pagination.filters.filter_by == '10' && item.duplicate == '0') || (pagination.filters.filter_by == '12' && item.is_lock_by_current_date == '1') || (pagination.filters.generate_invoice && !item.invoice_group) || (item.project && item.project.p_type=='fixed' && pagination.filters.generate_invoice && item.invoice_item_id==null) ||  (item.project && item.project.p_type=='cost_plus' && pagination.filters.generate_invoice && !item.invoice_group_id) "
                  @input="selectTransaction(); selectRecord(item.trans_id)"
                ></v-simple-checkbox>
              </td>
              <td width="7%" class="text-left">
                <span :title="item.bank_id ? item.bank.bank_name : ''">
                  {{
                  item.bank_id ? item.bank.bank_code : ""
                  }}
                </span>
              </td>
              <!-- <td class="text-center" width="10%">{{ (item.type)?item.type.title:'' }}</td> -->
              <td
                width="6%"
                v-if="pagination.filters.filter_by == '12' || open_doc_model_falg || open_log_model_falg"
                class="text-center"
              >{{ getFormatedDate(item.trans_date) }}</td>
              <td width="6%" v-else class="text-center">
                <a
                  href="javascript:void(0)"
                  @click="editRow(item)"
                  class="blue--text"
                >{{ getFormatedDate(item.trans_date) }}</a>
              </td>
              <td width="9%" class="text-right">
                <div>
                  <span
                    :class="{
                      'error--text': item.rev_amount < 0,
                      'primary--text': item.rev_amount > 0,
                    }"
                  >${{ getAmountFormat(item.rev_amount) }}</span>
                </div>
              </td>
              <td class="text-left" width="9%">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">{{ (item.project)?item.project.p_code:'' }}</span>
                  </template>
                  <span>{{ (item.project)?item.project.p_name:'' }}</span>
                </v-tooltip>
              </td>
              <td class="text-left" width="9%">
                <v-tooltip bottom v-if="item.expence">
                  <template v-slot:activator="{ on, attrs }">
                    <span
                      v-bind="attrs"
                      v-on="on"
                    >{{ (item.expance_details)?item.expance_details.bank_code:'' }}</span>
                  </template>
                  <span>{{ (item.expance_details)?item.expance_details.bank_name:'' }}</span>
                </v-tooltip>
                <v-tooltip bottom v-else>
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">{{ (item.vendor)?item.vendor.v_code:'' }}</span>
                  </template>
                  <span>{{ (item.vendor)?item.vendor.v_name:'' }}</span>
                </v-tooltip>
              </td>

              <td class="text-left" v-if="pagination.filters.generate_invoice" width="18%">
                <!-- {{getInvoiceGroup(item)}} -->
                {{(item.invoice_group)?item.group_name:''}}
              </td>
              <td
                v-if="!pagination.filters.generate_invoice"
                class="text-center"
                width="9%"
              >{{(item.generated_invoice)?getFormatedDate(item.generated_invoice.created_at):''}}</td>
              <td v-if="!pagination.filters.generate_invoice" class="text-center" width="9%">
                <a
                  v-if="item.generated_invoice && !open_doc_model_falg && !open_log_model_falg && !pagination.filters.generate_invoice"
                  href="javascript:void(0)"
                  @click="viewInvoice(item.generated_inv_id,item.project_id,item.last_invoice_id)"
                  class="blue--text"
                >{{ item.generated_invoice.invoice_number }}</a>
                <span v-else>{{(item.generated_invoice)?item.generated_invoice.invoice_number:''}}</span>
              </td>

              <td class="text-right" width="8%">
                <div v-if="item.generated_invoice">
                  <span
                    :class="{
                    'error--text': item.invoice_amt < 0,
                    'primary--text': item.invoice_amt >  0,
                  }"
                  >${{ getAmountFormat(item.invoice_amt) }}</span>
                </div>
                <div
                  v-if="pagination.filters.generate_invoice && !item.generated_invoice && item.generated_inv_id"
                >
                  <span class="error--text">${{ getInvoiceAmt(item) }}</span>
                </div>
              </td>
              <td width="29%" class="text-left">
                <v-tooltip left max-width="400">
                  <template v-slot:activator="{ on, attrs }">
                    <span
                      v-bind="attrs"
                      v-on="on"
                      style="word-break: break-all;"
                      class="d-inline-block"
                      v-html="(item.description) ? highlightedDescription(item.description.substring(0,40)) : ''"
                    ></span>
                  </template>
                  <span>{{ (item.description) ? item.description : '' }}</span>
                </v-tooltip>
              </td>
              <td width="3%">
                <v-icon
                  :color="(item.parent_id==null && item.childs_count) > 0 ? 'red' :''"
                  v-if="item.parent_id!=null || (item.parent_id==null && item.childs_count > 0)"
                  @click="GetSplitTransactionList(item.parent_id!=null ? item.parent_id : item.trans_id)"
                >mdi-arrow-split-vertical</v-icon>
              </td>
            </tr>
          </template>
          <template v-slot:body.append>
            <tr class="fix-bottom-bar">
              <td class="grey lighten-1 text-center">
                <span
                  class="pr-5"
                  v-if="filter_start_date && filter_start_end"
                >{{filter_start_date}} - {{filter_start_end}}</span>
                <span v-if="isDisplayNetBalance && filter_start_date && filter_start_end">
                  Opening Bal.:
                  <span
                    class="white--text"
                    :class="{
                    'red': opending_balance < 0,
                    'green': opending_balance >= 0,
                  }"
                  >${{ getAmountFormat(opending_balance) }}</span>
                </span>
                <span v-if="pagination.filters.generate_invoice">
                  <b>{{ report_details.multiplier }}{{(report_details.multiplier && report_details.p_price) ? '/': '' }}{{ report_details.p_price ? report_details.p_price : '' }}</b>
                </span>
              </td>
              <td class="grey lighten-1 text-center">
                <span v-if="isDisplayNetBalance && filter_start_date && filter_start_end">
                  Ending Bal.:
                  <span
                    class="white--text"
                    :class="{
                    'red': filter_balance < 0,
                    'green': filter_balance >= 0,
                  }"
                  >${{ getAmountFormat(filter_balance) }}</span>
                </span>
              </td>
              <td class="grey lighten-1 text-center">
                <span class="pr-5">
                  Cr:
                  <span class="green white--text">${{ getAmountFormat(credit) }}</span>
                </span>
                <span class="pr-5">
                  Dr:
                  <span class="red white--text">${{ getAmountFormat(debit) }}</span>
                </span>
                Bal.:
                <span
                  class="white--text"
                  :class="{
                    'red': transaction_balance < 0,
                    'green': transaction_balance >= 0,
                  }"
                >${{ getAmountFormat(transaction_balance) }}</span>
              </td>
              <td class="grey lighten-1 text-center">
                <span v-if="isDisplayNetBalance">
                  Ac. Bal.:
                  <span
                    class="white--text"
                    :class="{
                    'red': account_balance < 0,
                    'green': account_balance >= 0,
                  }"
                  >${{ getAmountFormat(account_balance) }}</span>
                </span>
              </td>
            </tr>
          </template>
          <template v-slot:header.select_all>
            <v-simple-checkbox
              v-model="select_all_checkbox"
              @input="changeSelectAll()"
              color="white"
              :ripple="false"
              class="select-all-checkbox custom-simple-box white_box"
              style="color:#ffffff !important;"
              v-if="!pagination.filters.generate_invoice || (pagination.filters.generate_invoice && pagination.filters.generate_invoice_project!='' && pagination.filters.generate_invoice_project!='undefined' && pagination.filters.generate_invoice_project!=undefined)"
              :disabled="open_doc_model_falg || open_log_model_falg"
            ></v-simple-checkbox>
          </template>
        </v-data-table>
        <div class="v-data-footer custom-pagination fix-footer-bar">
          <v-row dense>
            <v-col cols="4" class="d-flex align-center justify-end">
              <span>Total Record: {{items.total}}</span>
              <div class="v-data-footer__select pl-5">
                Rows per page:
                <v-select
                  v-model="pagination.itemsPerPage"
                  :items="pagination_settings.perPageList"
                  dense
                  hide-details
                  class
                  width="100px;"
                ></v-select>
              </div>
            </v-col>
            <v-col cols="8" class="d-flex align-center justify-start">
              <v-pagination
                class="d-flex align-center justify-start"
                v-model="pagination.page"
                :length="items.last_page"
                total-visible="22"
              ></v-pagination>
            </v-col>
            <!-- <v-col cols="2" class="d-flex align-center justify-start">
              Move to 
              <v-text-field
              class="pl-1 pr-1"
                v-model="move_to_page"
                single-line
                hide-details
                dense
                outlined=""
                clearable
                v-debounce:500="changePage"
                style="max-width: 83px;"
                @click:clear="pagination.page = 1; move_to_page = null; getTransaction()"
                dark
              >
              </v-text-field>
              Page
            </v-col>-->
          </v-row>
        </div>
      </v-card-text>
      <v-card-text
        class="pa-0 mx-auto"
        v-if="pagination.filters.filter_by == 6 && !pagination.filters.generate_invoice"
      >
        <v-data-table
          :headers="invoice_list_headers"
          class="elevation-1 rounded-0 my-transaction-table fix-table-layout fix-table-header"
          :search="search"
          :items="items.data"
          :items-per-page="pagination.itemsPerPage"
          hide-default-footer
          :page.sync="pagination.page"
          mobile-breakpoint="50"
          dense
          item-key="trans_id"
          :options.sync="pagination"
          sort-by="vendor_id"
        >
          <template v-slot:item="{ item }">
            <tr :class="invoice_row_backgroup_color(item)">
              <td class="text-start" width="2%">
                <v-simple-checkbox
                  v-model="item.selected"
                  :ripple="false"
                  class="custom-simple-box"
                ></v-simple-checkbox>
              </td>
              <td width="10%" class="text-center">{{getFormatedDate(item.created_at)}}</td>
              <td width="10%" class="text-center">
                <a
                  href="javascript:void(0)"
                  @click="viewInvoice(item.generated_inv_id,item.project_id,item.last_invoice_id)"
                  class="blue--text"
                >{{item.invoice_number}}</a>
                <v-btn class="ml-4 header_btn" icon>
                  <v-icon
                    size="20px"
                    @click="viewInvoice(item.generated_inv_id,item.project_id,item.last_invoice_id)"
                  >mdi-clipboard-edit-outline</v-icon>
                </v-btn>
              </td>
              <td width="23%">{{item.project ? item.project.p_name: ''}}</td>
              <td
                width="10%"
                class="text-right"
                :class="{
                'error--text':item.amount < 0,
                'primary--text': item.amount > 0,
              }"
              >
                <span class="mr-2">${{getAmountFormat(parseFloat(item.amount).toFixed(2))}}</span>
              </td>
              <td width="10%" class="text-right">
                <span
                  class="mr-2"
                >{{(item.period_to)?getFormatedDate(item.period_to):getFormatedDate(item.project.created_at)}}</span>
              </td>
              <td width="13%" class="primary--text text-right">
                <span
                  class="mr-2"
                >{{item.received_amount ? '$'+ parseFloat(item.received_amount).toFixed(2) : ''}}</span>
              </td>
              <td
                width="13%"
                class="text-right mr-2"
                :class="{
                'error--text':getInvoiceBalance(item) < 0,
                'primary--text': getInvoiceBalance(item) > 0,
              }"
              >
                <span class="mr-2">{{getInvoiceBalance(item)}}</span>
              </td>
              <td width="9%" class="text-right">
                <v-icon @click="GetSalesIncomeTransactionList(item.generated_inv_id)">mdi-file-chart</v-icon>
              </td>
            </tr>
          </template>
          <template v-slot:body.append>
            <tr class="fix-bottom-bar">
              <td width="10%" class="text-center">Total</td>
              <td width="10%" class="text-center"></td>
              <td width="25%"></td>
              <td
                width="10%"
                class="text-right"
                :class="{
                'error--text': total_amt_of_invoice < 0,
                'primary--text': total_amt_of_invoice > 0,
              }"
              >{{(total_amt_of_invoice)?'$'+getAmountFormat(parseFloat(total_amt_of_invoice).toFixed(2)):''}}</td>
              <td
                width="22%"
                class="text-right"
                :class="{
                'error--text': total_received_amt < 0,
                'primary--text': total_received_amt > 0,
              }"
              >{{(total_received_amt)?'$'+getAmountFormat(parseFloat(total_received_amt).toFixed(2)):''}}</td>
              <td
                width="13%"
                class="text-right"
                :class="{
                'error--text': total_balance_due < 0,
                'primary--text': total_balance_due > 0,
              }"
              >{{(total_balance_due)?'$'+getAmountFormat(parseFloat(total_balance_due).toFixed(2)):''}}</td>
              <td width="22%"></td>
            </tr>
          </template>
        </v-data-table>
        <div class="v-data-footer custom-pagination fix-footer-bar">
          <v-row dense>
            <v-col cols="4" class="d-flex align-center justify-end">
              <span>Total Record: {{items.total}}</span>
              <div class="v-data-footer__select pl-5">
                Rows per page:
                <v-select
                  v-model="pagination.itemsPerPage"
                  :items="pagination_settings.perPageList"
                  dense
                  hide-details
                  class="pagination_settings"
                  width="100px;"
                ></v-select>
              </div>
            </v-col>
            <v-col cols="8" class="d-flex align-center justify-start">
              <v-pagination
                class="d-flex align-center justify-start"
                v-model="pagination.page"
                :length="items.last_page"
                total-visible="22"
              ></v-pagination>
            </v-col>
          </v-row>
        </div>
      </v-card-text>
    </v-card>

    <v-dialog v-model="import_dailog" max-width="500" persistent>
      <v-card :loading="import_dailog_loading">
        <v-card-title class="headline d-flex justify-center">
          Import Transactions
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                small
                dark
                v-bind="attrs"
                v-on="on"
                class="header_btn ml-5"
                color="#757575"
                @click="downloadSampleExcel()"
              >
                <v-icon size="28px">mdi-download</v-icon>
                <span class="lable_class">Download</span>
              </v-btn>
            </template>
            <span>Download Sample File</span>
          </v-tooltip>
        </v-card-title>
        <v-card-text>
          <v-row dense>
            <v-col cols="5" class="d-flex align-center justify-center">Bank</v-col>
            <v-col cols="7">
              <v-select
                :items="active_banks"
                v-model="selected_bank"
                hide-details
                item-text="bank_name"
                item-value="bank_id"
                outlined
                dense
                placeholder="Select"
                @change="getBankStatistics()"
              ></v-select>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="5" class="d-flex align-center justify-center">File</v-col>
            <v-col cols="7">
              <v-file-input
                accept=".csv, .xlsx, .xls"
                v-model="selected_file"
                @change="updateFile"
                hide-details
                outlined
                placeholder="Select"
                dense
              >
                <template v-slot:selection>
                  <span class="grey--text caption">1 File Selected</span>
                </template>
              </v-file-input>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12">
              <v-card flat color="accent" v-if="selected_file">
                <v-card-text class="white--text pa-1">
                  <v-icon
                    dense
                    class="white--text"
                    style="position: absolute;"
                  >mdi-file-document-outline</v-icon>
                  <span class="pl-6">{{(selected_file)?selected_file.name:''}}</span>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <v-row dense v-for="(item, index) in db_column" :key="index">
            <v-col cols="4" class="d-flex align-center justify-center">
              <span :style="{ color: item.color }">{{item.label}}</span>
            </v-col>
            <v-col cols="8" class="d-flex">
              <v-select
                v-if="item.field == 'trans_date'"
                outlined
                :items="date_columns"
                hide-details
                placeholder="Select"
                dense
                v-model="db_column[index].value"
                :error-messages="db_column[index].error"
              ></v-select>

              <v-select
                v-if="item.field == 'description'"
                outlined
                placeholder="Select"
                :items="description_columns"
                hide-details
                dense
                v-model="db_column[index].value"
                :error-messages="db_column[index].error"
              ></v-select>
              <v-select
                v-if="item.field == 'amount'"
                outlined
                placeholder="Select"
                :items="amount_columns"
                hide-details
                dense
                v-model="db_column[index].value"
                :error-messages="db_column[index].error"
                style="width:50% !important;"
              ></v-select>
              <v-select
                v-if="item.field == 'amount'"
                outlined
                placeholder="Credit type"
                :items="credit_type_list"
                hide-details
                dense
                v-model="credit_type"
                style="width:50%  !important;margin-left: 10px;"
              ></v-select>
              <v-select
                v-if="item.field == 'amount2'"
                outlined
                placeholder="Select"
                :items="amount_columns"
                hide-details
                dense
                v-model="db_column[index].value"
                :error-messages="db_column[index].error"
                style="width:50%  !important;"
              ></v-select>
              <v-select
                v-if="item.field == 'amount2'"
                outlined
                placeholder="Debit type"
                :items="debit_type_list"
                hide-details
                dense
                v-model="debit_type"
                style="width:50% !important;margin-left: 10px;"
              ></v-select>
            </v-col>
          </v-row>
          <v-row v-if="bank_statistic" no-gutters>
            <v-card tile outlined>
              <v-card-title>Last Import Statistics</v-card-title>
              <v-card-text>
                <div class="d-flex flex-wrap">
                  <v-row dense style="width:100%">
                    <v-col cols="5">Import Date</v-col>
                    <v-col
                      cols="7"
                    >{{ bank_statistic.created_at ? getFormatedDate(bank_statistic.created_at):'' }}</v-col>
                    <v-col cols="5">Last Transaction Date</v-col>
                    <v-col
                      cols="7"
                    >{{ bank_statistic.last_transaction_date ? getFormatedDate(bank_statistic.last_transaction_date):'' }}</v-col>
                    <v-col cols="12">
                      <!-- <v-chip class="ma-1 text-truncate" color="accent" text-color="white">
                        <v-avatar left>
                          <v-icon>mdi-file-document-outline</v-icon>
                        </v-avatar>
                        {{ bank_statistic.file_name }}
                      </v-chip>-->
                      <!-- <v-chip>
                        {{ bank_statistic.file_name }}
                      </v-chip>-->
                      <v-card flat color="accent">
                        <v-card-text class="white--text pa-1">
                          <v-icon
                            dense
                            class="white--text"
                            style="position: absolute;"
                          >mdi-file-document-outline</v-icon>
                          <span
                            class="pl-6"
                          >{{ bank_statistic.file_name ?bank_statistic.file_name:'' }}</span>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </div>
              </v-card-text>
            </v-card>
          </v-row>
        </v-card-text>
        <v-card-actions class="import-btn">
          <v-btn color="error" dark @click="import_dailog = false">Close</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            :disabled="disableImportBtn"
            color="primary"
            dark
            @click="importData"
            :loading="import_dailog_loading"
          >Import</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="split_dailog" max-width="500" persistent :loading="split_dailog_loading">
      <v-card>
        <v-card-title>
          Split Transaction
          <span v-if="main_amount" class="ml-1">
            (Main Amt:
            <span
              :class="{
                'error--text': main_amount < 0,
                'primary--text': main_amount > 0,
              }"
            >${{ getAmountFormat(main_amount) }}</span>)
          </span>
        </v-card-title>
        <v-card-text v-if="selectedRows.length">
          <v-row dense>
            <v-col>
              <b>Transaction Date</b>
            </v-col>
            <v-col>{{ getFormatedDate(selectedRows[0].trans_date) }}</v-col>
          </v-row>
          <v-row dense>
            <v-col>
              <b>Amount</b>
            </v-col>
            <v-col>
              <span
                :class="{
                  'error--text': selectedRows[0].rev_amount < 0,
                  'primary--text': selectedRows[0].rev_amount > 0,
                }"
              >${{ getAmountFormat(selectedRows[0].rev_amount) }}</span>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col>
              <b>Description</b>
            </v-col>
            <v-col>{{ selectedRows[0].description }}</v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <v-select
                :items="order_types"
                label="Status"
                dense
                outlined
                v-model="project_selected_status"
                @change="getProjectByStatus()"
                placeholder="All"
                hide-details
              ></v-select>
            </v-col>
            <v-col cols="8">
              <v-autocomplete
                dense
                :items="project_of_selected_status"
                v-model="split_project_id"
                outlined
                hide-details
                clearable
                label="Project"
                @clear="project_group_list=[]"
              >
                <template v-slot:item="{ index, item }">
                  <div v-if="item.text == 'No Project'" class="v-list-item__content">
                    <div
                      class="v-list-item__title error--text"
                      style="font-size: 15px"
                    >{{ item.text }}</div>
                  </div>
                  <div v-else class="v-list-item__content">
                    <div class="v-list-item__title">{{ item.text }}</div>
                  </div>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="4">
              <v-select
                :items="order_types"
                label="Status"
                dense
                outlined
                v-model="vendor_selected_status"
                @change="getTransactionSelectors()"
                placeholder="All"
                hide-details
              ></v-select>
            </v-col>
            <v-col cols="8">
              <v-autocomplete
                dense
                :items="expence_list"
                v-model="split_vendor_id"
                outlined
                hide-details
                v-if="split_expence"
                clearable
                class="focus-on-vendor-expence3"
                label="Chart Of Account"
              >
                <template v-slot:prepend-item>
                  <a
                    class="pl-4"
                    @click="
                      split_expence = false;
                      setFocus('focus-on-vendor-expence3');
                    "
                  >Select Vendor</a>
                  <v-divider></v-divider>
                </template>
              </v-autocomplete>

              <v-autocomplete
                dense
                :items="vendor_list"
                v-model="split_vendor_id"
                outlined
                hide-details
                clearable
                label="Vendor"
                class="focus-on-vendor-expence3"
                v-else
              >
                <template v-slot:prepend-item>
                  <a
                    class="pl-4"
                    @click="
                      split_expence = true;
                      setFocus('focus-on-vendor-expence3');
                    "
                  >Select Chart of Account</a>
                  <v-divider></v-divider>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                dense
                outlined
                v-model="split_amount"
                type="number"
                label="Split Amount"
                :autofocus="split_dailog"
                :error-messages="split_amount_error"
                :hide-details="split_amount_error"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="split_dailog = false">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            v-if="!isNaN(split_amount)"
            @click="splitBill"
            :loading="split_dailog_loading"
          >Split</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="keywords.dialog" max-width="500" persistent>
      <v-card :loading="keywords.loading">
        <v-card-title class="headline">Keywords</v-card-title>
        <v-card-text v-if="keywords.dialog">
          <v-row dense>
            <!-- <v-col cols="12" v-if="keywords.item.trans_type_id">
              <h3>
                <v-row dense>
                  <v-col cols="10">{{keywords.info.type.title}} ({{keywords.type.length}} Selected)</v-col>
                  <v-col cols="2" class="text-right">Type</v-col>
                </v-row>
              </h3>
              <span>
                <v-combobox
                  v-model="keywords.type"
                  :items="keywords.type"
                  placeholder=" "
                  multiple
                  outlined
                  dense
                  hide-details
                >
                  <template v-slot:selection></template>
                </v-combobox>
              </span>
            </v-col>-->
            <v-col cols="12" v-if="keywords.item.vendor_id && !keywords.item.expence">
              <h3>
                <v-row dense>
                  <v-col
                    cols="10"
                  >{{keywords.info.vendor.v_name}} ({{keywords.vendors.length}} Selected)</v-col>
                  <v-col cols="2" class="text-right">Vendor</v-col>
                </v-row>
              </h3>
              <span>
                <v-combobox
                  v-model="keywords.vendors"
                  :items="keywords.vendors"
                  placeholder=" "
                  multiple
                  outlined
                  dense
                  hide-details
                >
                  <template v-slot:selection></template>
                </v-combobox>
              </span>
            </v-col>
            <v-col cols="12" v-if="keywords.item.vendor_id && keywords.item.expence">
              <h3>
                <v-row dense>
                  <v-col
                    cols="8"
                  >{{keywords.info.expence.bank_name}} ({{keywords.expences.length}} Selected)</v-col>
                  <v-col cols="4" class="text-right">Chart Of Account</v-col>
                </v-row>
              </h3>
              <span>
                <v-combobox
                  v-model="keywords.expences"
                  :items="keywords.expences"
                  placeholder=" "
                  multiple
                  outlined
                  dense
                  hide-details
                >
                  <template v-slot:selection></template>
                </v-combobox>
              </span>
            </v-col>
            <v-col cols="12" v-if="keywords.item.project_id">
              <h3>
                <v-row dense>
                  <v-col
                    cols="10"
                  >{{keywords.info.project.p_name}} ({{keywords.project.length}} Selected)</v-col>
                  <v-col cols="2" class="text-right">Project</v-col>
                </v-row>
              </h3>
              <span>
                <v-combobox
                  v-model="keywords.project"
                  :items="keywords.project"
                  placeholder=" "
                  multiple
                  outlined
                  dense
                  hide-details
                >
                  <template v-slot:selection></template>
                </v-combobox>
              </span>
            </v-col>

            <v-col cols="12" v-if="keywords.item && keywords.item.invoice_group_id">
              <h3>
                <v-row dense>
                  <v-col
                    cols="9"
                  >{{keywords.info.invoice_group.name}} ({{keywords.invoice_group.length}} Selected)</v-col>
                  <v-col cols="3" class="text-right">Invoice Group</v-col>
                </v-row>
              </h3>
              <span>
                <v-combobox
                  v-model="keywords.invoice_group"
                  :items="keywords.invoice_group"
                  placeholder=" "
                  multiple
                  outlined
                  dense
                  hide-details
                >
                  <template v-slot:selection></template>
                </v-combobox>
              </span>
            </v-col>

            <v-col>
              <h3>Description</h3>
              <span>{{ keywords.item.description }}</span>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="keywords.dialog = false">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" :disabled="keywords.loading" @click="saveKeywords(true)">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="delete_dialog" max-width="400">
      <v-card>
        <v-card-title class="headline">Confirmation</v-card-title>
        <v-card-text>Are you sure you want to delete selected transactions?</v-card-text>
        <v-card-actions class="pa-0">
          <v-spacer></v-spacer>
          <v-btn color="dark darken-1" text @click="delete_dialog = false">Cancel</v-btn>
          <v-btn
            color="red darken-1"
            text
            @click="delete_dialog = false; deleteTransactions()"
          >Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="misc_delete_dialog" max-width="400">
      <v-card>
        <v-card-title class="headline">Confirmation</v-card-title>
        <v-card-text>Are you sure you want to delete selected transaction's invoice Assignment?</v-card-text>
        <v-card-actions class="pa-0">
          <v-spacer></v-spacer>
          <v-btn color="dark darken-1" text @click="misc_delete_dialog = false">Cancel</v-btn>
          <v-btn
            color="red darken-1"
            text
            @click="misc_delete_dialog = false; deleteMiscAssignTransactions()"
          >Delete Invoice Assignment</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="remove_selection_confirmation" max-width="400">
      <v-card>
        <v-card-title class="headline">Confirmation</v-card-title>
        <v-card-text>Are you sure you want to delete {{remove_selection_flag}} on selected transactions?</v-card-text>
        <v-card-actions class="pa-0">
          <v-spacer></v-spacer>
          <v-btn color="dark darken-1" text @click="remove_selection_confirmation = false">Cancel</v-btn>
          <v-btn
            color="red darken-1"
            text
            @click="remove_selection_confirmation = false; removeSelection()"
          >Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="delete_invoice_dialog" max-width="320">
      <v-card>
        <v-card-title class="headline">Confirmation</v-card-title>
        <v-card-text>Are you sure want to delete this invoice?</v-card-text>
        <v-card-actions class="pa-0">
          <v-spacer></v-spacer>
          <v-btn color="dark darken-1" text @click="delete_invoice_dialog = false">Cancel</v-btn>
          <v-btn color="red darken-1" text @click="deleteInvoiceFromReport">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="report_text_dialog" max-width="900" persistent>
      <v-card :loading="report_text_loading">
        <v-card-title class="headline">Update Text</v-card-title>
        <v-card-text>
          <v-row dense>
            <v-col cols="12">
              <vue-editor v-model="report_text_data.text" :editor-toolbar="customToolbar" />
            </v-col>
            <v-col cols="12">
              <v-row
                dense
                class="report-header2"
                v-if="report_text_data.report == '1' && report_text_data.section  == '14'"
              >
                <v-col cols="12">
                  <b>Below are short code for dynamic value:</b>
                </v-col>
                <v-col cols="12">{amount}</v-col>
                <v-col cols="12">{amount_in_word}</v-col>
              </v-row>
              <v-row
                dense
                class="report-header2"
                v-if="report_text_data.report == '2' && report_text_data.section  == '1'"
              >
                <v-col cols="12">
                  <b>Below are short code for dynamic value:</b>
                </v-col>
                <v-col cols="12">{amount_in_word}</v-col>
                <v-col cols="12">{project_details}</v-col>
              </v-row>
              <v-row
                dense
                class="report-header2"
                v-if="report_text_data.report == '3' && report_text_data.section  == '1'"
              >
                <v-col cols="12">
                  <b>Below are short code for dynamic value:</b>
                </v-col>
                <v-col cols="12">{balance}</v-col>
                <v-col cols="12">{project_name}</v-col>
                <v-col cols="12">{customer_address}</v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="report_text_dialog = false">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            class="text-capitalize"
            @click="updateReportText('no')"
          >Update for this project</v-btn>
          <v-btn
            color="primary"
            class="text-capitalize"
            @click="updateReportText('yes')"
          >Update Template</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="preview_pdf_dialog" max-width="800" persistent>
      <v-card :loading="preview_pdf_loading">
        <v-card-text>
          <v-row dense>
            <v-col cols="12">
              <iframe :src="preview_page_link" frameborder="0" style="width:100%;height:800px"></iframe>
              <!-- <iframe
                :src="'https://docs.google.com/gview?embedded=true&url='+preview_page_link"
                frameborder="0"
                style="width:100%;height:800px"
              ></iframe>-->
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="error"
            @click="preview_pdf_dialog = false; user_sign_blob = []; customer_sign_blob = ''; active_page = 0;"
          >Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            class="text-capitalize"
            @click="saveReport()"
            :loading="preview_pdf_loading"
          >{{(total_page == active_page)?'Finish':'Next Page'}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="confirm_date_dialog" width="430px">
      <v-card>
        <v-card-title class="headline">Confirmation</v-card-title>
        <v-card-text>
          <p>Opening balance is greater than starting date for below bank.Are you want to generate?</p>
          <b class="mb-2">Date range : {{actual_start_date}} to {{change_end_date}}</b>
          <template>
            <v-data-table
              :headers="headers_outRange"
              class="elevation-1"
              :items="outofdate_bank_list.data"
            ></v-data-table>
          </template>
          <template v-slot:item="{ item }">
            <tr>
              <td width="50%">
                {{
                item
                }}
              </td>
              <td width="50%" class="text-right">
                {{
                item
                }}
              </td>
            </tr>
          </template>
        </v-card-text>
        <v-card-actions class="pa-0">
          <v-spacer></v-spacer>
          <v-btn color="dark darken-1" text @click="CloseOpeningDialog()">Cancel</v-btn>
          <v-btn color="red darken-1" text @click="ChangeStartdate()">Confirm</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="generate_invoice_project_list_popup" width="430px">
      <v-card>
        <v-card-title class="headline">Project List</v-card-title>
        <v-card-text>
          <v-autocomplete
            dense
            flat
            :items="project_list_with_work_type"
            item-text="p_name"
            item-value="project_id"
            outlined
            label="Project"
            hide-details
            small
            class="body-2"
            placeholder="All"
            clearable
            v-model="project_without_transaction"
          ></v-autocomplete>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="error"
            @click="generate_invoice_project_list_popup=false;project_without_transaction=false;"
          >Cancel</v-btn>
          <v-spacer></v-spacer>

          <v-btn
            :loading="loading"
            color="primary"
            class="pr-3 text-capitalize"
            :disabled="!project_without_transaction"
            @click="generate_invoice_project_list_popup=false;generateInvoiceWithoutTransaction()"
          >Generate Invoice</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="split_list_dialogue" width="800px">
      <v-card>
        <v-card-text>
          <v-row>
            <v-col cols="12" text-right>
              <v-card-title
                class="headline d-inline"
              >{{split_id ? 'Split Transaction' : 'Sales Income List' }}</v-card-title>
              <v-btn
                icon
                class="ml-4 header_btn float-right d-flex"
                @click="split_id ? GetSplitTransactionListFilter() : GetSalesIncomeTransactionListFilter() "
              >
                <v-icon size="28px">{{split_id ? 'mdi-arrow-split-vertical' : 'mdi-file-chart'}}</v-icon>
                <!-- <span class="lable_class">View</span> -->
              </v-btn>
            </v-col>
          </v-row>
          <v-data-table
            :headers="split_list_header"
            class="elevation-1 rounded-0 my-transaction-table"
            :items="split_list"
            :items-per-page="-1"
            dense
            fix-header
            hide-default-footer
            disable-pagination
            style="max-height:500px !important;overflow:auto"
          >
            <template v-slot:item="{ item }">
              <tr>
                <td width="14%" class="text-left">
                  <span :title="item.bank_id ? item.bank.bank_name : ''">
                    {{
                    item.bank_id ? item.bank.bank_code : ""
                    }}
                  </span>
                </td>
                <td width="14%" class="text-left">{{ getFormatedDate(item.trans_date) }}</td>
                <td width="14%" class="text-right">
                  <div>
                    <span
                      :class="{
                            'error--text': item.rev_amount < 0,
                            'primary--text': item.rev_amount > 0,
                          }"
                    >${{ getAmountFormat(item.rev_amount) }}</span>
                  </div>
                </td>
                <td
                  width="14%"
                  class="text-center"
                >{{ (item.generated_invoice && item.generated_invoice.invoice_number ? item.generated_invoice.invoice_number:'') }}</td>

                <td width="14%" class="text-right">
                  <div v-if="item.generated_invoice">
                    <span
                      :class="{
                    'error--text': item.invoice_amt < 0,
                    'primary--text': item.invoice_amt >  0,
                  }"
                    >${{ getAmountFormat(item.invoice_amt) }}</span>
                  </div>
                  <div v-if="!item.generated_invoice && item.generated_inv_id">
                    <span class="error--text">${{ getInvoiceAmt(item) }}</span>
                  </div>
                </td>
                <td class="text-left" width="14%">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">{{ (item.project)?item.project.p_code:'' }}</span>
                    </template>
                    <span>{{ (item.project)?item.project.p_name:'' }}</span>
                  </v-tooltip>
                </td>
                <td class="text-left" width="14%">
                  <v-tooltip bottom v-if="item.expence">
                    <template v-slot:activator="{ on, attrs }">
                      <span
                        v-bind="attrs"
                        v-on="on"
                      >{{ (item.expance_details)?item.expance_details.bank_code:'' }}</span>
                    </template>
                    <span>{{ (item.expance_details)?item.expance_details.bank_name:'' }}</span>
                  </v-tooltip>
                  <v-tooltip bottom v-else>
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">{{ (item.vendor)?item.vendor.v_code:'' }}</span>
                    </template>
                    <span>{{ (item.vendor)?item.vendor.v_name:'' }}</span>
                  </v-tooltip>
                </td>
              </tr>
            </template>
            <template v-slot:body.append>
              <tr>
                <td colspan="2">
                  <b>Total</b>
                </td>
                <td
                  class="text-right"
                  :class="{
                              'error--text': split_list_total < 0,
                              'primary--text': split_list_total > 0,
                            }"
                >
                  <b>${{getAmountFormat(split_list_total)}}</b>
                </td>
                <td colspan="4"></td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <Upload />
    <DocList />
    <LogList />
    <Signatura
      :customer_sign="customer_sign_blob"
      :active_page="active_page"
      @updateValue="updateParent"
      @clearValue="clearParent"
      :project_details="project_details"
      :signature_dialog="signature_dialog"
    />
    <SingleUpdate
      :single_update_tran="single_update_tran"
      :selected_item="selected_item"
      :project_of_selected_status="project_of_selected_status"
      @closePopup="single_update_tran = false"
      @updateValue="refreshTransactions"
    />
    <MultipleUpdate
      @deleteSelection="deleteSelection"
      :multi_update_tran="multi_update_tran"
      :selected_items="selectedRows"
      :project_of_selected_status="project_of_selected_status"
      @closePopup="multi_update_tran = false"
      @updateValue="refreshTransactions"
    />
    <SendMailDialog
      :email_id="email_ids"
      :email_dialog="email_dialog"
      @closeDialog="closeSendMailDialog"
      @sendMail="sendMail"
    />
    <GenerateInvoice
      :is_generate_invoice="is_generate_invoice"
      :is_update_invoice="is_update_invoice"
      :generate_invoice_id="this.pagination.filters.generated_inv_id"
      :project_details="invoice_project_data"
      @successGenerateInvoice="pagination.perPageList=25;pagination.filters.generate_invoice = false;pagination.filters.filter_by= '6'"
      @closeDialog="is_generate_invoice = false;is_update_invoice= false;"
      :selected_rows="selectedRows"
    />
    <GenerateInvoiceForCostPlus
      :is_generate_invoice_for_cost_plus="is_generate_invoice_for_cost_plus"
      :is_update_invoice="is_update_invoice"
      :generate_invoice_id="this.pagination.filters.generated_inv_id"
      :project_details="invoice_project_data"
      @successGenerateInvoice="pagination.perPageList=25;pagination.filters.generate_invoice = false;pagination.filters.filter_by= '6'"
      @closeDialog="is_generate_invoice_for_cost_plus = false;is_update_invoice= false;"
      :selected_rows="selectedRows"
    />

    <SalesInvoiceReport
      :project_details="(selectedRows[0])?selectedRows[0].project:{}"
      :report_header_name="report_header_name"
      :sales_invoice_report="sales_invoice_report"
      @updateValue="sales_invoice_report = false"
      v-if="selectedRows[0] && selectedRows[0].project"
    />
    <CounterTopSalesInvoiceReport
      :project_details="(selectedRows[0])?selectedRows[0].project:{}"
      :report_header_name="report_header_name"
      :counter_top_sales_invoice_report="counter_top_sales_invoice_report"
      @updateValue="counter_top_sales_invoice_report = false"
      v-if="selectedRows[0] && selectedRows[0].project"
    />
    <CounterTopOrderReport
      :project_details="(selectedRows[0])?selectedRows[0].project:{}"
      :report_header_name="report_header_name"
      :counter_top_order_report="counter_top_order_report"
      @updateValue="counter_top_order_report = false"
      v-if="selectedRows[0] && selectedRows[0].project"
    />
    <AcceptanceReport
      :project_details="(selectedRows[0])?selectedRows[0].project:{}"
      :report_header_name="report_header_name"
      :acceptance_report="acceptance_report"
      @updateValue="acceptance_report = false"
      v-if="selectedRows[0] && selectedRows[0].project"
    />
    <G702Report
      :project_details="(selectedRows[0])?selectedRows[0].project:{}"
      :report_header_name="report_header_name"
      :g702_report="g702_report"
      :g702_change_report="g702_change_report"
      @updateValue="g702_report = false"
      :invoice_id="selectedRows[0] ? selectedRows[0].generated_inv_id :''"
      v-if="selectedRows[0] && selectedRows[0].project"
    />
    <G703Report
      :project_details="(selectedRows[0])?selectedRows[0].project:{}"
      :report_header_name="report_header_name"
      :g703_report="g703_report"
      :g703_change_report="g703_change_report"
      @updateValue="g703_report = false"
      :invoice_id="selectedRows[0] ? selectedRows[0].generated_inv_id :''"
      v-if="selectedRows[0] && selectedRows[0].project"
    />
    <G703CostPlusReport
      :project_details="(selectedRows[0])?selectedRows[0].project:{}"
      :report_header_name="report_header_name"
      :g703_cost_plus_report="g703_cost_plus_report"
      :g703_cost_plus_change_report="g703_cost_plus_change_report"
      @updateValue="g703_cost_plus_report = false"
      :invoice_id="selectedRows[0] ? selectedRows[0].generated_inv_id :''"
      v-if="selectedRows[0] && selectedRows[0].project"
    />
    <!-- <ContractReport
      :project_details="(selectedRows[0])?selectedRows[0].project:{}"
      :report_header_name="report_header_name"
      :contract_report="contract_report"
      @updateValue="contract_report = false"
      v-if="selectedRows[0] && selectedRows[0].project"
    />-->
    <PartialLienReleaseReport
      :project_details="(selectedRows[0])?selectedRows[0].project:{}"
      :report_header_name="report_header_name"
      :partial_lien_release_report="partial_lien_release_report"
      @updateValue="partial_lien_release_report = false"
      :invoice_id="selectedRows[0] ? selectedRows[0].generated_inv_id :''"
      v-if="selectedRows[0] && selectedRows[0].project"
    />
    <FinalLienReleaseReport
      :project_details="(selectedRows[0])?selectedRows[0].project:{}"
      :report_header_name="report_header_name"
      :final_lien_release_report="final_lien_release_report"
      @updateValue="final_lien_release_report = false"
      v-if="selectedRows[0] && selectedRows[0].project"
    />
    <GenerateInvoiceForGenerateInvoice
      :is_generate_invoice_for_generate_invoice="is_generate_invoice_for_generate_invoice"
      :report_header_name="report_header_name"
      :is_update_invoice="is_update_invoice"
      :generate_invoice_id="this.pagination.filters.generated_inv_id"
      :project_details="invoice_project_data"
      @successGenerateInvoice="pagination.perPageList=25;pagination.filters.generate_invoice = false;pagination.filters.filter_by= '6'"
      @closeDialog="is_generate_invoice_for_generate_invoice = false;is_update_invoice= false;"
      :selected_rows="selectedRows"
    />
  </div>
</template>

<script>
import { VueEditor } from "vue2-editor";
import axios from "../../plugins/axios";
import Upload from "../document/Upload";
import DocList from "../document/List";
import LogList from "../log/List";
import Signatura from "../projects/Signatura";
import SingleUpdate from "../Transaction/SingleUpdate";

import SalesInvoiceReport from "../projects/SalesInvoiceReport";
import CounterTopSalesInvoiceReport from "../projects/CounterTopSalesInvoiceReport";
import G702Report from "../projects/G702Report";
import G703Report from "../projects/G703Report";
import G703CostPlusReport from "../projects/G703CostPlusReport";
// import ContractReport from "../projects/ContractReport";
import PartialLienReleaseReport from "../projects/PartialLienReleaseReport";
import FinalLienReleaseReport from "../projects/FinalLienReleaseReport";
import CounterTopOrderReport from "../projects/CounterTopOrderReport";
import AcceptanceReport from "../projects/AcceptanceReport";

import MultipleUpdate from "../Transaction/MultipleUpdate";
import GenerateInvoice from "../Transaction/GenerateInvoice";
import GenerateInvoiceForCostPlus from "../Transaction/GenerateInvoiceForCostPlus";
import GenerateInvoiceForGenerateInvoice from "../Transaction/GenerateInvoiceForGenerateInvoice";
import SendMailDialog from "../projects/SendMailDialog";
import {
  parseParams,
  getCompanyDetails,
  getAmountInWord,
  getTotalOrderAmountwithAllcalculation,
  logout
} from "../../plugins/helper";
import { mapMutations, mapState } from "vuex";
import moment from "moment";
// import { jsPDF } from "jspdf";
//import * as htmlToImage from 'html-to-image';
export default {
  name: "TransactionList",
  components: {
    Upload,
    DocList,
    LogList,
    VueEditor,
    Signatura,
    SingleUpdate,
    MultipleUpdate,
    SendMailDialog,
    G702Report,
    G703Report,
    G703CostPlusReport,
    // ContractReport,
    GenerateInvoice,
    GenerateInvoiceForCostPlus,
    SalesInvoiceReport,
    CounterTopSalesInvoiceReport,
    PartialLienReleaseReport,
    FinalLienReleaseReport,
    CounterTopOrderReport,
    AcceptanceReport,
    GenerateInvoiceForGenerateInvoice
  },
  data() {
    return {
      cancelToken: "",
      source: "",
      invoice_project_data: {},
      sales_invoice_report: false,
      counter_top_sales_invoice_report: false,
      counter_top_order_report: false,
      acceptance_report: false,
      g702_report: false,
      g703_report: false,
      g702_change_report: false,
      g703_change_report: false,
      g703_cost_plus_change_report: false,
      g703_cost_plus_report: false,
      report_menu: false,
      closeOnContentClick: false,
      // contract_report: false,
      partial_lien_release_report: false,
      final_lien_release_report: false,
      is_generate_invoice: false,
      is_generate_invoice_for_cost_plus: false,
      is_generate_invoice_for_generate_invoice: false,
      is_update_invoice: false,
      is_project_unchecked: false,
      split_list_dialogue: false,
      split_list_total: null,
      split_list: [],
      project_date: null,
      bank_date: null,
      vendor_date: null,
      report_header_name: "",
      credit_type: "payment",
      debit_type: "expense",
      // project_selected_status: "all",
      set_date_default: false,
      vendor_selected_status: "all",
      credit_type_list: [
        { text: "Payment", value: "payment" },
        { text: "Expense", value: "expense" }
      ],
      debit_type_list: [
        { text: "Payment", value: "payment" },
        { text: "Expense", value: "expense" }
      ],
      project_work: [
        { text: "New Construction", value: "new_construction" },
        { text: "Remodeling", value: "remodeling" },
        { text: "General Invoice", value: "retail_sales" },
        { text: "Counter Tops", value: "counter_tops" }
      ],
      customToolbar: [
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        ["bold", "italic", "underline", "strike"], // toggled buttons
        [
          { align: "" },
          { align: "center" },
          { align: "right" },
          { align: "justify" }
        ],
        //["blockquote", "code-block"],
        [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
        [{ indent: "-1" }, { indent: "+1" }],
        [{ color: [] }, { background: [] }],
        ["link", "image", "video"],
        //["clean"],
        // This is what I have added
        [{ size: ["small", false, "large"] }]
      ],
      email_id_arr: [],
      preview_pdf_loading: "",
      total_page: "",
      active_page: 0,
      preview_page_link: "",
      preview_pdf_dialog: false,
      selected_item: {},
      signature_dialog: false,
      project_details: {},
      user_sign_blob: [],
      customer_sign_blob: "",
      is_send_report: false,
      email_ids: null,
      email_ids_error: null,
      email_dialog: false,
      send_pdf_loading: false,
      printing_report: false,
      open_doc_model_falg: false,
      open_log_model_falg: false,
      disable_generate_invoice: false,
      total_amt_of_invoice: null,
      total_received_amt: null,
      total_balance_due: null,
      company_details: getCompanyDetails(),
      order_types: [
        { text: "All", value: "all" },
        { text: "Active", value: "1" },
        { text: "Inactive", value: "0" }
      ],
      report_text_loading: false,
      report_text_dialog: false,
      project_selected_status: "1",
      project_of_selected_status: [],
      active_banks: [],
      report_text_data: {},
      last_select_transaction: "",
      active_report: 6,
      lock_transaction_loading: false,
      import_dailog: false,
      import_dailog_loading: false,
      split_dailog: false,
      split_dailog_loading: false,
      date_range_menu: false,
      inline_save_loading: false,
      delete_dialog: false,
      misc_delete_dialog: false,
      delete_invoice_dialog: false,
      expence_filter_flag: false,
      split_patent_id: "",
      split_id: null,
      sales_income_inv_id: null,
      sales_income_invoice_id: "",
      multi_update_tran: false,
      single_update_tran: false,
      multi_update_loading: false,
      single_update_loading: false,
      remove_selection_confirmation: false,
      remove_selection_flag: null,
      filter_start_date: null,
      filter_start_end: null,
      report_details: {
        edit_architect: false,
        report_texts: []
      },
      inline_from_error: {},
      invoice_data: [],
      report_texts: [],
      generated_invoices: [],
      lock_transaction_data: {
        content_id: null,
        date: null,
        content_type: null
      },
      banks: [],
      bank_filter: [],
      selected_bank: null,
      split_amount: "",
      split_amount_error: null,
      split_project_id: "",
      split_expence: false,
      split_vendor_id: "",
      search: "",
      main_amount: null,
      move_to_page: null,
      project_list_filter: [],
      trans_type_list_filter: [],
      select_all_checkbox: false,
      filter_menu: false,
      tran_end_date: false,
      transaction_date: false,
      transaction_date2: false,
      pageCount: 0,
      items: {
        current_page: 1,
        per_page: 20,
        data: [],
        last_page: 0
      },
      loading: false,
      db_column: [
        {
          label: "Transaction Date",
          field: "trans_date",
          value: "",
          error: null,
          color: ""
        },
        {
          label: "Description",
          field: "description",
          value: "",
          error: null,
          color: ""
        },
        {
          label: "Credit Amount (+)",
          field: "amount",
          value: "",
          error: null,
          color: "green"
        },
        {
          label: "Debit Amount (-) ",
          field: "amount2",
          value: "",
          error: null,
          color: "red"
        }
      ],
      imported_columns: [],
      date_columns: [],
      description_columns: [],
      amount_columns: [],
      selected_file: null,
      project_list: [],
      item_list: [],
      vendor_list: [],
      vendor_list_filter: [],
      group_list_filter: [],
      // item_list_filter: [],
      expence_list: [],
      expence_list_filter: [],
      trans_type_list: [],
      tran_start_date: false,
      general_lock_date: false,
      bank_lock_date: false,
      project_lock_date: false,
      vendor_lock_date: false,
      type_lock_date: false,
      general_lock_enable: false,
      bank_lock_enable: false,
      project_lock_enable: false,
      vendor_lock_enable: false,
      type_lock_enable: false,
      disable_dates: null,
      transaction_balance: 0,
      dateFormatted: null,
      general_date: null,
      credit: 0,
      debit: 0,
      account_balance: 0,
      filter_balance: 0,
      opending_balance: 0,
      total_invoice_amt: 0,
      exact_amount: "",
      group_id: "",
      amount_from: "",
      amount_to: "",
      outofdate_bank_list: {
        data: []
      },
      confirm_date_dialog: false,
      change_start_date: "",
      change_end_date: "",
      actual_start_date: "",
      last_invoice: "no",
      update_data: {
        trans_type_id: null,
        project_id: null,
        update_locked_trans: false,
        vendor_id: null,
        expence: false,
        item_id: null,
        transaction_date: null,
        amount_type: null,
        amount: null,
        bank_id: null
      },
      update_transaction: {
        trans_type_id: null,
        update_locked_trans: false,
        project_id: null,
        vendor_id: null,
        expence: false,
        item_id: null,
        transaction_date: null,
        amount_type: "PLUS",
        amount: null,
        bank_id: null,
        description: null
      },
      update_transaction_error: {},
      pagination_settings: {
        perPageList: [
          "All",
          25,
          50,
          100,
          150,
          200,
          250,
          300,
          350,
          400,
          450,
          500,
          1000
        ],
        itemsPerPage: 30
      },
      pagination: {
        itemsPerPage: 25,
        sortBy: ["trans_code"],
        page: 1,
        filters: {
          p_tagged: false,
          tagged: false,
          p_invoice: false,
          search_type: "",
          f_project: "",
          f_vendor: "",
          f_type: "",
          f_group: "",
          f_item: "",
          f_co: "",
          bank: "",
          f_project_status: "",
          f_vendor_status: "",
          f_group_status: "1",
          f_item_status: "1",
          bank_status: "",
          filter_by: "1",
          tran_start_date: "",
          date_filter: "",
          tran_end_date: "",
          amt_filter_by: "1",
          generate_invoice: false,
          generate_invoice_project: "",
          generate_invoice_vendor: "",
          generate_invoice_project_work: "",
          generate_invoice_group: "",
          invoice_project: "",
          generated_inv_id: "",
          outstanding: false,
          is_last_invoice: "no"
        }
      },
      expanded: [],
      status: [
        { text: "All", value: "" },
        { text: "Active", value: "1" },
        { text: "Inactive", value: "0" }
      ],
      search_filters: [
        { text: "All", value: "" },
        // { text: "Bank", value: "bank_name" },
        { text: "Trans. Date", value: "trans_date" },
        { text: "Vendor", value: "v_name" }
      ],
      filter_by_amount: [
        { text: "All", value: "1" },
        { text: "Credit", value: "2" },
        { text: "Debit", value: "3" },
        { text: "Sales", value: "4" }
      ],
      filter_by_group: [
        { text: "All", value: "1" },
        { text: "Grouped", value: "2" },
        { text: "UnGrouped", value: "3" }
      ],
      // filter_by_item: [
      //   { text: "All", value: "1" },
      //   { text: "Grouped", value: "2" },
      //   { text: "UnGrouped", value: "3" }
      // ],
      search_transaction_types: [
        { text: "Transactions", value: "1" },
        { text: "Duplicate Transaction List", value: "2" },
        { text: "Compare Duplicate Transaction", value: "3" },
        { text: "Deleted Transaction List", value: "4" },
        { text: "Locked Transaction List", value: "5" }
      ],
      date_filter: [
        { text: "All", value: "" },
        { text: "Last 90 Days", value: "5" },
        { text: "12 Month", value: "9" },
        { text: "24 Month", value: "10" },
        { text: "This Financial Year", value: "6" },
        { text: "Last Financial Year", value: "7" },
        { text: "Custom", value: "8" }
        // { text: "Today", value: "1" },
        // { text: "Last 7 Days", value: "2" },
        // { text: "Last 30 Days", value: "3" },
        // { text: "Last 60 Days", value: "4" },
        // { text: "Last 90 Days", value: "5" },
      ],
      filter_by: [
        { text: "Transaction All", value: "4" },
        { text: "Pending To Tag", value: "1" },
        // { text: "Ungrouped", value: "7" },
        { text: "Tagged", value: "2" },
        // { text: "Invoiced Transaction", value: "3" },
        { text: "Pending To Invoice", value: "5" },
        { text: "Invoice List", value: "6" },

        // { text: "Transactions", value: "8" },
        { text: "Duplicate Transaction List", value: "9" },
        { text: "Compare Duplicate Transaction", value: "10" },
        { text: "Deleted Transaction List", value: "11" }
        // { text: "Locked Transaction List", value: "12" }
      ],
      headers_outRange: [
        {
          value: "name",
          text: "Bank",
          sortable: false,
          width: "50%"
        },
        {
          value: "date_of_opening_balance",
          text: "Opening Balance Date",
          sortable: false,
          width: "50%"
        }
      ],
      bank_statistic: null,
      keywords: {
        dialog: false,
        loading: false,
        item: null,
        vendors: [],
        expences: [],
        invoice_group: [],
        project: [],
        type: [],
        info: {}
      },
      grouped: {
        status: true,
        type: "bank_id"
      },
      grouped_items: [
        { text: "Bank", value: "bank_id" },
        { text: "Vendor", value: "vendor_id" },
        { text: "Project", value: "project_id" }
      ],
      colors_selected: [],
      search_menu: false,
      group_change_order: "",
      project_without_transaction: "",
      generate_invoice_project_list_popup: false,
      project_list_with_work_type: [],
      selectProjectIsMisc: ""
    };
  },
  computed: {
    // ...mapState("utils", ["pagination_settings"]),
    ...mapState("document", ["doc_list_modal", "refresh_doc_list"]),
    ...mapState("log", ["log_list_modal", "refresh_log_list"]),
    ...mapState("transaction", [
      "is_from_project",
      "co_project_id",
      "co_group_id",
      "co_co_id",
      "co_item_id",
      "redirect_to",
      "is_from_dashboard"
    ]),
    sortData() {
      if (this.pagination.filters.generate_invoice) {
        let sort_items = [];
        sort_items = this.items.data.filter(item => {
          if (!item.selected) {
            return item;
          }
        });
        // sort_items = sort_items.sort((a,b) => {
        //   console.log(a)
        //   let fa = a.amount, fb = b.amount;
        //   if(a.vendor && b.vendor) {
        //     fa = a.vendor.v_name, fb = b.vendor.v_name;
        //   }
        //   if (fa < fb) {
        //     return -1
        //   }
        //   if (fa > fb) {
        //     return 1
        //   }
        //   return 0
        // })
        this.items.data.filter(item => {
          if (item.selected) {
            sort_items.unshift(item);
          }
        });

        return sort_items;
      } else {
        return this.items.data;
      }
    },

    imagePath() {
      return window.location.origin + "/images/build_well_logo.png";
    },
    selected_transaction_invoice_total() {
      let total = 0;
      for (let i = 0; i < this.selectedRows.length; i++) {
        total += parseFloat(
          this.getInvoiceAmt(this.selectedRows[i]).toFixed(2)
        );
      }
      return parseFloat(total).toFixed(2);
    },
    getSelectedTransactionType() {
      let tran_type = "";
      if (this.pagination.filters.generate_invoice) {
        tran_type = "Invoice";
      } else {
        this.filter_by.filter(item => {
          if (item.value == this.pagination.filters.filter_by) {
            tran_type = item.text;
          }
        });
      }
      return tran_type;
    },
    totalBalanceToFinish() {
      let total = this.totalContractSum - this.totalEarnedLessRetainage;
      return total.toFixed(2);
    },
    totalCurrentPaymentDue() {
      let total =
        this.totalScheduleValue - this.totalPreviousValue - this.totalRetainage;
      //let total = this.totalEarnedLessRetainage - this.totalPreviousPayment
      return total.toFixed(2);
    },
    totalEarnedLessRetainage() {
      let total = this.totalCompleted - this.totalRetainage;
      return total.toFixed(2);
    },
    totalContractSum() {
      let total =
        parseFloat(this.totalScheduleValue) +
        parseFloat(this.report_details.net_change_amount);
      return total.toFixed(2);
    },
    totalPreviousPayment() {
      let totalPreviousValue = this.totalPreviousValue;
      if (totalPreviousValue > 0) {
        if (
          this.report_details.retainage &&
          this.report_details.retainage_percentage > 0
        ) {
          let ratainage =
            (totalPreviousValue * this.report_details.retainage_percentage) /
            100;
          totalPreviousValue =
            parseFloat(totalPreviousValue) - parseFloat(ratainage);
        }
      }
      totalPreviousValue = parseFloat(totalPreviousValue);
      if (totalPreviousValue > 0) {
        return totalPreviousValue.toFixed(2);
      } else {
        return "0.00";
      }
    },
    amount_in_word() {
      return getAmountInWord(this.totalScheduleValue);
    },
    totalPreviousValue() {
      let total = 0;
      if (this.invoice_data) {
        for (let i = 0; i < this.invoice_data.length; i++) {
          total += parseFloat(
            this.calculatePreviousValue(this.invoice_data[i])
          );
        }
      }
      return total.toFixed(2);
    },
    totalScheduleValue() {
      let total = 0;
      if (this.invoice_data) {
        for (let i = 0; i < this.invoice_data.length; i++) {
          total += parseFloat(
            this.calculateScheduleValue(this.invoice_data[i])
          );
        }
      }
      return total.toFixed(2);
    },
    totalThisPeriod() {
      let total = 0;
      if (this.invoice_data) {
        for (let i = 0; i < this.invoice_data.length; i++) {
          total += parseFloat(
            this.calculateThisPeriodValue(this.invoice_data[i])
          );
        }
      }
      return total.toFixed(2);
    },
    totalCompleted() {
      let total = 0;
      if (this.invoice_data) {
        for (let i = 0; i < this.invoice_data.length; i++) {
          total += parseFloat(
            this.calculateThisPeriodValue(this.invoice_data[i])
          );
          total += parseFloat(
            this.calculatePreviousValue(this.invoice_data[i])
          );
        }
      }
      return total.toFixed(2);
    },
    totalBalance() {
      let total = 0;
      if (this.invoice_data) {
        for (let i = 0; i < this.invoice_data.length; i++) {
          total += parseFloat(this.calculateBalance(this.invoice_data[i]));
        }
      }
      return total.toFixed(2);
    },
    totalRetainage() {
      let total = 0;
      if (this.invoice_data) {
        for (let i = 0; i < this.invoice_data.length; i++) {
          total += parseFloat(this.calculateRetainage(this.invoice_data[i]));
        }
      }
      return total.toFixed(2);
    },
    vendor_account_flag() {
      if (this.expence_filter_flag) {
        return "chart_of_account";
      } else {
        return "vendor";
      }
    },
    disableImportBtn() {
      if (!this.selected_bank) {
        return true;
      } else if (!this.selected_file) {
        return true;
      } else if (
        this.db_column[0].value === "" ||
        this.db_column[1].value === "" ||
        this.db_column[2].value === "" ||
        this.db_column[3].value === ""
      ) {
        return true;
      } else {
        return false;
      }
    },
    headers() {
      if (this.pagination.filters.generate_invoice) {
        return [
          { value: "select_all", text: "", sortable: false, width: "2%" },
          {
            value: "B2.bank_code",
            text: "Bank",
            width: "7%",
            sortable: true,
            align: "left",
            class: "text-subtitle-2 font-weight-regular"
          },
          // {
          //   value: "TT.title",
          //   text: "Type",
          //   width: "10%",
          //   sortable: true,
          //   align: "center",
          //   class: "text-subtitle-2 font-weight-regular"
          // },
          {
            value: "trans_date",
            text: "Date",
            width: "6%",
            sortable: true,
            align: "center",
            class: "text-subtitle-2 font-weight-regular"
          },
          {
            value: "amount",
            text: "Amount",
            width: "9%",
            sortable: true,
            align: "right",
            class: "text-subtitle-2 font-weight-regular pa-0"
          },
          {
            value: "P.p_code",
            text: "Project",
            width: "9%",
            align: "left",
            sortable: true,
            class: "text-subtitle-2 font-weight-regular"
          },
          {
            value: "V.v_code",
            text: "Vendor",
            width: "9%",
            align: "left",
            sortable: true,
            class: "text-subtitle-2 font-weight-regular"
          },
          {
            value: "group_name",
            text: "Group",
            width: "18%",
            sortable: true,
            align: "left",
            class: "text-subtitle-2 font-weight-regular"
          },
          {
            value: "",
            text: "INV Amt",
            width: "8%",
            sortable: false,
            align: "right",
            class: "text-subtitle-2 font-weight-regular"
          },
          {
            value: "description",
            text: "Description",
            width: "29%",
            sortable: true,
            align: "center",
            class: "text-subtitle-2 font-weight-regular"
          },
          {
            value: "",
            text: "",
            width: "3%",
            sortable: false,
            align: "center",
            class: ""
          }
        ];
      } else {
        return [
          { value: "select_all", text: "", sortable: false, width: "2%" },
          {
            value: "B2.bank_code",
            text: "Bank",
            width: "7%",
            sortable: true,
            align: "left",
            class: "text-subtitle-2 font-weight-regular"
          },
          // {
          //   value: "TT.title",
          //   text: "Type",
          //   width: "10%",
          //   sortable: true,
          //   align: "center",
          //   class: "text-subtitle-2 font-weight-regular"
          // },
          {
            value: "trans_date",
            text: "Date",
            width: "6%",
            sortable: true,
            align: "center",
            class: "text-subtitle-2 font-weight-regular"
          },
          {
            value: "amount",
            text: "Amount",
            width: "9%",
            sortable: true,
            align: "right",
            class: "text-subtitle-2 font-weight-regular pa-0"
          },
          {
            value: "P.p_code",
            text: "Project",
            width: "9%",
            align: "left",
            sortable: true,
            class: "text-subtitle-2 font-weight-regular"
          },
          {
            value: "V.v_code",
            text: "Vendor",
            width: "9%",
            align: "left",
            sortable: true,
            class: "text-subtitle-2 font-weight-regular"
          },
          {
            value: "",
            text: "INV Dt",
            width: "9%",
            sortable: false,
            align: "center",
            class: "text-subtitle-2 font-weight-regular"
          },
          {
            value: "",
            text: "INV No.",
            width: "9%",
            sortable: false,
            align: "center",
            class: "text-subtitle-2 font-weight-regular"
          },
          {
            value: "",
            text: "INV Amt",
            width: "8%",
            sortable: false,
            align: "right",
            class: "text-subtitle-2 font-weight-regular"
          },
          {
            value: "description",
            text: "Description",
            width: "32%",
            sortable: true,
            align: "center",
            class: "text-subtitle-2 font-weight-regular"
          }
        ];
      }
    },
    invoice_list_headers() {
      return [
        { value: "select_all", text: "", sortable: false, width: "2%" },
        {
          text: "Invoice Date",
          width: "10%",
          sortable: false,
          align: "center",
          class: "text-subtitle-2 font-weight-regular"
        },
        {
          text: "Invoice No.",
          width: "10%",
          sortable: false,
          align: "center",
          class: "text-subtitle-2 font-weight-regular"
        },
        {
          text: "Project",
          width: "23%",
          sortable: false,
          class: "text-subtitle-2 font-weight-regular"
        },
        {
          text: "Inv.Amount",
          width: "10%",
          sortable: false,
          align: "right",
          class: "text-subtitle-2 font-weight-regular"
        },
        {
          text: "Period To",
          width: "10%",
          sortable: false,
          align: "right",
          class: "text-subtitle-2 font-weight-regular"
        },
        {
          text: "Payment Received",
          width: "13%",
          sortable: false,
          align: "right",
          class: "text-subtitle-2 font-weight-regular"
        },
        {
          text: "Balance Due",
          width: "13%",
          sortable: false,
          align: "right",
          class: "text-subtitle-2 font-weight-regular"
        },
        {
          text: "",
          width: "9%",
          sortable: false,
          align: "right",
          class: "text-subtitle-2 font-weight-regular"
        }
      ];
    },

    split_list_header() {
      return [
        {
          text: "Bank",
          width: "14%",
          sortable: false,
          align: "left",
          class: "text-subtitle-2 font-weight-regular",
          value: "bank.bank_code"
        },
        {
          text: "Date",
          width: "14%",
          sortable: false,
          align: "left",
          class: "text-subtitle-2 font-weight-regular",
          value: "trans_date"
        },
        {
          text: "Amount",
          width: "14%",
          sortable: false,
          align: "right",
          class: "text-subtitle-2 font-weight-regular",
          value: "amount"
        },
        {
          text: "INV NO.",
          width: "14%",
          sortable: false,
          align: "left",
          class: "text-subtitle-2 font-weight-regular",
          value: "trans_date"
        },
        {
          text: "INV Amt.",
          width: "14%",
          sortable: false,
          align: "right",
          class: "text-subtitle-2 font-weight-regular",
          value: "amount"
        },

        {
          text: "Project",
          width: "14%",
          sortable: false,
          align: "left",
          class: "text-subtitle-2 font-weight-regular",
          value: "project.p_code"
        },
        {
          text: "Vendor",
          width: "14%",
          sortable: false,
          align: "left",
          class: "text-subtitle-2 font-weight-regular",
          value: "vendor.v_code"
        }
      ];
    },
    invoice_headers() {
      return [
        {
          text: "Item No.",
          value: "item_number",
          width: "5%",
          sortable: false,
          align: "center",
          class: "text-subtitle-2 font-weight-regular"
        },
        {
          text: "Description",
          width: "25%",
          sortable: false,
          align: "center",
          class: "text-subtitle-2 font-weight-regular"
        },
        {
          text: "Scheduled Value",
          width: "10%",
          sortable: false,
          align: "right",
          class: "text-subtitle-2 font-weight-regular"
        },
        {
          text: "Previous Valuedfs",
          width: "10%",
          sortable: false,
          align: "right",
          class: "text-subtitle-2 font-weight-regular"
        },
        {
          text: "This Period",
          width: "10%",
          sortable: false,
          align: "right",
          class: "text-subtitle-2 font-weight-regular"
        },
        {
          text: "Total Completed",
          width: "10%",
          align: "right",
          sortable: false,
          class: "text-subtitle-2 font-weight-regular"
        },
        {
          text: "% (G/C)",
          width: "10%",
          align: "center",
          sortable: false,
          class: "text-subtitle-2 font-weight-regular"
        },
        {
          text: "Balance",
          width: "10%",
          sortable: false,
          align: "right",
          class: "text-subtitle-2 font-weight-regular"
        },
        {
          text: "Retainage",
          width: "10%",
          sortable: false,
          align: "right",
          class: "text-subtitle-2 font-weight-regular"
        }
      ];
    },
    selectedRows() {
      return this.items.data.filter(function(item) {
        return item.selected == true;
      });
    },
    hasInvoices() {
      return this.items.data.filter(function(item) {
        return item.generated_inv_id != null && item.selected == true;
      });
    },

    tranIsTagged() {
      let selected = this.items.data.filter(function(item) {
        return item.selected && (!item.vendor_id || !item.project_id);
      });
      return selected.length == 0;
    },
    hasChilds() {
      return this.items.data.filter(function(item) {
        return item.selected && item.childs_count > 0;
      });
    },
    hasParentAssign() {
      return this.items.data.filter(function(item) {
        return item.selected && item.parent_assign > 0;
      });
    },
    pageData() {
      let paginationData = this.pagination;
      paginationData.search = this.search;
      paginationData.exact_amount = this.exact_amount;
      paginationData.amount_from = this.amount_from;
      paginationData.amount_to = this.amount_to;

      return paginationData;
    },
    filtersCount() {
      let count = 0;
      for (var key in this.pagination.filters) {
        if (
          this.pagination.filters[key] &&
          key != "tran_start_date" &&
          key != "tran_end_date"
        ) {
          count++;
        }
      }
      if (
        this.pagination.filters.tran_start_date &&
        this.pagination.filters.tran_end_date
      ) {
        count++;
      }
      if (this.exact_amount) {
        count++;
      }
      if (this.amount_from && this.amount_to) {
        count++;
      }
      if (count == 3) {
        return "D";
      } else {
        return count;
      }
    },
    isDisplayNetBalance() {
      let count = 0;
      if (this.pagination.filters.f_project) {
        count++;
      }
      if (this.pagination.filters.f_vendor) {
        count++;
      }
      if (this.pagination.filters.f_type) {
        count++;
      }
      if (this.pagination.filters.bank) {
        count++;
      }
      if (count == 1) {
        return true;
      } else {
        return false;
      }
    }
  },
  watch: {
    doc_list_modal: function(value) {
      if (!value) {
        this.open_doc_model_falg = false;
      } else {
        this.open_doc_model_falg = true;
      }
    },
    log_list_modal: function(value) {
      if (!value) {
        this.open_log_model_falg = false;
      } else {
        this.open_log_model_falg = true;
      }
    },
    "update_transaction.amount": function(value) {
      console.log(value);
    },
    // search: {
    //   handler() {
    //     this.getTransaction(this.pageData);
    //   },
    // },
    pagination: {
      handler() {
        this.getTransaction(this.pageData);
      },
      deep: true
    },
    import_dailog: {
      handler(val) {
        if (!val) {
          this.selected_file = null;
          this.selected_bank = null;
          this.imported_columns = [];
          this.date_columns = [];
          this.description_columns = [];
          this.amount_columns = [];
          this.bank_statistic = null;
          this.db_column = this.db_column.map(function(item) {
            item.error = null;
            return item;
          });
        }
      }
    },
    split_dailog: {
      handler(val) {
        if (!val) {
          this.split_amount = null;
          this.split_amount_error = null;
        }
      }
    },
    "keywords.dialog": {
      handler(val) {
        if (!val) {
          this.keywords.item = null;
          this.keywords.vendors = [];
          this.keywords.expences = [];
          this.keywords.project = [];
          this.keywords.type = [];
          this.keywords.info = {};
        }
      }
    },
    "pagination.filters.tagged": {
      handler(val) {
        if (!val) {
          this.pagination.filters.f_project = "";
          this.pagination.filters.f_vendor = "";
          this.pagination.filters.f_type = "";
          this.pagination.filters.f_group = "";
          this.pagination.filters.f_item = "";
          this.pagination.filters.f_co = "";
        }
      }
    },
    "pagination.filters.p_invoice": {
      handler(val) {
        if (!val) {
          this.pagination.filters.f_project = "";
          this.pagination.filters.f_vendor = "";
          this.pagination.filters.f_type = "";
          this.pagination.filters.f_co = "";
        }
      }
    },
    "pagination.filters.tran_start_date": {
      handler(val) {
        if (val && this.pagination.filters.tran_end_date) {
          const startDate = new Date(val);
          const endDate = new Date(this.pagination.filters.tran_end_date);
          if (startDate > endDate) {
            this.pagination.filters.tran_end_date = "";
          }
        }
      }
    }
  },
  methods: {
    ...mapMutations("utils", ["setAlert"]),
    ...mapMutations("document", ["setModal", "setDocumentData"]),
    ...mapMutations("log", ["setLogData"]),
    getAmountFormatInBracket(val) {
      if (val < 0) {
        val = val.toString();
        val = val.replace("-", "");
        return "($" + val + ")";
      } else {
        return "$" + val;
      }
    },

    AssignGroupChangeOrder() {
      let group_change_order = this.group_change_order;
      let gr_ch_data = group_change_order.split("-");
      this.pagination.filters.f_group = gr_ch_data[1];
      this.pagination.filters.f_co = gr_ch_data[0];
    },
    generateG702Report() {
      this.loading = true;
      axios
        .get(
          "get_total_of_ungroup_item?project_id=" +
            this.selectedRows[0].project_id +
            "&report_header_name=" +
            this.report_header_name
        )
        .then(response => {
          if (response.data.total > 0) {
            this.setAlert({
              show: true,
              variant: "error",
              message:
                "<div class='text-center' style='line-height: 24px;'>Item(s) are not grouped. <br> So you can't generate this report.</div>",
              dismissCountDown: 0
            });
          } else {
            this.g702_report = true;
          }
          this.loading = false;
        })
        .catch(function() {
          this.loading = false;
        });
    },
    generateG703Report(p_type = "") {
      this.loading = true;
      axios
        .get(
          "get_total_of_ungroup_item?project_id=" +
            this.selectedRows[0].project_id +
            "&report_header_name=" +
            this.report_header_name
        )
        .then(response => {
          if (response.data.total > 0) {
            this.setAlert({
              show: true,
              variant: "error",
              message:
                "<div class='text-center' style='line-height: 24px;'>Item(s) are not grouped. <br> So you can't generate this report.</div>",
              dismissCountDown: 0
            });
          } else {
            if (p_type == "cost_plus") {
              this.g703_cost_plus_report = true;
            } else {
              this.g703_report = true;
            }
          }
          this.loading = false;
        })
        .catch(function() {
          this.loading = false;
        });
    },
    generateContractReport() {
      this.loading = true;
      axios
        .get(
          "get_total_of_ungroup_item?project_id=" +
            this.selectedRows[0].project_id +
            "&report_header_name=" +
            this.report_header_name
        )
        .then(response => {
          if (response.data.total > 0) {
            this.setAlert({
              show: true,
              variant: "error",
              message:
                "<div class='text-center' style='line-height: 24px;'>Item(s) are not grouped. <br> So you can't generate this report.</div>",
              dismissCountDown: 0
            });
          } else {
            this.contract_report = true;
          }
          this.loading = false;
        })
        .catch(function() {
          this.loading = false;
        });
    },
    generatePartialLienReleaseReport() {
      this.loading = true;
      axios
        .get(
          "get_total_of_ungroup_item?project_id=" +
            this.selectedRows[0].project_id +
            "&report_header_name=" +
            this.report_header_name
        )
        .then(response => {
          if (response.data.total > 0) {
            this.setAlert({
              show: true,
              variant: "error",
              message:
                "<div class='text-center' style='line-height: 24px;'>Item(s) are not grouped. <br> So you can't generate this report.</div>",
              dismissCountDown: 0
            });
          } else {
            this.partial_lien_release_report = true;
          }
          this.loading = false;
        })
        .catch(function() {
          this.loading = false;
        });
    },
    generateFinalLienReleaseReport() {
      this.loading = true;
      axios
        .get(
          "get_total_of_ungroup_item?project_id=" +
            this.selectedRows[0].project_id +
            "&report_header_name=" +
            this.report_header_name
        )
        .then(response => {
          if (response.data.total > 0) {
            this.setAlert({
              show: true,
              variant: "error",
              message:
                "<div class='text-center' style='line-height: 24px;'>Item(s) are not grouped. <br> So you can't generate this report.</div>",
              dismissCountDown: 0
            });
          } else {
            this.final_lien_release_report = true;
          }
          this.loading = false;
        })
        .catch(function() {
          this.loading = false;
        });
    },
    generateSalesInvoiceReport() {
      if (this.selectedRows[0].project.project_work == "counter_tops") {
        this.counter_top_sales_invoice_report = true;
      } else {
        this.sales_invoice_report = true;
      }
    },
    generateCounterTopOrderReport() {
      this.counter_top_order_report = true;
    },
    generateAcceptanceReport() {
      this.acceptance_report = true;
    },
    view703Report() {
      if (
        this.pagination.filters.generate_invoice_project_work == "retail_sales"
      ) {
        this.is_generate_invoice_for_generate_invoice = true;
      } else {
        this.is_generate_invoice = true;
      }
    },
    view703ReportForCostPlus() {
      this.is_generate_invoice_for_cost_plus = true;
      if (
        this.pagination.filters.generate_invoice_project_work == "retail_sales"
      ) {
        this.is_generate_invoice_for_generate_invoice = true;
      } else {
        this.is_generate_invoice_for_cost_plus = true;
      }
    },
    getProjectListWithWorkType() {
      let _self = this;
      axios
        .get("get_project_list_without_transaction?project_work_type=")
        .then(response => {
          if (response.data.status) {
            _self.project_list_with_work_type = response.data.data.projects;
          }
        })
        .catch(function() {});
    },
    generateInvoiceWithoutTransaction() {
      this.invoice_project_data = this.project_list_with_work_type.find(
        project => project.project_id === this.project_without_transaction
      );
      this.is_generate_invoice = true;
    },

    getInvoiceBalance(item) {
      let balance_due = item.balance_due;
      return this.getAmountFormatInBracket(balance_due);
    },
    sendMail(variable) {
      this.email_id_arr = variable;
      this.print("mail", true);
    },
    closeSendMailDialog() {
      this.email_dialog = false;
      this.preview_pdf_dialog = false;
      this.user_sign_blob = [];
      this.customer_sign_blob = "";
      this.active_page = 0;
    },
    saveReport() {
      if (this.active_report == 3) {
        this.signature_dialog = true;
      } else {
        if (this.is_send_report) {
          if (this.total_page == this.active_page) {
            this.email_dialog = true;
            this.email_ids = this.report_details.customer_email;
          } else {
            this.print("save", false);
          }
        } else {
          if (this.total_page == this.active_page) {
            this.print("save", true);
          } else {
            this.print("save", false);
          }
        }
      }
    },
    customChange() {
      this.pagination.itemsPerPage = 25;
      this.getTransaction();
    },
    GetSalesIncomeTransactionList(id) {
      let _self = this;
      _self.sales_income_inv_id = id;
      axios
        .post("get_sales_income_transaction_list", {
          invoice_id: id
        })
        .then(function(res) {
          _self.split_list_dialogue = true;
          _self.split_list = res.data.data;
          _self.split_list_total = res.data.total_sales_income;
        })
        .catch(function() {
          _self.split_list_dialogue = false;
        });
    },
    GetSplitTransactionList(id) {
      let _self = this;
      _self.split_id = id;
      axios
        .post("get_split_transaction", {
          split_id: id
        })
        .then(function(res) {
          _self.split_list_dialogue = true;
          _self.split_list = res.data.data;
          _self.split_list_total = res.data.total;
        })
        .catch(function() {
          _self.split_list_dialogue = false;
        });
    },
    GetSalesIncomeTransactionListFilter() {
      let _self = this;
      _self.resetFilter();

      _self.sales_income_invoice_id = _self.sales_income_inv_id;

      _self.split_list_dialogue = false;
      _self.pagination.filters.filter_by = "4";
      _self.getTransaction();
    },
    GetSplitTransactionListFilter() {
      this.resetFilter();
      this.split_list_dialogue = false;
      this.split_patent_id = this.split_id;
      this.pagination.filters.filter_by = "4";
      this.getTransaction();
    },
    refreshTransactions() {
      this.single_update_tran = false;
      this.multi_update_tran = false;
      this.getTransaction();
    },
    updateParent(variable) {
      if (variable.user_sign_blob) {
        this.user_sign_blob[this.active_page] = variable.user_sign_blob;
      }
      if (variable.customer_sign_blob && this.active_page == 1) {
        this.customer_sign_blob = variable.customer_sign_blob;
      }
      this.signature_dialog = false;
      if (this.is_send_report) {
        if (this.total_page == this.active_page) {
          this.email_dialog = true;
          this.email_ids = this.report_details.customer_email;
        } else {
          this.print("save", false);
        }
      } else {
        if (this.total_page == this.active_page) {
          this.print("save", true);
        } else {
          this.print("save", false);
        }
      }
    },
    clearParent(variable) {
      console.log(variable);
      this.signature_dialog = false;
    },
    viewInvoice(generated_inv_id, project_id, last_id) {
      this.loading = true;
      this.items.data = [];
      this.pagination.sortBy = ["generate_invoice"];
      this.last_select_transaction = "";
      this.pagination.filters.generated_inv_id = generated_inv_id;
      this.pagination.filters.generate_invoice_project = project_id;
      this.pagination.filters.invoice_project = project_id;
      this.pagination.filters.invoice_project = project_id;
      this.pagination.filters.generate_invoice_vendor = "";
      this.pagination.filters.generate_invoice_group = "";
      this.pagination.filters.generate_invoice = true;
      this.pagination.itemsPerPage = -1;
      if (generated_inv_id == last_id) {
        // this.pagination.filters.is_last_invoice = 'yes';
        this.last_invoice = "yes";
      } else {
        this.last_invoice = "no";
      }
      this.getinvoices();
    },
    getInvoiceAmt(item) {
      if (item.project) {
        let total = this.getAmountFormat(item.rev_amount);
        total = getTotalOrderAmountwithAllcalculation(
          item.project.p_price,
          item.project.multiplier,
          item.rev_amount
        );

        return total;
      } else {
        return 0;
      }
    },
    selectRecord(val) {
      if (this.open_doc_model_falg || this.open_log_model_falg) {
        this.items.data.filter(item => {
          if (val == item.trans_id) {
            if (this.open_doc_model_falg && this.open_log_model_falg) {
              this.setDocumentData({
                key: "refresh_doc_list",
                value: !this.refresh_doc_list
              });
              this.setLogData({
                key: "refresh_log_list",
                value: !this.refresh_log_list
              });
              this.openDocList(item);
              this.openLogList(item);
              setTimeout(() => {
                this.openDocList(item);
                this.openLogList(item);
              }, 500);
            } else if (this.open_doc_model_falg) {
              this.setDocumentData({
                key: "refresh_doc_list",
                value: !this.refresh_doc_list
              });
              this.openDocList(item);
            } else if (this.open_log_model_falg) {
              this.setLogData({
                key: "refresh_log_list",
                value: !this.refresh_log_list
              });
              this.openLogList(item);
            }
          } else {
            item.selected = false;
          }
        });
      }
    },
    updateReportText(update_for_all_project) {
      this.report_text_data.project_id = this.pagination.filters.invoice_project;
      this.report_text_data.update_for_all_project = update_for_all_project;
      this.report_text_loading = true;
      let _self = this;
      axios
        .post("update_project_report_text", this.report_text_data)
        .then(function(res) {
          _self.report_details.report_texts = res.data.data;
          _self.report_text_dialog = false;
          _self.getReportTexts();
          _self.report_text_loading = false;
        })
        .catch(function() {
          _self.report_text_loading = false;
        });
    },
    openReportTextDialog(report, section) {
      this.report_text_data.text = this.getReportText(report, section, true);
      this.report_text_data.report = report;
      this.report_text_data.section = section;
      this.report_text_dialog = true;
    },
    getReportText(report, section, is_edit_mode) {
      let report_text = "";
      this.report_details.report_texts.filter(item => {
        if (item.report == report && item.section == section) {
          report_text = item.text;
        }
      });
      if (!report_text) {
        this.report_texts.filter(item => {
          if (item.report == report && item.section == section) {
            report_text = item.text;
          }
        });
      }
      if (report == "1" && section == "14" && !is_edit_mode) {
        let totalScheduleValue = "$" + this.totalScheduleValue;
        let amountInWord = "US$ " + this.amount_in_word;
        report_text = report_text.replace("{amount}", totalScheduleValue);
        report_text = report_text.replace("{amount_in_word}", amountInWord);
      }
      if (report == "2" && section == "1" && !is_edit_mode) {
        let amountInWord = "US$ " + this.amount_in_word;
        report_text = report_text.replace("{amount_in_word}", amountInWord);
        report_text = report_text.replace(
          "{project_details}",
          "<span><span>" +
            this.report_details.project_name +
            "</span><br><span>" +
            this.report_details.project_address +
            "</span></span>"
        );
      }
      if (report == "3" && section == "1" && !is_edit_mode) {
        let balance = "$" + this.totalBalance;
        report_text = report_text.replace("{balance}", balance);
        report_text = report_text.replace(
          "{project_name}",
          this.report_details.project_name
        );
        report_text = report_text.replace(
          "{customer_address}",
          this.report_details.project_address
        );
      }
      return report_text;
    },
    saveArchitech() {
      this.loading = true;
      let _self = this;
      axios
        .post("save_project_architect", {
          project_id: _self.pagination.filters.invoice_project,
          architect: _self.report_details.architect
        })
        .then(function() {
          _self.loading = false;
          _self.report_details.edit_architect = false;
        })
        .catch(function() {
          _self.loading = false;
        });
    },
    print(flag, is_past_page) {
      this.active_page++;
      let print_id = "";
      if (this.active_report == 1) {
        print_id = "g_702";
      } else if (this.active_report == 2) {
        print_id = "g_703";
      } else if (this.active_report == 3) {
        print_id = "contract";
      } else if (this.active_report == 4) {
        print_id = "partial_lien_release";
      } else if (this.active_report == 5) {
        print_id = "final_lien_release";
      }

      //let url = parseParams(this.pageData);
      let company_data = localStorage.getItem("company_data");
      company_data = JSON.parse(company_data);
      //url = url+'&project_id='+this.pagination.filters.invoice_project+'&invoice_id='+this.pagination.filters.generated_inv_id+'&report_name='+print_id+'&flag='+flag+'&user_name='+localStorage.getItem('user_id')+'&company_id='+company_data.company_id;
      let data = this.pageData;
      data.project_id = this.pagination.filters.invoice_project;
      data.invoice_id = this.pagination.filters.generated_inv_id;
      data.report_name = print_id;
      data.user_name = localStorage.getItem("user_id");
      data.company_id = company_data.company_id;
      data.filter = this.pagination.filters;
      data.flag = flag;
      (data.active_page = this.active_page),
        (data.total_page = this.total_page);
      data.user_sign_blob = this.user_sign_blob;
      data.customer_sign_blob = this.customer_sign_blob;

      if (is_past_page) {
        if (this.user_sign_blob) {
          data.user_sign_blob = this.user_sign_blob;
        }
        if (this.customer_sign_blob) {
          data.customer_sign_blob = this.customer_sign_blob;
        }
        data.generate_pdf_flag = "whole_page";
      } else {
        data.generate_pdf_flag = "single_page";
      }

      if (flag == "mail") {
        //url = url+'&email_ids='+this.email_ids;
        data.email_ids = this.email_ids;
        data.email_id_arr = this.email_id_arr;
        this.send_pdf_loading = true;
        axios
          .post("generate_invoice_pdf", data)
          .then(response => {
            this.email_ids_error = null;
            if (response.data.status) {
              this.email_dialog = false;
              this.setAlert({
                show: true,
                variant: "primary",
                message: response.data.message,
                dismissCountDown: 0
              });
              this.preview_pdf_dialog = false;
              this.preview_page_link = "";
              this.active_page = 0;
              this.user_sign_blob = [];
              this.customer_sign_blob = "";
            } else {
              this.email_ids_error = response.data.errors["email_ids"];
            }
            this.send_pdf_loading = false;
          })
          .catch(function(error) {
            console.log(error);
            this.send_pdf_loading = false;
          });
      } else {
        this.preview_pdf_loading = true;
        axios
          .post("generate_invoice_pdf", data)
          .then(response => {
            if (is_past_page) {
              if (response.data.status) {
                this.setAlert({
                  show: true,
                  variant: "primary",
                  message: response.data.message,
                  dismissCountDown: 0
                });
                this.preview_pdf_dialog = false;
              }
              this.preview_page_link = "";
              this.active_page = 0;
              this.user_sign_blob = [];
              this.customer_sign_blob = "";
            } else {
              this.preview_page_link = response.data.preview_page_link;
            }
            this.preview_pdf_loading = false;
          })
          .catch(function(error) {
            console.log(error);
            this.preview_pdf_loading = false;
          });
      }

      // let url = parseParams(this.pageData);
      // let company_data = localStorage.getItem('company_data')
      // company_data = JSON.parse(company_data)
      // url = url+'&project_id='+this.pagination.filters.invoice_project+'&invoice_id='+this.pagination.filters.generated_inv_id+'&report_name='+print_id+'&flag='+flag+'&user_name='+localStorage.getItem('user_id')+'&company_id='+company_data.company_id;
      // if(flag == 'mail') {
      //   url = url+'&email_ids='+this.email_ids;
      //   this.send_pdf_loading = true
      //   axios
      //   .get("generate_invoice_pdf?" + url)
      //   .then(response => {
      //     this.email_ids_error = null;
      //     if(response.data.status) {
      //       this.email_dialog = false
      //       this.setAlert({
      //         show: true,
      //         variant: "primary",
      //         message: response.data.message,
      //         dismissCountDown: 0
      //       });
      //     } else {
      //         this.email_ids_error = response.data.errors['email_ids'];
      //     }
      //     this.send_pdf_loading = false
      //   })
      //   .catch(function(error) {
      //     console.log(error);
      //     this.send_pdf_loading = false
      //   });
      // } else {
      //   this.loading = true
      //   axios
      //   .get("generate_invoice_pdf?" + url)
      //   .then(response => {
      //     if(response.data.status) {
      //       this.setAlert({
      //         show: true,
      //         variant: "primary",
      //         message: response.data.message,
      //         dismissCountDown: 0
      //       });
      //     }
      //     this.loading = false
      //   })
      //   .catch(function(error) {
      //     console.log(error);
      //     this.loading = false
      //   });
      // }
      // var html = document.getElementById(print_id);

      // var doc = new jsPDF({
      //   orientation: "l",
      //   unit: "px",
      //   //format: 'a4',
      //   format: [1030, 1000],
      //   hotfixes: ["px_scaling"],
      // });

      // doc.html(html, {
      //   callback: doc => {
      //     if (flag == "mail") {
      //       var blob = doc.output("blob");
      //       var formData = new FormData();
      //       formData.append("report_pdf", blob);
      //       formData.append(
      //         "project_id",
      //         this.pagination.filters.invoice_project
      //       );
      //       formData.append(
      //         "email_ids",
      //         this.email_ids
      //       );
      //       this.send_pdf_loading = true;
      //       axios
      //         .post("send_report_in_mail", formData, {
      //           headers: {
      //             "Content-Type": "multipart/form-data"
      //           }
      //         })
      //         .then(response => {
      //           this.email_ids_error = null;
      //           this.send_pdf_loading = false
      //           if(response.data.status) {
      //             this.email_dialog = false
      //             this.setAlert({
      //               show: true,
      //               variant: "primary",
      //               message: response.data.message,
      //               dismissCountDown: 0
      //             });
      //           } else {
      //              this.email_ids_error = response.data.errors['email_ids'];
      //           }
      //         });
      //     } else {
      //       doc.save(print_id + ".pdf");
      //     }
      //   },
      // });
      // setTimeout(() => {
      //   this.printing_report = false;
      // }, 500);

      // let options = {}
      // if(this.active_report == 1 || this.active_report == 2) {
      //   options = {
      //     name: '_blank',
      //     specs: [
      //       'fullscreen=yes',
      //       'titlebar=yes',
      //       'scrollbars=yes'
      //     ],
      //     styles: [
      //       'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
      //       'https://unpkg.com/kidlat-css/css/kidlat.css',
      //       //'https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700,900',
      //       //'https://cdn.jsdelivr.net/npm/@mdi/font@4.x/css/materialdesignicons.min.css',
      //       'https://cdn.jsdelivr.net/npm/vuetify@2.x/dist/vuetify.min.css',
      //       process.env.VUE_APP_URL+'/custom.css',
      //       process.env.VUE_APP_URL+'/print.css'
      //     ]
      //   }
      // } else {
      //   options = {
      //     name: '_blank',
      //     specs: [
      //       'fullscreen=yes',
      //       'titlebar=yes',
      //       'scrollbars=yes'
      //     ],
      //     styles: [
      //       'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
      //       'https://unpkg.com/kidlat-css/css/kidlat.css',
      //       //'https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700,900',
      //       //'https://cdn.jsdelivr.net/npm/@mdi/font@4.x/css/materialdesignicons.min.css',
      //       'https://cdn.jsdelivr.net/npm/vuetify@2.x/dist/vuetify.min.css',
      //       process.env.VUE_APP_URL+'/custom.css'
      //     ]
      //   }
      // }
      // this.$htmlToPaper(print_id,options);
    },
    getTotalPage() {
      this.preview_pdf_loading = true;
      this.preview_page_link = "";
      this.active_page = 0;
      this.user_sign_blob = [];
      this.customer_sign_blob = "";
      let print_id = "";
      if (this.active_report == 1) {
        print_id = "g_702";
      } else if (this.active_report == 2) {
        print_id = "g_703";
      } else if (this.active_report == 3) {
        print_id = "contract";
      } else if (this.active_report == 4) {
        print_id = "partial_lien_release";
      } else if (this.active_report == 5) {
        print_id = "final_lien_release";
      }

      let company_data = localStorage.getItem("company_data");
      company_data = JSON.parse(company_data);
      let data = this.pageData;
      data.project_id = this.pagination.filters.invoice_project;
      data.invoice_id = this.pagination.filters.generated_inv_id;
      data.report_name = print_id;
      data.user_name = localStorage.getItem("user_id");
      data.company_id = company_data.company_id;
      data.filter = this.pagination.filters;
      data.flag = "save";
      data.generate_pdf_flag = "get_total";
      axios
        .post("generate_invoice_pdf", data)
        .then(response => {
          if (response.data.status) {
            this.total_page = response.data.total_page;
          }
          this.print("save", false);
          this.preview_pdf_loading = false;
        })
        .catch(function(error) {
          console.log(error);
          this.preview_pdf_loading = false;
        });
    },
    deleteInvoiceFromReport() {
      this.loading = true;
      let _self = this;
      axios
        .post("delete_invoice_from_report", {
          generated_inv_id: this.pagination.filters.generated_inv_id
        })
        .then(function(response) {
          _self.setAlert({
            show: true,
            variant: "primary",
            message: response.data.message,
            dismissCountDown: 0
          });
          _self.delete_invoice_dialog = false;
          _self.last_select_transaction = "";
          _self.pagination.filters.generate_invoice_project = "";
          _self.pagination.filters.generate_invoice = false;
          _self.pagination.filters.generated_inv_id = "";
          _self.pagination.filters.invoice_project = "";
          _self.loading = false;
        })
        .catch(function() {
          _self.loading = false;
          console.log("FAILURE!!");
        });
    },
    updateInvoiceFromReport() {
      this.is_update_invoice = true;
      if (
        this.pagination.filters.generate_invoice_project_work == "retail_sales"
      ) {
        this.is_generate_invoice_for_generate_invoice = true;
      } else {
        this.is_generate_invoice = true;
      }
      // this.loading = true;
      // let _self = this;
      // axios
      //   .post("update_invoice_from_report", {
      //     project_id: this.pagination.filters.generate_invoice_project,
      //     transactions: this.selectedRows,
      //     generated_inv_id: this.pagination.filters.generated_inv_id
      //   })
      //   .then(function(response) {
      //     _self.setAlert({
      //       show: true,
      //       variant: "primary",
      //       message: response.data.message,
      //       dismissCountDown: 0
      //     });
      //     _self.getTransaction();
      //     _self.loading = false;
      //   })
      //   .catch(function() {
      //     _self.loading = false;
      //     console.log("FAILURE!!");
      //   });
    },
    updateInvoiceFromReportForCostPlus() {
      this.is_update_invoice = true;
      this.is_generate_invoice_for_cost_plus = true;
    },
    // generateInvoiceFromReport() {
    //   this.loading = true;
    //   let _self = this;
    //   axios
    //     .post("generate_invoice_from_report", {
    //       project_id: _self.pagination.filters.generate_invoice_project,
    //       transactions: this.selectedRows
    //     })
    //     .then(function(response) {
    //       _self.setAlert({
    //         show: true,
    //         variant: "primary",
    //         message: response.data.message,
    //         dismissCountDown: 0
    //       });
    //       _self.viewInvoice(
    //         response.data.generated_inv_id,
    //         _self.pagination.filters.generate_invoice_project
    //       );
    //       _self.getTransaction();
    //       _self.loading = false;
    //     })
    //     .catch(function() {
    //       _self.loading = false;
    //       console.log("FAILURE!!");
    //     });
    // },
    calculateBalance(item) {
      let schedule_value = this.calculateScheduleValue(item);
      let this_period_value = this.calculateTotalCompletedValue(item);
      let balance = schedule_value - this_period_value;
      return balance.toFixed(2);
    },
    calculateRetainage(item) {
      if (
        this.report_details.retainage &&
        this.report_details.retainage_percentage > 0
      ) {
        let calculateTotalCompletedValue = this.calculateTotalCompletedValue(
          item
        );
        let ratainage =
          (calculateTotalCompletedValue *
            this.report_details.retainage_percentage) /
          100;
        return ratainage.toFixed(2);
      } else {
        return "0.00";
      }
    },
    calculateGC(item) {
      let schedule_value = this.calculateScheduleValue(item);
      let total_complated_value = this.calculateTotalCompletedValue(item);
      if (total_complated_value > 0 || schedule_value > 0) {
        let gc = (100 * total_complated_value) / schedule_value;
        return gc.toFixed(2);
      } else {
        return "0.00";
      }
    },
    calculateTotalCompletedValue(item) {
      let total = 0;
      total += parseFloat(this.calculatePreviousValue(item));
      total += parseFloat(this.calculateThisPeriodValue(item));
      return total.toFixed(2);
    },
    calculatePreviousValue(item) {
      let total = parseFloat(item.total_previous_value);
      return total.toFixed(2);
    },
    calculateScheduleValue(item) {
      let total = parseFloat(item.total_schedule_value);
      return total.toFixed(2);
    },
    calculateThisPeriodValue(item) {
      let total = item.total_this_period_value;
      return total.toFixed(2);
    },
    getProjectType() {
      let _self = this;
      if (_self.project_list_filter) {
        const project = this.project_list_filter.find(
          p => p.value === this.pagination.filters.f_project
        );

        _self.selectProjectIsMisc = project?.work_type || null;
        return project?.work_type || null;
      }
    },
    getinvoices() {
      let _self = this;
      this.loading = true;
      let url = parseParams(this.pageData);
      axios
        .get("invoices?" + url)
        .then(response => {
          _self.invoice_data = response.data.data;
          _self.generated_invoices = response.data.generated_invoices;
          _self.report_details = response.data.report_details;
          _self.project_details = response.data.project_details;
          _self.invoice_project_data = response.data.invoice_project_data;
          let project_work = _self.invoice_project_data.project_work;
          _self.pagination.filters.generate_invoice_project_work = project_work;

          // _self.loading = false;
          //get Ungroup Count
          axios
            .get(
              "get_total_of_ungroup_item?project_id=" +
                response.data.project_details.project_id
            )
            .then(response => {
              if (response.data.total > 0) {
                this.is_project_unchecked = true;
              } else {
                this.is_project_unchecked = false;
              }
            });
        })
        .catch(function(error) {
          console.log(error);
          _self.loading = false;
        });
    },
    selectTransaction() {
      if (this.pagination.filters.generate_invoice) {
        if (
          this.selectedRows.length == 1 &&
          !this.pagination.filters.generate_invoice_project
        ) {
          this.last_select_transaction = this.selectedRows[0].trans_id;
          this.pagination.filters.generate_invoice_project = this.selectedRows[0].project_id;
          this.pagination.filters.invoice_project = this.selectedRows[0].project_id;
          this.getinvoices();
        }
      }
      this.updateThisPeriodValue();
    },
    updateThisPeriodValue() {
      setTimeout(() => {
        this.invoice_data.filter(item => {
          item.total_this_period_value = 0;
        });

        for (let i = 0; i < this.selectedRows.length; i++) {
          this.selectedRows[i].project_data_group_id = null;
          if (!this.selectedRows[i].invoice_amt) {
            this.selectedRows[i].invoice_amt = this.getInvoiceAmt(
              this.selectedRows[i]
            );
          }
          for (let k = 0; k < this.invoice_data.length; k++) {
            for (let j = 0; j < this.invoice_data[k].project_data.length; j++) {
              if (
                this.selectedRows[i].vendor_id ==
                this.invoice_data[k].project_data[j].vendor_id
              ) {
                this.selectedRows[i].pro_data_group_id = this.invoice_data[
                  k
                ].pro_data_group_id;
              }
            }
            if (this.invoice_data[k].project_data_group_flag == 6) {
              for (
                let x = 0;
                x < this.invoice_data[k].project_data2.length;
                x++
              ) {
                if (
                  this.selectedRows[i].vendor_id ==
                  this.invoice_data[k].project_data2[x].vendor_id
                ) {
                  this.selectedRows[i].pro_data_group_id = this.invoice_data[
                    k
                  ].pro_data_group_id;
                }
              }
            }
          }
        }

        for (let y = 0; y < this.invoice_data.length; y++) {
          for (let v = 0; v < this.selectedRows.length; v++) {
            if (
              this.selectedRows[v].pro_data_group_id ==
              this.invoice_data[y].pro_data_group_id
            ) {
              this.invoice_data[y].total_this_period_value =
                parseFloat(this.invoice_data[y].total_this_period_value) +
                parseFloat(this.getInvoiceAmt(this.selectedRows[v]));
            }
          }
        }

        this.disable_generate_invoice = false;
        for (let p = 0; p < this.invoice_data.length; p++) {
          var total_complated =
            parseFloat(this.invoice_data[p].total_this_period_value) +
            parseFloat(this.invoice_data[p].total_previous_value);
          if (total_complated > this.invoice_data[p].total_schedule_value) {
            this.disable_generate_invoice = true;
          }
        }
      }, 500);
    },
    getInvoiceGroup(item) {
      //console.log(item)
      let group_name = "";
      for (let k = 0; k < this.invoice_data.length; k++) {
        if (
          item.pro_data_group_id &&
          this.invoice_data[k].pro_data_group_id == item.pro_data_group_id
        ) {
          group_name = this.invoice_data[k].description;
        } else {
          for (let j = 0; j < this.invoice_data[k].project_data.length; j++) {
            if (
              item.vendor_id == this.invoice_data[k].project_data[j].vendor_id
            ) {
              //item.pro_data_group_id = this.invoice_data[k].pro_data_group_id
              group_name = this.invoice_data[k].description;
            }
          }
          if (this.invoice_data[k].project_data_group_flag == 6) {
            for (
              let x = 0;
              x < this.invoice_data[k].project_data2.length;
              x++
            ) {
              if (
                item.vendor_id ==
                this.invoice_data[k].project_data2[x].vendor_id
              ) {
                //item.pro_data_group_id = this.invoice_data[k].pro_data_group_id
                group_name = this.invoice_data[k].description;
              }
            }
          }
        }
      }
      return group_name;
    },
    row_backgroup_color(item) {
      if (item.duplicate || this.pagination.filters.filter_by == "11") {
        return "red lighten-5";
      }
      // else if (item.split_from_id) {
      //   return "grey lighten-2";
      // }
      else if (
        item.invoice_group_id &&
        item.invoice_item_id &&
        item.project &&
        item.project.p_type == "fixed"
      ) {
        return "light-green lighten-5";
      }
      // else if (item.split_from_id) {
      //   return "grey lighten-2";
      // }
      else if (item.invoice_group_id) {
        //  return "orange lighten-5";
        if (item.project && item.project.p_type == "cost_plus") {
          return "light-blue lighten-5";
        }
        if (item.project && item.project.p_type == "fixed") {
          return "orange lighten-5";
        }
      } else {
        return "";
      }
    },
    invoice_row_backgroup_color(item) {
      if (item.project && item.project.p_type == "cost_plus") {
        return "light-blue lighten-5";
      } else {
        return "";
      }
    },
    getLockDate(content_type) {
      this.lock_transaction_data = {
        content_id: null,
        date: null,
        content_type: null
      };
      this.lock_transaction_data.content_type = content_type;
      if (content_type == "bank") {
        this.lock_transaction_data.content_id = this.pagination.filters.bank;
      } else if (content_type == "project") {
        this.lock_transaction_data.content_id = this.pagination.filters.f_project;
      } else if (
        content_type == "vendor" ||
        content_type == "chart_of_account"
      ) {
        this.lock_transaction_data.content_id = this.pagination.filters.f_vendor;
      } else if (content_type == "type") {
        this.lock_transaction_data.content_id = this.pagination.filters.f_type;
      }
      this.lock_transaction_loading = true;
      let _self = this;
      let url = parseParams(this.lock_transaction_data);
      if (this.lock_transaction_data.content_id) {
        axios
          .get("get_lock_transaction_date?" + url)
          .then(response => {
            if (content_type == "bank") {
              _self.bank_date = response.data.data;
            } else if (content_type == "general") {
              _self.general_date = response.data.data;
            } else if (content_type == "project") {
              _self.project_date = response.data.data;
            } else if (
              content_type == "vendor" ||
              content_type == "chart_of_account"
            ) {
              _self.vendor_date = response.data.data;
            } else if (content_type == "type") {
              _self.type_date = response.data.data;
            }
            this.lock_transaction_loading = false;
          })
          .catch(function() {
            this.lock_transaction_loading = false;
          });
      }
    },
    resetTranData() {
      this.single_update_loading = true;
      let item_data = this.items.data.filter(item => {
        return item.trans_id == this.update_transaction.id;
      });
      let item = item_data[0];
      this.update_transaction.trans_type_id = item.trans_type_id;
      this.update_transaction.update_locked_trans = false;
      this.update_transaction.project_id = item.project_id;
      this.update_transaction.vendor_id = item.vendor_id;
      this.update_transaction.expence = item.expence;
      this.update_transaction.item_id = item.item_id;
      this.update_transaction.description = item.description;
      this.dateFormatted = item.trans_date;
      this.parseDate3();
      if (item.rev_amount < 0) {
        this.update_transaction.amount_type = "MINUS";
      } else {
        this.update_transaction.amount_type = "PLUS";
      }
      this.update_transaction.amount = this.getAmountFormat(item.rev_amount);
      this.update_transaction.bank_id = item.bank_id;
      this.single_update_loading = false;
    },
    editRow(item) {
      // this.update_transaction_error = {}
      // this.update_transaction.id = item.trans_id;
      // this.update_transaction.trans_type_id = item.trans_type_id;
      // this.update_transaction.update_locked_trans = false;
      // this.update_transaction.project_id = item.project_id;
      // this.update_transaction.vendor_id = item.vendor_id;
      // this.update_transaction.expence = item.expence;
      // this.update_transaction.item_id = item.item_id;
      // this.update_transaction.description = item.description;
      // this.update_transaction.is_lock_by_current_date =
      //   item.is_lock_by_current_date;
      // this.dateFormatted = item.trans_date;
      // this.parseDate3();
      // if (item.rev_amount < 0) {
      //   this.update_transaction.amount_type = "MINUS";
      // } else {
      //   this.update_transaction.amount_type = "PLUS";
      // }
      // this.update_transaction.amount = this.getAmountFormat(item.rev_amount);
      // this.update_transaction.bank_id = item.bank_id;
      // this.project_selected_status = "1";
      // this.getProjectByStatus();
      this.selected_item = item;
      this.single_update_tran = true;
      //this.openKeywordList(item,false);
    },
    opendEditPopup() {
      // if (this.selectedRows.length == 1) {
      //   console.log(this.selectedRows[0].trans_date);
      //   console.log(this.selectedRows[0].rev_amount);
      //   this.dateFormatted = this.selectedRows[0].trans_date;
      //   this.parseDate2();
      //   if (this.selectedRows[0].rev_amount < 0) {
      //     this.update_data.amount_type = "MINUS";
      //   } else {
      //     this.update_data.amount_type = "PLUS";
      //   }
      //   this.update_data.amount = this.getAmountFormat(
      //     this.selectedRows[0].rev_amount
      //   );
      // }
      // this.update_data.is_lock_by_current_date = 0;
      // this.selectedRows.filter(item => {
      //   if (item.is_lock_by_current_date == 1) {
      //     this.update_data.is_lock_by_current_date = 1;
      //   }
      // });
      // console.log(this.selectedRows);
      // this.project_selected_status = "1";
      // this.getProjectByStatus();
      this.multi_update_tran = true;
    },
    parseDate2() {
      const [year, month, day] = this.dateFormatted.split("-");
      this.update_data.transaction_date = `${month.padStart(
        2,
        "0"
      )}/${day.padStart(2, "0")}/${year}`;
    },
    parseDate3() {
      const [year, month, day] = this.dateFormatted.split("-");
      this.update_transaction.transaction_date = `${month.padStart(
        2,
        "0"
      )}/${day.padStart(2, "0")}/${year}`;
    },
    changeLockDate(content_type, content_id) {
      let dateFormate = null;
      if (this.dateFormatted) {
        const [year, month, day] = this.dateFormatted.split("-");
        dateFormate = `${month.padStart(2, "0")}/${day.padStart(
          2,
          "0"
        )}/${year}`;
      }
      if (content_type == "general") {
        this.general_date = dateFormate;
      } else if (content_type == "bank") {
        this.bank_date = dateFormate;
      } else if (content_type == "project") {
        this.project_date = dateFormate;
      } else if (
        content_type == "vendor" ||
        content_type == "chart_of_account"
      ) {
        this.vendor_date = dateFormate;
      } else if (content_type == "type") {
        this.type_date = dateFormate;
      }
      this.lock_transaction_data.date = dateFormate;
      this.lock_transaction_data.content_type = content_type;
      this.lock_transaction_data.content_id = content_id;
      let _self = this;
      this.lock_transaction_loading = true;
      axios
        .post("update_lock_transaction_date", this.lock_transaction_data)
        .then(function(response) {
          //if(_self.pagination.filters.transaction_type_filter == '5') {
          _self.getTransaction();
          //}
          _self.setAlert({
            show: true,
            variant: "primary",
            message: response.data.message,
            dismissCountDown: 0
          });
          _self.lock_transaction_loading = false;
        })
        .catch(function() {
          _self.lock_transaction_loading = false;
        });
    },
    deleteSelection(remove_selection_flag) {
      this.items.data = this.items.data.map(item => {
        if (item.selected) {
          if (
            remove_selection_flag == "vendor" ||
            remove_selection_flag == "chart of account"
          ) {
            item.expance_details = null;
            item.vendor = null;
            item.vendor_id = null;
          } else if (remove_selection_flag == "project") {
            item.project = null;
            item.project_id = null;
          } else if (remove_selection_flag == "item") {
            item.item_id = null;
          } else if (remove_selection_flag == "type") {
            item.trans_type_id = null;
            item.type = null;
          } else if (remove_selection_flag == "invoice group") {
            item.invoice_group_id = null;
          }
        }
        return item;
      });
    },
    removeSelection() {
      let _self = this;
      this.multi_update_loading = true;
      let ids = [];
      this.selectedRows.map(function(item) {
        ids.push(item.trans_id);
      });
      let company_data = localStorage.getItem("company_data");
      company_data = JSON.parse(company_data);

      axios
        .post("remove_selection", {
          ids: ids,
          flag: this.remove_selection_flag,
          company_id: company_data.company_id
        })
        .then(function(response) {
          //_self.getTransaction();
          _self.setAlert({
            show: true,
            variant: "primary",
            message: response.data.message,
            dismissCountDown: 0
          });
          _self.multi_update_loading = false;
          _self.loading = true;
          _self.items.data = _self.items.data.map(function(item) {
            if (item.selected == true) {
              if (
                _self.remove_selection_flag == "vendor" ||
                _self.remove_selection_flag == "chart of account"
              ) {
                item.vendor_id = null;
              } else if (_self.remove_selection_flag == "project") {
                item.project_id = null;
              } else if (_self.remove_selection_flag == "item") {
                item.item_id = null;
              } else if (_self.remove_selection_flag == "type") {
                item.trans_type_id = null;
              }
            }
            return item;
          });
          _self.loading = false;
        })
        .catch(function() {
          _self.multi_update_loading = false;
        });
    },
    changePage() {
      this.pagination.page = this.move_to_page;
    },
    updateNote() {
      axios
        .post("update_note", this.selectedRows[0])
        .then(function() {})
        .catch(function() {});
    },
    updateSingleTransaction() {
      let _self = this;
      this.single_update_loading = true;
      this.update_transaction_error = {};

      let company_data = localStorage.getItem("company_data");
      company_data = JSON.parse(company_data);
      _self.update_transaction.company_id = company_data.company_id;

      axios
        .post("edit_transaction", this.update_transaction)
        .then(function(response) {
          let data = response.data;
          if (!data.status) {
            for (let key in data.errors) {
              _self.update_transaction_error[key] = data.errors[key][0];
            }
          } else {
            if (response.data.display_success_msg) {
              _self.setAlert({
                show: true,
                variant: "primary",
                message: response.data.message,
                dismissCountDown: 0
              });
            }
            _self.getTransaction();
            _self.single_update_tran = false;
          }
          _self.single_update_loading = false;
        })
        .catch(function() {
          _self.single_update_loading = false;
        });
      this.saveKeywords(false);
    },
    updateTransactions() {
      let _self = this;
      this.multi_update_loading = true;
      let ids = [];
      this.selectedRows.map(function(item) {
        ids.push(item.trans_id);
      });
      this.update_data.ids = ids;

      let company_data = localStorage.getItem("company_data");
      company_data = JSON.parse(company_data);
      this.update_data.company_id = company_data.company_id;
      axios
        .post("update_transactions", this.update_data)
        .then(function(response) {
          if (response.data.lock_tran_count > 0) {
            _self.setAlert({
              show: true,
              variant: "primary",
              message: response.data.message,
              dismissCountDown: 0
            });
          }
          _self.getTransaction();
          _self.resetUpdateTran();
          _self.multi_update_loading = false;
        })
        .catch(function() {
          _self.multi_update_loading = false;
        });
    },
    resetUpdateTran() {
      this.update_data.trans_type_id = null;
      this.update_data.project_id = null;
      this.update_data.update_locked_trans = false;
      this.update_data.vendor_id = null;
      this.update_data.expence = false;
      this.update_data.item_id = null;
      this.update_data.transaction_date = null;
      this.update_data.amount_type = null;
      this.update_data.amount = null;
      this.update_data.bank_id = null;
      this.multi_update_tran = false;
    },
    highlightedDescription(description) {
      if (description && this.search) {
        let string1 = description.toLowerCase();
        let searchStr = this.search;
        let string2 = searchStr.toLowerCase();
        var index = string1.indexOf(string2);
        if (index >= 0) {
          description =
            description.substring(0, index) +
            "<span class='yellow'>" +
            description.substring(index, index + this.search.length) +
            "</span>" +
            description.substring(index + this.search.length);
          return description;
        } else {
          return description;
        }
      } else {
        return description;
      }
    },
    changeSelectAll() {
      let _self = this;
      if (this.select_all_checkbox) {
        this.updateThisPeriodValue();
        this.items.data = this.items.data.map(function(item) {
          if (
            (_self.pagination.filters.filter_by == "10" &&
              item.duplicate == "0") ||
            (_self.pagination.filters.filter_by == "12" &&
              item.is_lock_by_current_date == "1") ||
            (_self.pagination.filters.generate_invoice == true &&
              ((item.project.p_type == "fixed" && !item.invoice_group) ||
                item.invoice_item_id == null) &&
              item.project.p_type == "cost_plus" &&
              !item.invoice_group)
          ) {
            item.selected = false;
          } else {
            item.selected = true;
          }
          return item;
        });
      } else {
        this.items.data = this.items.data.map(function(item) {
          item.selected = false;
          return item;
        });
      }
    },
    resetFilter() {
      this.loading = true;
      this.search = "";
      this.pagination.itemsPerPage = 25;
      this.pagination.filters.p_tagged = false;
      this.pagination.filters.tagged = false;
      this.pagination.filters.p_invoice = false;
      this.pagination.filters.f_project = "";
      this.pagination.filters.f_vendor = "";
      this.pagination.filters.f_type = "";
      this.pagination.filters.f_group = "";
      this.pagination.filters.f_item = "";
      this.pagination.filters.f_project_status = "";
      this.pagination.filters.f_vendor_status = "";
      this.pagination.filters.f_group_status = "1";
      this.pagination.filters.bank_status = "";
      this.pagination.filters.amt_filter_by = "1";
      this.pagination.filters.bank = "";
      this.pagination.filters.filter_by = "1";
      this.pagination.filters.tran_start_date = "";
      this.pagination.filters.date_filter = "";
      this.pagination.filters.tran_end_date = "";
      this.pagination.filters.outstanding = false;
      this.pagination.filters.split_patent_id = "";
      this.pagination.filters.sales_income_invoice_id = "";
      this.exact_amount = "";
      this.amount_from = "";
      this.amount_to = "";
      this.split_patent_id = "";
      this.sales_income_invoice_id = "";
      this.getTransaction();
      this.loading = false;
    },
    parseDate(key) {
      if (key == "tran_start_date") {
        if (this.dateFormatted) {
          this.disable_dates = this.dateFormatted;
        } else {
          this.disable_dates = null;
        }
      }
      const [year, month, day] = this.dateFormatted.split("-");
      this.pagination.filters[key] = `${month.padStart(2, "0")}/${day.padStart(
        2,
        "0"
      )}/${year}`;
    },

    addProject() {
      this.$router.push({ path: "/projects" });
    },
    addVendor() {
      this.$router.push({ path: "/vendors" });
    },
    addExpence() {
      this.$router.push({ path: "/accounts" });
    },
    addItem() {
      this.$router.push({ path: "/items" });
    },
    getFormatedDate(date) {
      return moment(date).format("MM/DD/YY");
    },
    splitTransaction() {
      this.split_dailog = true;

      if (this.selectedRows[0].parent_id > 0) {
        let select_item_data = this.items.data.filter(item => {
          return item.trans_id == this.selectedRows[0].parent_id;
        });
        this.main_amount = select_item_data[0].rev_amount;
      } else {
        this.main_amount = null;
      }
      this.split_project_id = this.selectedRows[0].project_id;
      this.split_vendor_id = this.selectedRows[0].vendor_id;
      this.expence = this.selectedRows[0].expence;
    },
    expandRow(itemData) {
      if (itemData.value) {
        this.items.data = this.items.data.map(function(item) {
          if (item.trans_id == itemData.item.trans_id) {
            item.selected = true;
          }
          return item;
        });
      }
    },
    getAmountFormat(value) {
      if (value) {
        return value.replace("-", "");
      } else {
        return 0;
      }
    },
    updateFile() {
      let _self = this;
      _self.imported_columns = [];
      _self.date_columns = [];
      _self.description_columns = [];
      _self.amount_columns = [];
      try {
        let formData = new FormData();
        formData.append("csv_file", this.selected_file);
        axios
          .post("parse_csv", formData, {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          })
          .then(function(response) {
            if (response.data.status) {
              let data = response.data;

              _self.imported_columns = [];
              _self.date_columns = [];
              _self.description_columns = [];
              _self.amount_columns = [];

              // Populate dropdown lists
              for (let key in data.data) {
                _self.imported_columns.push(data.data[key]);
              }
              for (let key in data.date_fields) {
                _self.date_columns.push(data.date_fields[key]);
              }
              for (let key in data.description_fields) {
                _self.description_columns.push(data.description_fields[key]);
              }
              for (let key in data.amount_fields) {
                _self.amount_columns.push(data.amount_fields[key]);
              }

              // Set values into db_column based on field type
              _self.$set(
                _self.db_column[0],
                "value",
                _self.findValueByText(
                  _self.date_columns,
                  _self.bank_statistic.transaction_date
                )
              );

              _self.$set(
                _self.db_column[1],
                "value",
                _self.findValueByText(
                  _self.description_columns,
                  _self.bank_statistic.description
                )
              );

              _self.$set(
                _self.db_column[2],
                "value",
                _self.findValueByText(
                  _self.amount_columns,
                  _self.bank_statistic.credit_amount
                )
              );

              _self.$set(
                _self.db_column[3],
                "value",
                _self.findValueByText(
                  _self.amount_columns,
                  _self.bank_statistic.debit_amount
                )
              );
              _self.$set(
                _self.credit_type,
                "value",
                _self.bank_statistic.credit_type
              );
              _self.$set(
                _self.debit_type,
                "value",
                _self.bank_statistic.debit_type
              );
            }
          });
      } catch (e) {
        console.log(e);
      }
    },

    findValueByText(list, label) {
      const match = list.find(item => item.text === label);
      console.log(list, label, "list");
      return match ? match.value : null;
    },
    importData() {
      let _self = this;
      this.import_dailog_loading = "accent";

      // Reset error messages
      this.db_column = this.db_column.map(item => {
        item.error = null;
        return item;
      });

      // Helper to get selected value from db_column based on field name
      const getFieldValue = field => {
        const found = _self.db_column.find(item => item.field === field);
        return found ? found.value : null;
      };

      // Helper to get label (text) from dropdown list by value
      const findTextByValue = (list, value) => {
        const match = list.find(item => item.value === value);
        return match ? match.text : null;
      };

      // Prepare form data
      let formData = new FormData();
      formData.append("csv_file", this.selected_file);
      formData.append("bank_id", this.selected_bank);
      formData.append("mapping", JSON.stringify(this.db_column));
      formData.append("credit_type", this.credit_type);
      formData.append("debit_type", this.debit_type);

      // Append mapped field labels instead of index values
      formData.append(
        "transaction_date",
        findTextByValue(this.date_columns, getFieldValue("trans_date"))
      );
      formData.append(
        "description",
        findTextByValue(this.description_columns, getFieldValue("description"))
      );
      formData.append(
        "credit_amount",
        findTextByValue(this.amount_columns, getFieldValue("amount"))
      );
      formData.append(
        "debit_amount",
        findTextByValue(this.amount_columns, getFieldValue("amount2"))
      );

      // Optional debug log
      for (let [key, val] of formData.entries()) {
        console.log(`${key}: ${val}`);
      }

      // Send API request
      axios
        .post("import_transaction", formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(function(response) {
          if (response.data.status) {
            _self.getTransaction();
            _self.import_dailog_loading = false;
            _self.import_dailog = false;

            _self.setAlert({
              show: true,
              variant: "primary",
              message: response.data.message,
              dismissCountDown: 0
            });
          } else {
            for (let key in response.data.errors) {
              let obj = _self.db_column.find(
                o => o.field === response.data.errors[key].field
              );
              if (obj) {
                obj.error = response.data.errors[key].message;
              }
            }
            _self.import_dailog_loading = false;
          }
        })
        .catch(function(err) {
          console.error("FAILURE!!", err);
          _self.import_dailog_loading = false;
        });
    },
    deleteTransactions() {
      this.loading = true;
      let _self = this;
      let ids = [];

      let company_data = localStorage.getItem("company_data");
      company_data = JSON.parse(company_data);

      this.selectedRows.map(function(item) {
        ids.push(item.trans_id);
      });
      axios
        .post("delete_transaction", {
          ids: ids,
          company_id: company_data.company_id
        })
        .then(function(response) {
          _self.getTransaction();
          _self.setAlert({
            show: true,
            variant: "primary",
            message: response.data.message,
            dismissCountDown: 0
          });
          _self.loading = false;
        })
        .catch(function() {
          _self.loading = false;
          console.log("FAILURE!!");
        });
    },
    deleteMiscAssignTransactions() {
      this.loading = true;
      let _self = this;
      let ids = [];

      let company_data = localStorage.getItem("company_data");
      company_data = JSON.parse(company_data);

      this.selectedRows.map(function(item) {
        ids.push(item.trans_id);
      });
      axios
        .post("delete_misc_assignment_transaction", {
          ids: ids,
          company_id: company_data.company_id
        })
        .then(function(response) {
          _self.getTransaction();
          _self.setAlert({
            show: true,
            variant: "primary",
            message: response.data.message,
            dismissCountDown: 0
          });
          _self.loading = false;
        })
        .catch(function() {
          _self.loading = false;
          console.log("FAILURE!!");
        });
    },
    addAsMainTransaction() {
      this.loading = true;
      let _self = this;
      let ids = [];
      this.selectedRows.map(function(item) {
        ids.push(item.trans_id);
      });
      axios
        .post("add_duplicate_transaction", {
          ids: ids,
          filter_type: this.pagination.filters.filter_by
        })
        .then(function(response) {
          _self.getTransaction();
          _self.setAlert({
            show: true,
            variant: "primary",
            message: response.data.message,
            dismissCountDown: 0
          });
          _self.loading = false;
        })
        .catch(function() {
          _self.loading = false;
          console.log("FAILURE!!");
        });
    },
    splitBill() {
      let _self = this;
      let sData = {};
      this.split_dailog_loading = "accent";
      this.selectedRows.map(function(item) {
        sData.trans_id = item.trans_id;
      });
      sData.amount = _self.split_amount;
      sData.project_id = _self.split_project_id;
      sData.vendor_id = _self.split_vendor_id;
      sData.expence = _self.split_expence;
      axios
        .post("split_transaction", sData)
        .then(function(response) {
          if (response.data.status) {
            _self.getTransaction();
            _self.split_dailog = false;
            _self.setAlert({
              show: true,
              variant: "primary",
              message: response.data.message,
              dismissCountDown: 0
            });
          } else {
            for (let key in response.data.errors) {
              _self.split_amount_error = response.data.errors[key][0];
            }
          }
          _self.split_dailog_loading = false;
        })
        .catch(function() {
          console.log("FAILURE!!");
          _self.split_dailog_loading = false;
        });
    },
    addProjectVendor() {
      this.loading = true;
      let _self = this;
      axios
        .post("auto_fill_project_vendor")
        .then(function(response) {
          _self.getTransaction();
          //_self.getTransactionSelectors();
          _self.setAlert({
            show: true,
            variant: "primary",
            message: response.data.message,
            dismissCountDown: 0
          });
          _self.loading = false;
        })
        .catch(function() {
          console.log("FAILURE!!");
          _self.loading = false;
        });
    },
    // deleteInvoices() {
    //   this.loading = true;
    //   let _self = this;
    //   let ids = [];
    //   this.hasInvoices.map(function(item) {
    //     ids.push(item.generated_inv_id);
    //   });
    //   axios
    //     .post("delete_invoice", {
    //       ids: ids
    //     })
    //     .then(function(response) {
    //       _self.getTransaction();
    //       _self.setAlert({
    //         show: true,
    //         variant: "primary",
    //         message: response.data.message,
    //         dismissCountDown: 0
    //       });
    //       _self.loading = false;
    //     })
    //     .catch(function() {
    //       _self.loading = false;
    //       console.log("FAILURE!!");
    //     })
    //     .then(() => {
    //       this.delete_invoice_dialog = false;
    //     });
    // },
    // generateInvoices() {
    //   this.loading = true;
    //   let _self = this;
    //   let ids = [];
    //   this.selectedRows.map(function(item) {
    //     ids.push(item.trans_id);
    //   });
    //   axios
    //     .post("generate_invoice", {
    //       ids: ids
    //     })
    //     .then(function(response) {
    //       _self.pagination.filters.generate_invoice = false;
    //       //_self.getTransaction();
    //       _self.setAlert({
    //         show: true,
    //         variant: "primary",
    //         message: response.data.message,
    //         dismissCountDown: 0
    //       });
    //       _self.loading = false;
    //     })
    //     .catch(function() {
    //       _self.loading = false;
    //       console.log("FAILURE!!");
    //     });
    // },
    ChangeStartdate() {
      this.pagination.filters.date_filter = "8";
      this.pagination.filters.tran_start_date = this.change_start_date;
      this.pagination.filters.tran_end_date = this.change_end_date;
      this.getTransaction(false);
      this.confirm_date_dialog = false;
    },
    CloseOpeningDialog() {
      this.pagination.filters.date_filter = "";
      this.pagination.filters.tran_start_date = "";
      this.pagination.filters.tran_end_date = "";
      this.confirm_date_dialog = false;
    },
    getTransaction() {
      let _self = this;

      this.pageData.filters.expence_filter_flag = this.expence_filter_flag;
      this.pageData.filters.split_patent_id = _self.split_patent_id;
      this.pageData.filters.sales_income_invoice_id =
        _self.sales_income_invoice_id;
      if (this.pageData.itemsPerPage == "All") {
        this.pageData.itemsPerPage = -1;
      }
      let url = parseParams(this.pageData);
      if (
        this.pagination.filters.filter_by == 6 &&
        !this.pagination.filters.generate_invoice
      ) {
        if (this.set_date_default == true) {
          this.pagination.filters.date_filter = "";
        }

        _self.items.data = [];
        this.cancelSearch();
        this.cancelSource = axios.CancelToken.source();
        _self.loading = true;
        axios
          .get("get_invoice_list?" + url, {
            cancelToken: this.cancelSource.token
          })
          .then(response => {
            if (_self.items.total != response.data.data.total) {
              _self.pagination.page = 1;
            }
            // setTimeout(() => {
            _self.items = response.data.data;
            _self.total_amt_of_invoice = response.data.total_invoice_amt;
            _self.total_received_amt = response.data.total_received_amt;
            _self.total_balance_due = response.data.total_balance_due;
            _self.project_list_filter = response.data.projects;
            // }, 100);

            if (_self.pagination.filters.f_project) {
              let set_blank_project = "yes";
              _self.project_list_filter.map(item => {
                if (item.value == _self.pagination.filters.f_project) {
                  set_blank_project = "no";
                }
              });
              if (set_blank_project == "yes") {
                _self.pagination.filters.f_project = "";
              }
            }
            _self.loading = false;
          })
          .catch(function(error) {
            console.log(error);
            // _self.loading = false;
          });
      } else {
        if (
          this.pagination.filters.date_filter != "undefined" &&
          this.pagination.filters.date_filter != undefined &&
          this.pagination.filters.date_filter != "" &&
          (this.pagination.filters.bank != "" ||
            this.pagination.filters.f_vendor != "")
        ) {
          this.getTransactinFinalDate(url);
          // axios.get("get_out_of_date_data?page_list=transaction&" + url).then((response) => {
          //    console.log(response.data.total);
          //     if(response.data.total>0){
          //       _self.outofdate_bank_list.data=response.data.data;
          //       _self.confirm_date_dialog=true;
          //       _self.change_start_date=response.data.start_date;
          //       _self.change_end_date=response.data.end_date;
          //       _self.actual_start_date=response.data.actual_start_date;
          //     }else{
          //       this.getTransactinFinalDate(url);
          //     }
          //     }).catch(function () {
          //         _self.loading = false;
          //     });
        } else {
          if (this.pagination.filters.date_filter == 8) {
            if (
              this.pagination.filters.tran_start_date != "" &&
              this.pagination.filters.tran_start_date != null &&
              this.pagination.filters.tran_start_date != "null" &&
              this.pagination.filters.tran_end_date != "" &&
              this.pagination.filters.tran_end_date != null &&
              this.pagination.filters.tran_end_date != "null"
            ) {
              this.getTransactinFinalDate(url);
            }
          } else {
            this.getTransactinFinalDate(url);
          }
        }
      }
      this.set_date_default == false;
    },
    cancelSearch() {
      if (this.cancelSource) {
        this.cancelSource.cancel("Start new search, stop active search");
        // console.log('cancel request done');
      }
    },
    getTransactinFinalDate(url) {
      let _self = this;
      _self.loading = true;
      this.cancelSearch();
      this.cancelSource = axios.CancelToken.source();
      axios
        .get("transactions?" + url, { cancelToken: this.cancelSource.token })
        .then(response => {
          if (_self.items.total != response.data.data.total) {
            _self.pagination.page = 1;
          }
          _self.items = response.data.data;
          _self.transaction_balance = response.data.balance;
          _self.credit = response.data.credit_balance;
          _self.debit = response.data.debit_balance;
          _self.account_balance = response.data.account_balance;
          _self.filter_balance = response.data.filter_balance;
          _self.opending_balance = response.data.opending_balance;
          _self.total_invoice_amt = response.data.total_invoice_amt;
          _self.filter_start_date = response.data.start_date;
          _self.filter_start_end = response.data.end_date;
          _self.select_all_checkbox = false;
          if (
            _self.pagination.filters.generate_invoice &&
            _self.last_select_transaction
          ) {
            _self.items.data.filter(item => {
              if (item.trans_id == _self.last_select_transaction) {
                item.selected = true;
              }
            });
          }
          if (
            _self.pagination.filters.generate_invoice &&
            _self.pagination.filters.generated_inv_id
          ) {
            _self.items.data.filter(item => {
              if (
                item.generated_inv_id ==
                _self.pagination.filters.generated_inv_id
              ) {
                item.selected = true;
              }
            });
            _self.updateThisPeriodValue();
          }
          if (response.data.data.total > 0) {
            _self.getTransactionSelectorsFilterOnly();
          } else {
            _self.loading = false;
          }

          // _self.getTransactionSelectors();

          // setTimeout(() => {
          //   _self.loading = false;
          // }, 1000);
        })
        .catch(function(error) {
          console.log(error);
          _self.loading = false;
        });
    },
    changeVendorExpence(flag, trans_id) {
      this.loading = true;
      //this.items.data[index].expence = flag
      this.items.data = this.items.data.map(function(item) {
        if (item.trans_id == trans_id) {
          item.expence = flag;
        }
        return item;
      });
      document.querySelectorAll(".focus-" + trans_id + " input")[0].focus();
      this.loading = false;
    },
    setFocus(className) {
      document.querySelectorAll("." + className + " input")[0].focus();
    },
    getProjectByStatus() {
      let _self = this;
      this.loading = true;
      axios
        .get("get_project_by_status?status=" + this.project_selected_status)
        .then(response => {
          if (response.data.status) {
            _self.project_of_selected_status = response.data.data;
          }
          _self.loading = false;
        })
        .catch(function() {
          _self.loading = false;
        });
    },
    getTransactionSelectorsFilterOnly() {
      let _self = this;
      this.pageData.filters.expence_filter_flag = this.expence_filter_flag;
      let url = parseParams(this.pageData);
      _self.loading = true;
      axios
        .get("transactions_selectors?" + url + "&get_filter=true")
        .then(response => {
          if (response.data.status) {
            // _self.project_list = response.data.data.projects;
            _self.project_list_filter = response.data.data.projects2;
            console.log(_self.project_list_filter, "aaa");

            // _self.group_list = response.data.data.group;
            _self.group_list_filter = response.data.data.group2;

            // _self.item_list = response.data.data.items;
            // _self.item_list.unshift({ text: "", value: "" });
            // _self.vendor_list = response.data.data.vendors;
            _self.vendor_list_filter = response.data.data.vendors2;

            // _self.expence_list = response.data.data.expences;
            _self.expence_list_filter = response.data.data.expences2;

            // _self.trans_type_list = response.data.data.trans_types;
            _self.trans_type_list_filter = response.data.data.trans_types2;
            _self.trans_type_list.unshift({ text: "", value: "" });

            _self.bank_filter = response.data.data.banks2;
            // _self.banks = response.data.data.banks;
            // _self.active_banks = response.data.data.active_banks;
            if (_self.pagination.filters.f_project) {
              let set_blank_project = "yes";
              _self.project_list_filter.map(item => {
                if (item.value == _self.pagination.filters.f_project) {
                  set_blank_project = "no";
                }
              });
              if (set_blank_project == "yes") {
                _self.pagination.filters.f_project = "";
              }
            }

            if (_self.pagination.filters.f_type) {
              let set_blank_type = "yes";
              _self.trans_type_list_filter.map(item => {
                if (item.value == _self.pagination.filters.f_type) {
                  set_blank_type = "no";
                }
              });
              if (set_blank_type == "yes") {
                _self.pagination.filters.f_type = "";
              }
            }

            if (_self.pagination.filters.bank) {
              let set_blank_bank = "yes";
              _self.bank_filter.map(item => {
                if (item.value == _self.pagination.filters.bank) {
                  set_blank_bank = "no";
                }
              });
              if (set_blank_bank == "yes") {
                _self.pagination.filters.bank = "";
              }
            }

            if (_self.pagination.filters.f_vendor) {
              let set_blank_vendor = "yes";
              if (_self.expence_filter_flag) {
                _self.expence_list_filter.map(item => {
                  if (item.value == _self.pagination.filters.f_vendor) {
                    set_blank_vendor = "no";
                  }
                });
              } else {
                _self.vendor_list_filter.map(item => {
                  if (item.value == _self.pagination.filters.f_vendor) {
                    set_blank_vendor = "no";
                  }
                });
              }
              if (set_blank_vendor == "yes") {
                _self.pagination.filters.f_vendor = "";
              }
            }
          }
          // _self.last_select_transaction = "";
          _self.loading = false;
        })
        .catch(function() {
          _self.loading = false;
        });
    },
    getTransactionSelectors() {
      let _self = this;
      this.pageData.filters.expence_filter_flag = this.expence_filter_flag;
      let url = parseParams(this.pageData);
      // _self.loading = true;
      axios
        .get("transactions_selectors?" + url + "&get_filter=false")
        .then(response => {
          if (response.data.status) {
            _self.project_list = response.data.data.projects;
            // _self.project_list_filter = response.data.data.projects2;

            _self.group_list = response.data.data.group;
            // _self.group_list_filter = response.data.data.group2;

            _self.item_list = response.data.data.items;
            _self.item_list.unshift({ text: "", value: "" });
            _self.vendor_list = response.data.data.vendors;
            // _self.vendor_list_filter = response.data.data.vendors2;

            _self.expence_list = response.data.data.expences;
            // _self.expence_list_filter = response.data.data.expences2;

            _self.trans_type_list = response.data.data.trans_types;
            // _self.trans_type_list_filter = response.data.data.trans_types2;
            _self.trans_type_list.unshift({ text: "", value: "" });

            // _self.bank_filter = response.data.data.banks2;
            _self.banks = response.data.data.banks;
            _self.active_banks = response.data.data.active_banks;
          }
          _self.last_select_transaction = "";
          // _self.loading = false;
        })
        .catch(function() {
          _self.loading = false;
        });
    },
    updateTransaction(item) {
      let _self = this;
      this.inline_save_loading = "accent";
      this.inline_from_error = {};

      let company_data = localStorage.getItem("company_data");
      company_data = JSON.parse(company_data);
      _self.item.company_id = company_data.company_id;

      axios
        .post("edit_transaction", item)
        .then(res => {
          let data = res.data;
          if (!data.status) {
            for (let key in data.errors) {
              _self.inline_from_error[key] = data.errors[key][0];
            }
          } else {
            _self.expanded = [];
            _self.getTransactionSelectorsFilterOnly();
            // _self.getTransactionSelectors();
          }
        })
        .catch(function() {})
        .then(() => {
          _self.inline_save_loading = false;
        });
    },
    openUploader(item) {
      this.setModal(true);
      this.setDocumentData({ key: "type", value: 1 });
      this.setDocumentData({ key: "o_id", value: item.trans_id });
      this.setDocumentData({ key: "items", value: this.items });
      this.setDocumentData({ key: "item", value: item });
    },
    openDocList(item) {
      this.setDocumentData({ key: "doc_list_modal", value: true });
      this.setDocumentData({ key: "type", value: 1 });
      this.setDocumentData({ key: "o_id", value: item.trans_id });
      this.setDocumentData({ key: "item", value: item });
      this.setDocumentData({ key: "main_task_id", value: "0" });
      this.setDocumentData({ key: "child_task_id", value: "0" });
      this.setDocumentData({ key: "form_name", value: "Transaction" });
      this.setDocumentData({ key: "item_name", value: "" });
      this.setDocumentData({ key: "job_name", value: "" });
      this.setDocumentData({ key: "user_name", value: "" });
      this.setDocumentData({ key: "customer_name", value: "" });
      this.setDocumentData({ key: "doc_module", value: "TRANSACTION" });
      this.setDocumentData({ key: "is_vendor", value: !item.expence });
      this.setDocumentData({
        key: "is_chart_of_account",
        value: item.expence
      });
      if (item.bank) {
        this.setDocumentData({ key: "bank_name", value: item.bank.bank_name });
      } else {
        this.setDocumentData({ key: "bank_name", value: "" });
      }
      if (item.project) {
        this.setDocumentData({
          key: "project_name",
          value: item.project.p_name
        });
      } else {
        this.setDocumentData({ key: "project_name", value: "" });
      }
      if (item.vendor) {
        this.setDocumentData({ key: "vendor_name", value: item.vendor.v_name });
      } else {
        this.setDocumentData({ key: "vendor_name", value: "" });
      }
      if (item.expence) {
        this.setDocumentData({
          key: "chart_of_account_name",
          value: item.expance_details.bank_name
        });
      } else {
        this.setDocumentData({ key: "chart_of_account_name", value: "" });
      }
    },
    openLogList(item) {
      this.setLogData({ key: "log_list_modal", value: true });
      this.setLogData({ key: "type", value: 1 });
      this.setLogData({ key: "o_id", value: item.trans_id });
      this.setLogData({ key: "item", value: item });

      this.setLogData({ key: "form_name", value: "Transaction" });
      this.setLogData({ key: "item_name", value: "" });
      this.setLogData({ key: "job_name", value: "" });
      this.setLogData({ key: "user_name", value: "" });
      this.setLogData({ key: "customer_name", value: "" });
      if (item.bank) {
        this.setLogData({ key: "bank_name", value: item.bank.bank_name });
      } else {
        this.setLogData({ key: "bank_name", value: "" });
      }
      if (item.project) {
        this.setLogData({ key: "project_name", value: item.project.p_name });
      } else {
        this.setLogData({ key: "project_name", value: "" });
      }
      if (item.vendor) {
        this.setLogData({ key: "vendor_name", value: item.vendor.v_name });
      } else {
        this.setLogData({ key: "vendor_name", value: "" });
      }
    },
    getProject(projectId) {
      let proj = this.project_list.filter(function(project) {
        return project.value == projectId;
      });
      if (proj.length) {
        return proj[0].text;
      }
    },
    getBankStatistics() {
      let _self = this;
      this.import_dailog_loading = "accent";
      axios
        .get("get_bank_stats?bank_id=" + _self.selected_bank)
        .then(data => {
          let res = data.data;
          if (res.status) {
            _self.bank_statistic = res.data;
          }
        })
        .then(() => {
          _self.import_dailog_loading = false;
        });
    },
    openKeywordList(item, open_dialog_flag) {
      let _self = this;
      this.keywords.dialog = open_dialog_flag;
      this.keywords.item = item;
      this.keywords.loading = "accent";
      axios.get("get_keywords?" + parseParams(item)).then(function(res) {
        let data = res.data;
        if (data.status && data.data.keywords) {
          _self.keywords.vendors = data.data.keywords.vendor;
          _self.keywords.expences = data.data.keywords.expence;
          _self.keywords.project = data.data.keywords.project;
          _self.keywords.invoice_group = data.data.keywords.invoice_group;
          _self.keywords.type = data.data.keywords.type;
          _self.keywords.info = data.data.keywords.info;
        }
        _self.keywords.loading = false;
      });
    },
    saveKeywords(display_msg_flag) {
      let _self = this;
      this.keywords.loading = "accent";
      setTimeout(function() {
        axios.post("set_keywords", _self.keywords).then(function(res) {
          let data = res.data;
          if (data.status) {
            _self.keywords.dialog = false;
            if (display_msg_flag) {
              _self.setAlert({
                show: true,
                variant: "primary",
                message: data.message,
                dismissCountDown: 0
              });
            }
            _self.keywords.item = null;
            _self.keywords.vendors = [];
            _self.keywords.expences = [];
            _self.keywords.project = [];
            _self.keywords.invoice_group = [];
            _self.keywords.type = [];
            _self.keywords.info = {};
          }
          _self.keywords.loading = false;
        });
      }, 1000);
    },
    getSelectedTitle(dId) {
      let type = this.grouped.type;
      if (type == "bank_id") {
        try {
          return this.banks.filter(bank => {
            return bank.bank_id == dId;
          })[0].bank_name;
        } catch (e) {
          return "";
        }
      }
      if (type == "vendor_id") {
        try {
          return this.vendor_list.filter(vendor => {
            return vendor.value == dId;
          })[0].text;
        } catch (e) {
          return "";
        }
      }
      if (type == "project_id") {
        try {
          return this.project_list.filter(project => {
            return project.value == dId;
          })[0].text;
        } catch (e) {
          return "";
        }
      }
    },
    hasChild(item_e) {
      return this.items.data.filter(item => {
        return item.parent_id == item_e.trans_id;
      }).length;
    },
    getRandomColor(item, index) {
      let colors = [
        "blue lighten-5",
        "green lighten-5",
        "indigo lighten-5",
        "purple lighten-5",
        "orange lighten-5",
        "brown lighten-5",
        "deep-orange lighten-5"
      ];
      let trans_code = item.trans_code;
      trans_code = trans_code.split(".");
      if (!(trans_code[0] in this.colors_selected)) {
        this.colors_selected[trans_code[0]] =
          colors[Math.floor(Math.random() * colors.length)];
      }
      if (this.hasChild(item) > 0) {
        this.items.data[index].class = this.colors_selected[trans_code[0]];
      }
      return this.colors_selected[trans_code[0]];
    },
    updateDebouceTransaction() {
      this.updateNote();
    },
    getReportTexts() {
      let _self = this;
      this.loading = true;
      axios
        .get("get_report_texts")
        .then(function(res) {
          _self.report_texts = res.data.data;
          _self.loading = false;
        })
        .then(function() {
          _self.loading = false;
        });
    },
    downloadSampleExcel() {
      var File_url = process.env.VUE_APP_URL + "/storage/app/public/import.csv";
      window.open(File_url);
    },

    logout() {
      logout(this.$router);
    }
  },
  mounted: function() {
    //let _self = this;
    this.getTransactionSelectors();
    // axios.get("banks").then((response) => {
    //   _self.banks = response.data;
    // });

    if (localStorage.getItem("is_from_project") == "true") {
      if (localStorage.getItem("redirect_to") == "transaction") {
        this.pagination.filters.filter_by = "4";
        this.pagination.filters.f_project = parseInt(
          localStorage.getItem("co_project_id")
        );
        this.pagination.filters.f_group = parseInt(
          localStorage.getItem("co_group_id")
        );
        this.pagination.filters.f_item = parseInt(
          localStorage.getItem("co_item_id")
        );
        this.pagination.filters.f_co = parseInt(
          localStorage.getItem("co_co_id")
        );
      } else if (localStorage.getItem("redirect_to") == "transaction_income") {
        this.pagination.filters.filter_by = "2";
        this.pagination.filters.f_project = parseInt(
          localStorage.getItem("co_project_id")
        );
        this.pagination.filters.amt_filter_by = "2";
        this.expence_filter_flag = true;
        this.pagination.filters.expence_filter_flag = true;
        this.pagination.filters.f_vendor = 35;
      } else {
        this.pagination.filters.filter_by = "6";
        this.pagination.filters.f_project_status = "1";
        this.pagination.filters.f_project = parseInt(
          localStorage.getItem("co_project_id")
        );
        this.pagination.filters.f_group = parseInt(
          localStorage.getItem("co_group_id")
        );
        this.pagination.filters.f_co = parseInt(
          localStorage.getItem("co_co_id")
        );
      }
    }
    if (localStorage.getItem("is_from_dashboard") == "true") {
      this.pagination.filters.filter_by = "6";
      this.pagination.filters.f_project_status = "1";
      if (localStorage.getItem("co_project_id")) {
        this.pagination.filters.f_project = parseInt(
          localStorage.getItem("co_project_id")
        );
      }
    }
    this.getTransaction();
    this.getLockDate("general");
    this.getReportTexts();
    this.getProjectByStatus();
    this.cred;
  }
};
</script>
<style scoped>
.right-border-grey > td {
  border-right: thin solid rgba(0, 0, 0, 0.12);
}
.right-border-white > td {
  border-right: thin solid white;
}
ul li {
  list-style-type: none;
  &:before {
    content: "• ";
    margin-left: -1em;
  }
}
.white_box .v-icon {
  color: #ffffff !important;
}
.v-sheet.v-list {
  min-width: 70px !important;
}
</style>
